var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import englishTranslation from "./en";
var galegoTranslation = {
    translations: {
        configurationPackage: englishTranslation.translations.configurationPackage,
        ballotPrivacy: englishTranslation.translations.ballotPrivacy,
        readiness: {
            close: "Pechar",
            action: "Verificar preparación",
            title: "Preparación electoral",
            description: "Compare este evento oficial cun ensaio finalizado. Se a verificación é satisfactoria, rexístrase evidencia asinada no rexistro do evento oficial.",
            testedEvent: "Evento probado",
            archived: "Arquivado",
            noEvents: "Non hai outros eventos dispoñibles",
            retry: "Tentar de novo",
            eventsError: "Non se puideron cargar os eventos.",
            run: "Executar verificación",
            running: "Verificando preparación…",
            error: "Non se puido completar a verificación. Revise o rexistro antes de tentalo de novo; a resposta pode terse perdido tras rexistrar a evidencia.",
            downloadError: "Non se puido descargar o informe. Ténteo de novo.",
            success: "Preparación verificada. Rexistrouse evidencia asinada no rexistro do evento oficial.",
            failed: "A preparación fallou. Resolva as comprobacións fallidas e repita. Non se rexistrou ningunha entrada de preparación.",
            download: "Descargar informe JSON",
            snapshot: "Este informe é unha instantánea. Repita tras cambios relevantes; non bloquea o evento nin substitúe a aprobación operativa.",
            results: "Resultados da verificación",
            condition: "Condición comprobada polo servidor",
            noDetail: "O servidor non deu máis detalle sobre esta comprobación.",
            reasons: "Por que fallou",
            noArea: "ningunha área ou unha área descoñecida",
            eventRoles: {
                official: "oficial",
                tested: "de proba",
                both: "ambos",
            },
            scope: {
                event: "O evento {{event}}",
                election: "A elección {{election}}",
            },
            certification: {
                declared_sha256_missing: "non se indicou o SHA-256",
                declared_sha256_mismatch: "o SHA-256 indicado non coincide co do ficheiro",
                no_counts: "non ten votantes por área",
                blank_area: "hai votantes sen área",
                invalid_sha256: "o seu SHA-256 non é válido",
            },
            findings: {
                same_event: "O evento oficial e o de proba son o mesmo evento.",
                configuration_missing: "O evento {{event}} non se importou desde un paquete de configuración asinado.",
                configuration_incomplete: "A configuración asinada do evento oficial non ten un valor válido para «{{field}}».",
                external_id_mismatch: "Os eventos proceden de configuracións distintas: {{official}} (oficial) e {{tested}} (de proba).",
                content_mismatch: "O contido asinado é distinto: SHA-256 {{official}} (oficial) e {{tested}} (de proba).",
                approvers_mismatch: "Os aprobadores verificados son distintos: {{only_official}} só no evento oficial e {{only_tested}} só no de proba.",
                areas_mismatch: "{{area}} só está no contido asinado do evento {{event}}.",
                voter_import_missing: "O evento {{event}} non ten unha importación certificada de votantes.",
                voter_import_in_progress: "Aínda hai unha importación de votantes en curso no evento {{event}}.",
                voter_file_not_certified: "A última importación de votantes do evento {{event}} non está certificada: {{reason}}.",
                voter_receipt_not_signed: "O rexistro do evento {{event}} non ten unha entrada asinada que corresponda á importación de votantes {{import_id}}.",
                registry_count_changed: "O evento {{event}} ten agora {{current}} votantes en {{area}}, pero a súa importación certificada ten {{imported}}.",
                voter_area_not_configured: "Os votantes certificados do evento {{event}} inclúen {{area}}, que non está no seu contido asinado.",
                voter_file_mismatch: "Os ficheiros certificados de votantes son distintos: SHA-256 {{official}} (oficial) e {{tested}} (de proba).",
                voter_count_mismatch: "Os ficheiros certificados difiren en {{area}}: {{official}} votantes (oficial) e {{tested}} (de proba).",
                ballots_present: "O evento oficial ten {{count}} papeletas almacenadas.",
                received_ballots_present: "O evento oficial ten {{count}} papeletas recibidas para revisión.",
                tally_sessions_present: "O evento oficial ten {{count}} sesións de reconto.",
                status_missing: "{{scope}} non ten estado de votación.",
                voting_started: "{{scope}}: a canle {{channel}} está en {{status}}.",
                voting_dates_recorded: "{{scope}}: a canle {{channel}} ten datas de votación rexistradas.",
                no_elections: "O evento {{event}} non ten eleccións.",
                publication_missing: "O evento {{event}} non ten ningunha publicación activa.",
                publication_mismatch: "Os {{design_count}} deseños de papeleta publicados do evento {{event}} non coinciden con todos os deseños da súa configuración asinada.",
                publication_empty: "Os deseños de papeleta publicados do evento {{event}} non se puideron comprobar cunha configuración asinada.",
                channels_open: "O evento de proba aínda ten canles de votación sen pechar.",
                seal_at_close_off: "O evento de proba non sela as urnas ao peche.",
                no_expected_boxes: "A publicación do evento de proba non espera ningunha urna.",
                boxes_unsealed: "A elección {{election}} do evento de proba ten {{unsealed}} urnas sen selar.",
            },
        },
        plugins: {
            title: "Complementos",
            description: "Os complementos inclúense nesta versión. Ao activar un engádense o seu elemento de menú e os seus permisos para este inquilino; ao desactivalo ocúltase e consérvanse os seus datos e permisos.",
            enabled: "Activado",
            disabled: "Desactivado",
            compatible: "Compatible",
            incompatible: "Os datos gardados requiren unha versión máis recente",
            api: "API de complementos {{major}}",
            permissions: "Permisos",
            adminGroup: "concédense ao grupo admin ao activalo",
            enable: "Activar",
            disable: "Desactivar",
            confirmEnableTitle: "Activar {{name}}?",
            confirmDisableTitle: "Desactivar {{name}}?",
            confirmEnable: "{{name}} aparece no menú dos usuarios cos seus permisos. Os seus permisos créanse neste inquilino e concédense ao grupo admin.",
            confirmDisable: "{{name}} ocúltase e as súas solicitudes rexéitanse. Consérvanse os seus datos, historial e permisos, e non cambia nada máis no inquilino.",
            confirm: "Confirmar",
            noPermission: "Cambiar os complementos require o permiso tenant-write.",
            retry: "Tentar de novo",
            loading: "Cargando complementos…",
            signIn: "Inicia sesión no inquilino seleccionado para usar os seus complementos.",
            unavailable: "Este complemento non forma parte desta versión.",
            incompatibleRoute: "Os datos gardados deste complemento requiren unha versión máis recente. Os seus datos non cambiaron.",
            disabledRoute: "{{name}} non está activado para este inquilino. Un administrador do inquilino pode activalo en Axustes → Complementos.",
            forbidden: "Non tes permiso para usar {{name}}.",
        },
        projects: {
            title: "Proxectos",
            subtitle: "Planifica o traballo do inquilino nunha liña de tempo. Os proxectos nunca cambian os calendarios electorais.",
            cancel: "Cancelar",
            retry: "Tentar de novo",
            loading: "Cargando…",
            list: {
                create: "Novo proxecto",
                import: "Importar",
                emptyTitle: "Aínda non hai proxectos",
                emptyHelp: "Crea un proxecto ou importa un ficheiro CSV exportado doutro proxecto.",
                emptyViewer: "Non se creou ningún proxecto neste inquilino.",
                active_one: "Activos ({{count}})",
                active_other: "Activos ({{count}})",
                archived_one: "Arquivados ({{count}})",
                archived_other: "Arquivados ({{count}})",
                name: "Nome",
                dates: "Datas",
                tasks: "Tarefas",
                timezone: "Fuso horario",
                updated: "Último cambio",
                updatedBy: "{{at}} · {{actor}}",
                archivedChip: "Arquivado",
                noneInTab: "Non hai proxectos aquí.",
            },
            create: {
                title: "Novo proxecto",
                name: "Nome do proxecto",
                timezone: "Fuso horario",
                timezoneHelp: "Todas as datas do proxecto introdúcense e móstranse neste fuso horario IANA.",
                submit: "Crear proxecto",
            },
            import: {
                title: "Importar un proxecto",
                help: "Importar sempre crea un proxecto novo. Usa un ficheiro CSV en UTF-8 coas columnas {{columns}}, tal como se exporta dun proxecto, cun desprazamento UTC en cada data. Non se garda nada ata que crees o proxecto.",
                choose: "Escoller ficheiro CSV",
                noFile: "Ningún ficheiro escollido",
                fileLimit: "O ficheiro debe ocupar como máximo 1 MiB.",
                invalidFile: "O ficheiro non é texto UTF-8 válido.",
                valid_one: "{{count}} tarefa está lista para importar.",
                valid_other: "{{count}} tarefas están listas para importar.",
                invalid_one: "{{count}} de {{total}} filas ten erros. Corrixe o ficheiro e escólleo de novo.",
                invalid_other: "{{count}} de {{total}} filas teñen erros. Corrixe o ficheiro e escólleo de novo.",
                previewTable: "Vista previa da importación",
                line: "Liña",
                result: "Comprobación",
                rowValid: "Lista",
                commit: "Crear proxecto",
            },
            detail: {
                timezone: "Todas as datas e horas están en {{timezone}}.",
                export: "Exportar",
                archive: "Arquivar",
                restore: "Restaurar",
                addTask: "Engadir tarefa",
                viewOnly: "Só lectura. Cambiar tarefas require o permiso projects-write.",
                archivedNotice: "Este proxecto está arquivado. Restáurao para cambiar as súas tarefas.",
            },
            notices: {
                saved: "Gardouse «{{title}}».",
                moved: "Gardouse «{{title}}»: {{start}} – {{end}}.",
                deleted: "Eliminouse «{{title}}».",
                archived: "Proxecto arquivado.",
                restored: "Proxecto restaurado.",
            },
            panel: {
                details: "Detalles da tarefa",
                edit: "Editar tarefa",
                add: "Engadir tarefa",
                close: "Pechar os detalles da tarefa",
                hint: "Selecciona unha tarefa na liña de tempo para ver aquí os seus detalles.",
                noTasks: "Este proxecto aínda non ten tarefas.",
            },
            conflict: {
                body: "Outra persoa cambiou esta tarefa ({{actor}}, {{at}}). Os teus cambios seguen aquí. Revisa a súa versión antes de gardar de novo.",
                load: "Cargar a súa versión",
            },
            unsaved: {
                body: "Tes cambios sen gardar. Gárdaos ou descártaos para {{action}}.",
                keep: "Seguir editando",
                discard: "Descartar cambios",
                actions: {
                    open: "abrir «{{title}}»",
                    add: "engadir unha tarefa nova",
                    leave: "volver aos proxectos",
                    close: "pechar a tarefa",
                    state: "cambiar o proxecto",
                },
            },
            deleteDialog: {
                title: "Eliminar a tarefa?",
                body: "«{{title}}» elimínase do proxecto. Consérvase o seu historial de cambios.",
                confirm: "Eliminar",
            },
            history: {
                task: "Historial de cambios",
                project: "Historial do proxecto",
                empty: "Aínda non hai cambios rexistrados.",
                more: "Amosar cambios anteriores",
                by: "{{actor}} · {{at}}",
                actions: {
                    create: "Creado {{subject}}",
                    update: "Cambiado {{subject}}",
                    delete: "Eliminado {{subject}}",
                    import_one: "Importada {{count}} tarefa",
                    import_other: "Importadas {{count}} tarefas",
                    export: "Exportado como CSV",
                    other: "{{action}}",
                },
            },
            editor: {
                title: "Título",
                type: "Tipo",
                status: "Estado",
                start: "Inicio",
                end: "Fin",
                at: "Data e hora",
                notes: "Notas",
                order: "Orde",
                orderHelp: "As tarefas ordénanse por orde e despois por inicio.",
                timezoneNote: "As horas están en {{timezone}}.",
                offset: "UTC{{offset}}",
                localTime: {
                    invalid: "Introduce unha data e hora entre 1900 e 2200.",
                    skipped: "Esta hora non existe en {{timezone}}: os reloxos sáltana. Escolle outra hora.",
                    repeated: "Esta hora ocorre dúas veces en {{timezone}}. Escolle a cal te refires.",
                },
                chooseInstant: "Que vez",
                instantChoice: "En UTC{{offset}}",
                saving: "Gardando…",
                toFix_one: "{{count}} campo por corrixir",
                toFix_other: "{{count}} campos por corrixir",
                save: "Gardar",
                delete: "Eliminar",
            },
            validation: {
                title: "Introduce un título de como máximo 200 caracteres.",
                offset: "Introduce datas válidas.",
                range: "O fin debe ser posterior ao inicio.",
                milestone: "Un fito non ten fin.",
                notes: "As notas deben ter como máximo 16.000 caracteres.",
                order: "A orde debe ser un número enteiro de 0 a 1.000.000.",
            },
            status: {
                not_started: "Sen comezar",
                in_progress: "En curso",
                done: "Feita",
            },
            type: {
                task: "Tarefa",
                milestone: "Fito",
            },
            units: {
                days_one: "{{count}} día",
                days_other: "{{count}} días",
                hours_one: "{{count}} h",
                hours_other: "{{count}} h",
                minutes_one: "{{count}} min",
                minutes_other: "{{count}} min",
            },
            timeline: {
                title: "Liña de tempo",
                tasks_one: "{{count}} tarefa",
                tasks_other: "{{count}} tarefas",
                empty: "Aínda non hai tarefas.",
                editHelp: "Sinala ou enfoca unha tarefa para ver un resumo; selecciónaa para editala abaixo. Arrastra unha barra ou usa ← → para movela 24 horas; engade Maiús para cambiar o fin.",
                viewHelp: "Sinala ou enfoca unha tarefa para ver un resumo. Selecciónaa para ver os seus detalles abaixo.",
                touchEditHelp: "Toca unha tarefa para editala abaixo, ou arrastra unha barra para movela días enteiros.",
                touchViewHelp: "Toca unha tarefa para ver os seus detalles abaixo.",
                taskLabel: "{{title}}, de {{start}} a {{end}}, {{status}}",
                milestoneLabel: "{{title}}, fito o {{at}}, {{status}}",
                previewEdit: "Fai clic ou preme Intro para editar",
                previewView: "Fai clic ou preme Intro para ver os detalles",
            },
        },
        philippinePassport: "Pasaporte filipino",
        seamanBook: "Libro de marinero",
        philSysID: "Identificación PhilSys",
        iBP: "Colegio de Abogados Integrado de Filipinas (IBP)",
        driversLicense: "Licencia de conducir",
        loading: "Cargando...",
        loadingDataProvider: "Cargando o provedor de datos...",
        tallySheetImport: {
            title: "Importacións de actas de escrutinio",
            subtitle: "Importa ficheiros de actas de escrutinio ES&S ou CSV, previsualiza as urnas xeradas e apróbaas antes de crear actas de escrutinio.",
            createTitle: "Importar actas de escrutinio",
            detailTitle: "Importación de acta de escrutinio",
            empty: "Aínda non hai importacións de actas de escrutinio.",
            emptyBody: "Comeza importando un ficheiro ES&S Enhanced XML ou CSV canónico para este evento electoral.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV canónico",
            },
            channel: {
                PAPER: "Papel",
                POSTAL: "Postal",
                IN_PERSON: "Presencial",
            },
            table: {
                created: "Creado",
                createdBy: "Creado por",
                file: "Ficheiro",
                format: "Formato",
                channel: "Canle",
                status: "Estado",
                labels: "Etiquetas",
                annotations: "Anotacións",
                actions: "Accións",
            },
            summary: {
                imported: "Importadas",
                changed: "Modificadas",
                new: "Novas",
                unchanged: "Sen cambios",
                conflicted: "En conflito",
                errors: "Erros",
            },
            status: {
                PENDING_REVIEW: "Pendente de revisión",
                APPROVED: "Aprobada",
                DISAPPROVED: "Desaprobada",
                FAILED_VALIDATION: "Validación fallida",
                CONFLICTED: "En conflito",
                NEW: "Nova",
                CHANGED: "Modificada",
                UNCHANGED: "Sen cambios",
            },
            fields: {
                format: "Formato",
                channel: "Canle",
                supportedFormats: "Formatos admitidos: XML, CSV",
                generatedTallySheet: "Acta de escrutinio xerada",
                sourceCandidates: "IDs de candidatos de orixe",
                none: "Ningún",
            },
            actions: {
                create: "Importar actas de escrutinio",
                review: "Revisar",
                source: "Orixe",
                cancel: "Cancelar",
                preview: "Previsualizar",
                save: "Gardar importación",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                close: "Pechar",
                openExisting: "Abrir existente",
            },
            notifications: {
                selectFile: "Selecciona un ficheiro de importación antes de previsualizalo",
                duplicateSource: "Este hash de ficheiro de orixe xa aparece nunha importación de acta de escrutinio anterior.",
                uploadUrlError: "Non se puido crear a URL de subida",
                uploadError: "Non se puido subir o ficheiro de importación",
                previewEmpty: "A resposta da previsualización estaba baleira",
                previewError: "Non se puido previsualizar a importación",
                importEmpty: "A resposta da importación estaba baleira",
                created: "Creouse a importación da acta de escrutinio",
                createError: "Non se puido crear a importación",
                reviewEmpty: "A resposta da revisión estaba baleira",
                conflicted: "A importación ten conflitos de liña base desactualizados",
                approved: "Aprobouse a importación",
                disapproved: "Desaprobouse a importación",
                reviewError: "Non se puido revisar a importación",
                sourceUrlError: "Non se puido crear a URL de descarga de orixe",
                sourceDownloadError: "Non se puido descargar o ficheiro de orixe",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} de {{total}}",
                previous: "Anterior",
                next: "Seguinte",
            },
        },
        reconciliation: {
            menuButton: "Sincr. votantes ext.",
            categories: {
                VOTED_INTERNET: "Votou por Internet",
                VOTED_OTHER_CHANNEL: "Votou por outra canle",
                DISABLED_DELETE_CALL: "Votante desactivado",
                DELETION_REVERTED: "Eliminación revertida",
                PROFILE_UPDATE: "Perfil actualizado",
                VOTER_ADDED: "Votante engadido",
                REENABLED: "Votante reactivado",
                VOTED_UNMARKED: "Votante desmarcado como votante",
                ROW_FAILURE: "Erro de fila",
            },
            table: {
                voterId: "ID de Votante",
                field: "Campo",
                category: "Categoría",
                currentValue: "Valor actual",
                newValue: "Valor novo",
                reason: "Motivo",
                rowLabel: "Fila",
                noDifferences: "Non se atoparon diferenzas - os sistemas están sincronizados.",
            },
            wizard: {
                title: "Sincronización de reconciliación externa",
                subtitle: "Sincroniza a lista de votantes co sistema externo",
                drop: {
                    description: "Solta o ficheiro de reconciliación xerado polo sistema externo - ambos os diffs (lado externo e lado Sequent) calcúlanse automaticamente e móstranse en táboas separadas.",
                    fileFormatLabel: "Ficheiro CSV",
                    uploading: "Subindo {{fileName}} e calculando ambos os diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Secuencia {{sequence}}, xerado {{generatedAt}}",
                    rowFailuresWarning: "{{count}} fila(s) non se puideron reconciliar de forma segura e quedan excluídas de ambos os diffs - ver detalles abaixo.",
                    noDifferences: "Non hai diferenzas - ambos os sistemas xa están sincronizados.",
                    diffOnlyDifferences: "Esta é unha comprobación de converxencia dunha secuencia xa aplicada. As diferenzas móstranse para o seu seguimento, pero esta rolda non se pode volver aplicar.",
                    externalDiffTitle: "Diff externo",
                    sequentDiffTitle: "Diff de Sequent",
                    downloadExternalPatch: "Descargar parche externo",
                    externalDiffCaption: "Descarga o parche e entrégao ao sistema externo fóra desta ferramenta. Unha vez que o aplique e xere o seguinte ficheiro de reconciliación, preme en 'Atrás' e solta ese ficheiro - 'Aplicar' actívase cando esta táboa estea baleira.",
                    noExternalDifferences: "Non hai diferenzas do lado externo.",
                    sequentDiffCaption: "Aplica os cambios directamente a Sequent premendo en 'Aplicar' - non se xera ficheiro de parche para estes.",
                    noSequentDifferences: "Non hai diferenzas do lado de Sequent.",
                },
                applying: {
                    inProgress: "Aplicando os cambios do lado de Sequent...",
                    rowFailures: "{{count}} fila(s) quedaron excluídas desta ronda e precisan seguimento manual - ver detalles abaixo.",
                    rowFailuresTruncated: "Amósanse os primeiros {{shown}} de {{count}} erros de fila. Resolve a causa común e téntao de novo para ver os erros restantes.",
                    success: "Todos os cambios do lado de Sequent aplicáronse correctamente.",
                },
                actions: {
                    cancel: "Cancelar",
                    back: "Atrás",
                    apply: "Aplicar",
                    next: "Seguinte",
                    startOver: "Comezar de novo",
                    close: "Pechar",
                },
                confirm: {
                    title: "Confirmar cambios de reconciliación",
                    categoriesNote: "As categorías resaltadas en laranxa ({{categories}}) afectan o estado de voto ou desactivan votantes.",
                    applyChanges: "Aplicar cambios",
                    continue: "Continuar",
                },
                summary: {
                    votedOtherChannel: "marca {{count}} votante(s) como votado(s) por outra canle",
                    disabled: "desactiva {{count}} votante(s)",
                    reenabled: "reactiva {{count}} votante(s)",
                    votedUnmarked: "desmarca {{count}} votante(s) como votante",
                    profileUpdated: "actualiza {{count}} perfil(s)",
                    voterAdded: "engade {{count}} votante(s)",
                    prefix: "Isto aplicará cambios que {{parts}}.",
                    empty: "Non hai cambios do lado de Sequent para aplicar.",
                },
                notifications: {
                    envelopeLoadError: "Non se puido cargar o diff de reconciliación - téntao de novo.",
                    generateFailed: "Non se puido calcular o diff de reconciliación - consulta o widget de tarefas para máis detalles.",
                    applyFailed: "Non se puideron aplicar os cambios do lado de Sequent - consulta o widget de tarefas para máis detalles.",
                    uploadUrlError: "Non se puido obter unha URL de subida",
                    generateTaskError: "Non se puido iniciar a tarefa de diff de reconciliación",
                    uploadError: "Non se puido subir o ficheiro de reconciliación",
                    applyTaskError: "Non se puido iniciar a tarefa de aplicación",
                    applyError: "Non se puideron aplicar os cambios de reconciliación",
                },
            },
        },
        tenantLogs: {
            explanation: {
                action: "Acción: {{action}}",
                outcome: {
                    succeeded: "Aceptada (HTTP {{status}})",
                    denied: "Denegada (HTTP {{status}})",
                    failed: "Fallida (HTTP {{status}})",
                },
                by: "Pedida por {{username}} ({{userId}})",
                detail: "{{name}}: {{value}}",
                board: "Rexistro: {{board}}",
                publicKey: "Clave pública do rexistro: {{key}}",
            },
        },
        logsScreen: {
            configurationPackage: englishTranslation.translations.logsScreen.configurationPackage,
            readiness: {
                passed: "Superado",
                failed: "Fallido",
                checkResult: "{{outcome}}: {{description}}",
                checkResultWithMessage: "{{outcome}}: {{description}} Condición rexistrada: «{{message}}»",
                description: {
                    VotersImported: "Ficheiro de votantes importado.",
                    ReadinessVerified: "Preparación do evento oficial verificada co evento probado.",
                },
                checks: {
                    configuration: "Ambos os eventos teñen o mesmo contido aprobado, aprobadores verificados e áreas.",
                    certified_voters: "Ambos os eventos coinciden no ficheiro certificado de votantes e nos recontos actuais por área.",
                    official_zero: "O evento oficial nunca abriu a votación e non ten votos nin sesións de reconto.",
                    publication: "A publicación oficial coincide coa súa configuración asinada.",
                    tested_finished: "As canles de votación do evento probado están pechadas e todas as urnas previstas están seladas.",
                },
                fields: {
                    report: "Informe de preparación",
                    passed: "Superado",
                    checked_at: "Data da comprobación",
                    evidence: "Evidencia",
                    official: "Evento oficial",
                    tested: "Evento probado",
                    official_event_id: "ID do evento oficial",
                    tested_event_id: "ID do evento probado",
                    event_id: "ID do evento",
                    election_id: "ID da elección",
                    configuration: "Configuración",
                    external_id: "ID externo",
                    revision: "Revisión",
                    content_sha256: "SHA-256 do contido",
                    manifest_sha256: "SHA-256 do manifesto",
                    approvers: "Aprobadores verificados",
                    areas: "Áreas",
                    voters: "Importación de votantes",
                    import_id: "ID da importación",
                    document_id: "ID do documento",
                    file_name: "Nome do ficheiro",
                    sha256: "SHA-256 do ficheiro",
                    declared_sha256: "SHA-256 declarado",
                    counts_by_area: "Votantes por área",
                    imported_at: "Data da importación",
                    voter_log_delivered: "Importación asinada rexistrada",
                    current_voter_counts: "Votantes actuais por área",
                    voter_import_in_progress: "Importación de votantes activa",
                    status: "Estado",
                    elections: "Eleccións",
                    ballot_count: "Votos almacenados",
                    received_ballot_count: "Votos recibidos na revisión",
                    tally_session_count: "Sesións de reconto",
                    publication: "Publicación",
                    publication_id: "ID da publicación",
                    publication_ids: "ID das publicacións",
                    matches_manifest: "Coincide co manifesto asinado",
                    design_count: "Deseños publicados",
                    seal_at_close: "Selar ao peche",
                    expected_boxes: "Urnas previstas",
                    sealed_boxes: "Urnas seladas",
                    all_channels_closed: "Todas as canles pechadas",
                    locked_down: "Bloqueado",
                    log_entry_id: "ID da entrada do rexistro",
                },
            },
            noPermissions: "Non tes permiso para acceder aos rexistros.",
            title: "Rexistros",
            subtitle: "Todo o que se fai neste evento electoral. Os inicios de sesión e os cambios fóra del están en Configuracións > Rexistros.",
            empty: "Non se atoparon entradas.",
            tenant: {
                subtitle: "Inicios de sesión, contas do persoal e roles, configuración e eventos electorais desta organización. Cada evento electoral garda o seu propio rexistro na súa lapela Rexistros.",
                noPermissions: "Non tes permiso para ver este rexistro.",
            },
            entry: {
                title: "Entrada do rexistro {{id}}",
                statementKind: "Tipo de declaración",
                eventType: "Tipo de evento",
                logType: "Tipo de rexistro",
                when: "Cando",
                utc: "{{time}} UTC",
                who: "Quen",
                userId: "ID de usuario {{id}}",
                role: "Rol {{role}}",
                unknownAccount: "Conta descoñecida (non se rexistra o nome escrito)",
                madeIn: "Feito en",
                changed: "Cambiado",
                objectId: "ID {{id}}",
                actionLabel: "Acción",
                details: "Detalles",
                origin: {
                    "hasura": "Portal de administración (a través de Hasura)",
                    "harvest": "Portal de administración (a través de Harvest)",
                    "windmill": "Portal de administración (unha tarefa de Windmill)",
                    "keycloak-console": "Consola de administración de Keycloak, fóra do portal de administración",
                    "service-account": "Conta de servizo de Step, por un cambio feito no portal de administración",
                },
                action: {
                    create: "Creado",
                    update: "Actualizado",
                    delete: "Eliminado",
                    import: "Importado",
                    export: "Exportado",
                    archive: "Arquivado",
                    unarchive: "Desarquivado",
                    enable: "Activado",
                    disable: "Desactivado",
                    reset_password: "Contrasinal restablecido",
                    grant: "Concedido",
                    revoke: "Revogado",
                },
                objectType: {
                    tenant: "Configuración do inquilino",
                    tenant_log: "Rexistro do inquilino",
                    staff_account: "Conta do persoal",
                    role: "Rol",
                    template: "Modelo",
                    trustee: "Fideicomisario",
                    election_type: "Tipo de elección",
                    election_event: "Evento electoral",
                    election: "Elección",
                    contest: "Contenda",
                    candidate: "Candidato",
                    area: "Área",
                },
                values: {
                    title: "Valores anteriores e novos",
                    field: "Campo",
                    old: "Valor anterior",
                    new: "Valor novo",
                    none: "(ningún)",
                    secret: "Cambiado. Os valores secretos nunca se rexistran.",
                    yes: "Si",
                    no: "Non",
                    sha: "SHA-256 {{hash}}",
                },
                field: {
                    tenant: {
                        slug: "Nome curto",
                        isActive: "Activo",
                        logsTimezone: "Fuso horario do rexistro do inquilino (Idiomas)",
                        languages: "Idiomas",
                        enabledLanguages: "Idiomas habilitados (Idiomas)",
                        defaultLanguage: "Idioma predeterminado (Idiomas)",
                        languageDetection: "Detección do idioma (Idiomas)",
                        translations: "Traducións (Localización)",
                        sms: "SMS",
                        mail: "Correo electrónico",
                        gapiKey: "Clave da API de Google (Integracións)",
                        gapiEmail: "Correo da API de Google (Integracións)",
                        helpLinks: "Ligazóns de axuda (Aspecto)",
                        displayName: "Nome da organización (Aspecto)",
                        votingCountries: "Países bloqueados para votar (Países)",
                        enrollCountries: "Países bloqueados para inscribirse (Países)",
                        logoUrl: "Logotipo (Aspecto)",
                        css: "CSS personalizado (Aspecto)",
                        votingChannels: "Canles de votación",
                        onlineVoting: "Voto en liña (Canles de votación)",
                        kioskVoting: "Voto en quiosco (Canles de votación)",
                        telephoneVoting: "Voto telefónico (Canles de votación)",
                        earlyVoting: "Voto anticipado (Canles de votación)",
                        paperVoting: "Voto en papel (Canles de votación)",
                    },
                },
                signIn: {
                    title: "Inicio de sesión e seguridade da conta",
                    event: "Evento de Keycloak",
                    error: "Erro",
                    authentication: "Autenticación",
                    credential: "Credencial",
                    failures: "Fallos seguidos",
                    client: "Cliente",
                    ipAddress: "Enderezo IP",
                },
                keycloak: {
                    title: "Cambio en Keycloak",
                    account: "Conta",
                    operation: "Operación",
                    appliesTo: "Aplícase a",
                    resource: "Recurso",
                    newValue: "Valor novo",
                    error: "Erro",
                },
                importedFile: {
                    title: "O ficheiro importado",
                    declared: "Suma de comprobación declarada",
                    sha256: "SHA-256 do ficheiro",
                    declaredSha256: "SHA-256 declarado",
                    document: "Documento",
                    checksum: {
                        undeclared: "Non se declarou",
                        matches: "Coincide co ficheiro",
                        mismatch: "Non coincide co ficheiro",
                    },
                    counts: {
                        count: "Filas",
                        elections: "Eleccións",
                        contests: "Contendas",
                        candidates: "Candidatos",
                        areas: "Áreas",
                        area_contests: "Áreas por contenda",
                        sections: "Seccións de configuración",
                    },
                },
                deletedEvent: {
                    title: "O rexistro do evento electoral eliminado",
                    lastEntry: "Última entrada",
                    stateHash: "Hash de estado",
                    logDatabase: "Base de datos do rexistro",
                    status: "Estado",
                    retired: "Descargado e conservado ata que se borre segundo a política de conservación",
                    task: "Tarefa",
                    systemKey: "A clave de sistema do rexistro",
                },
                exported: {
                    title: "Exportación",
                    entries: "Entradas",
                    sha256: "SHA-256 do ficheiro",
                    document: "Documento",
                    scope: {
                        TENANT_LOG: "Todo o rexistro do inquilino",
                        ACCOUNT: "Unha conta",
                        ACCOUNT_WITH_EVENTS: "Unha conta, coas súas entradas en cada evento electoral",
                        ALL: "Todo o evento electoral",
                        ELECTION: "Unha elección",
                        AREA: "Unha área",
                    },
                },
                writer: {
                    title: "Escritor do rexistro",
                    release: "Versión",
                    lastEntry: "Última entrada publicada",
                },
                signatures: {
                    title: "Rexistro e sinaturas",
                    log: "Rexistro",
                    tenantLog: "Rexistro do inquilino",
                    eventLog: "Rexistro do evento electoral",
                    signedBy: "Asinado por",
                    adminKey: "Clave de administración de {{name}}",
                    systemOnly: "Só a clave de sistema do rexistro",
                    systemSignature: "Sinatura do sistema",
                    publicKey: "Clave de administración publicada",
                },
            },
            actions: {
                csv: "Exportar en CSV",
                pdf: "Exportar en PDF",
                audit: "Auditar",
            },
            auditDialog: {
                title: "Auditar o rexistro electoral",
                confirm: "Auditar",
                description: "A auditoría comproba cada entrada do rexistro co seu rexistro Merkle e verifica os puntos de control publicados. O resultado gárdase como unha tarefa.",
            },
            exportdialog: {
                description: "Confirme que quere executar esta acción; pode levar un tempo executarse.",
                title: "Exportar rexistros",
                from: "Desde",
                to: "Ata",
                timeZone: "Fuso horario",
                format: "Formato",
                csv: "CSV",
                pdf: "PDF",
                sql: "SQL",
                scope: {
                    label: "Alcance",
                    tenant: {
                        TENANT_LOG: "Todo o rexistro do inquilino",
                        ACCOUNT: "Unha conta",
                    },
                    event: {
                        ALL: "Todo o evento electoral",
                        ELECTION: "Unha elección",
                        AREA: "Unha área",
                        ACCOUNT: "Unha conta",
                    },
                },
                username: "Nome de usuario",
                election: "Elección",
                area: "Área",
                withElectionEvents: "Incluír as entradas desta conta en cada evento electoral",
                rowsNameLog: "As filas dos eventos electorais indican o seu rexistro.",
                recorded: "A propia exportación queda rexistrada neste rexistro.",
                zoneNote: "Cada fila conserva a súa hora en UTC (ISO 8601) e en {{abbr}}, co nome do fuso horario. O intervalo de datas inclúe ambos os extremos, en {{abbr}}.",
                zoneNotePdf: "O PDF amosa cada hora en {{abbr}}. O intervalo de datas inclúe ambos os extremos, en {{abbr}}.",
                rowZones: "O fuso horario da elección de cada fila",
                zoneNoteRows: "Cada fila conserva a súa hora en UTC (ISO 8601) e no fuso horario da súa elección, co nome do fuso horario. O intervalo de datas inclúe ambos os extremos, en {{abbr}}.",
                zoneNoteRowsPdf: "O PDF amosa cada hora no fuso horario da súa elección. O intervalo de datas inclúe ambos os extremos, en {{abbr}}.",
            },
            filter: {
                createdFrom: "Creado desde",
                createdTo: "ata",
                statementTimestampFrom: "Marca de tempo da declaración desde",
                statementTimestampTo: "Marca de tempo da declaración ata",
                timeZone: "Fuso horario",
            },
            scheduledOutcome: {
                outcome: {
                    "waiting-for-initialization": "Agardando pola inicialización",
                    "runs": "execútase",
                    "runs-unsigned": "execútase sen sinaturas",
                    "refused": "rexéitase",
                },
                check: {
                    "initialization": "A inicialización requirida está incompleta",
                    "voting-close": "A votación non pode abrirse despois do prazo de peche",
                    "needs-signatures": "sinaturas necesarias",
                    "covered": "na configuración asinada",
                    "unsigned-close": "peche sen sinaturas",
                    "stricter-copy": "configuración actual ou publicada",
                    "defaults": "aínda non hai nada publicado",
                },
                changed: "Agora {{after}} (antes: {{before}}).",
                result: "Resultado: {{outcome}}.",
                deciding: "Comprobación decisiva: {{check}}. {{value}}",
                authorizedBy: "Autorizado pola configuración {{code}}.",
                nextStep: "Seguinte paso: {{step}}",
                reason: {
                    "ballot-box-seal-policy": "Mantense pechada: con Selar ao pechar, a votación que xa se pechou segue pechada.",
                    "never-opened-kept-open": "Non hai nada que pechar segundo a programación: o Posto nunca se abriu, polo que queda como está.",
                },
            },
            column: {
                id: "ID",
                statement_kind: "Tipo de declaración",
                created: "Creado",
                statement_timestamp: "Marca de tiempo de declaración",
                message: "Mensaje",
                user_id: "ID de usuario",
                username: "Nombre de Usuario",
                sender_pk: "Clave primaria del remitente",
                log_type: "Tipo de registro",
                event_type: "Tipo de evento",
                description: "Descripción",
                version: "Versión",
            },
            main: {
                title: "Rexistros da Base de Datos Principal",
            },
            iam: {
                title: "Rexistros da Base de Datos IAM",
            },
            ballotBoxSeal: {
                sealHash: "Hash do selo: {{hash}}",
                counted: "Contabilizáronse {{counted}} de {{inBox}} papeletas.",
                notCounted_one: "A outra papeleta foi substituída por unha papeleta posterior do votante, descartada ou emitida por un votante non elixible.",
                notCounted_other: "As outras {{count}} papeletas foron substituídas por unha papeleta posterior do votante, descartadas ou emitidas por un votante non elixible.",
                closeRequest: "Pechada pola solicitude de sinatura de Pechar a votación {{request}}.",
                noCloseRequest: "Pechada sen solicitude de sinatura de Pechar a votación (Detener Votación ou o peche programado).",
                failedReason: "Motivo: {{reason}}",
                failedLocked: "A urna segue bloqueada e non está selada: é unha incidencia.",
                verifiedCounted: "Contabilizáronse {{counted}} papeletas a partir do selo.",
                tallySession: "Sesión de escrutinio {{session}}.",
                differs: "Diferenzas: {{differs}}",
            },
        },
        tasksScreen: {
            noPermissions: "Non tes permiso para acceder ás tarefas.",
            title: "Execución de Tarefas",
            subtitle: "Información sobre as tarefas executadas",
            taskInformation: "Información da Tarefa",
            status: "estado: {{status}}",
            ok: "Aceptar",
            column: {
                id: "Índice",
                name: "Nome da tarefa",
                type: "Tipo",
                execution_status: "Estado",
                start_at: "Hora de inicio",
                end_at: "Hora de fin",
                executed_by_user: "Executado por",
                annotations: "Anotacións",
                labels: "Etiquetas",
                logs: "Rexistros",
            },
            tasksExecution: {
                DELETE_TENANT: "Eliminar organización",
                PUBLISH_BALLOT: "Publicar papeleta",
                VOTER_INFORMATION_LETTER: "Carta de información para o votante",
                EXPORT_MONITORING_DATA: "Exportar Datos de Monitorización",
                AUDIT_ELECTORAL_LOG: "Auditar rexistro electoral",
                EXPORT_ELECTION_EVENT: "Exportar evento electoral",
                CREATE_ELECTION_EVENT: "Crear Evento Electoral",
                IMPORT_ELECTION_EVENT: "Importar evento electoral",
                IMPORT_USERS: "Importar usuarios",
                EDIT_USER: "Editar votante",
                IMPORT_CANDIDATES: "Importar candidatos",
                EXPORT_VOTERS: "Exportar votantes",
                CREATE_TRANSMISSION_PACKAGE: "Crear paquete de transmisión",
                EXPORT_BALLOT_PUBLICATION: "Exportar Publicación de Boleta",
                EXPORT_ACTIVITY_LOGS_REPORT: "Exportar Informe de Registros de Actividad",
                EXPORT_TENANT_LOGS: "Exportar Rexistro do Inquilino",
                GENERATE_REPORT: "Generar Reporte",
                GENERATE_TRANSMISSION_REPORT: "Generar Informe de Transmisión",
                EXPORT_TRUSTEES: "Exportar Autoridades",
                EXPORT_APPLICATION: "Exportar Solicitudes",
                EXPORT_TENANT_CONFIG: "Exportar Configuración del Cliente",
                IMPORT_TENANT_CONFIG: "Importar Configuración del Cliente",
                APPLY_CONFIGURATION_PACKAGE: "Aplicar Paquete de Configuración",
                RENDER_DOCUMENT_PDF: "Renderizar el documento PDF",
                CREATE_TENANT: "Crear Cliente",
                EXPORT_TEMPLATES: "Exportar Plantillas",
                IMPORT_TEMPLATES: "Importar Plantillas",
                DELETE_ELECTION_EVENT: "Eliminar evento electoral",
                DELETE_VOTERS: "Eliminar votantes",
                PREPARE_PUBLICATION_PREVIEW: "Preparar a vista previa da publicación",
                EXPORT_TALLY_RESULTS_XLSX: "Exportar os resultados do reconto en formato XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "Exportar autoridades de certificación",
                PUBLISH_RESULTS_WEBSITE: "Publicar sitio web de resultados",
            },
            documentAccess: {
                title: "Acceso ao documento",
                sensitivityNotice: "Información sensible. Comparta este contrasinal só co destinatario previsto.",
                passwordLabel: "Contrasinal para abrir o PDF cifrado",
                showPassword: "Amosar o contrasinal",
                copyPassword: "Copiar o contrasinal",
                passwordCopied: "Contrasinal copiado",
                passwordError: "Non se puido recuperar o contrasinal do PDF",
                copyError: "Non se puido copiar o contrasinal",
                guidance: "O contrasinal só se carga despois de escoller Amosar o contrasinal. Unha vez cargado, aparecerá aquí un campo de só lectura coa opción de copiar.",
            },
            widget: {
                taskTitle: "Tarefa: {{title}}",
                viewTask: "Ver Tarefa",
                downloadDocument: "Descargar Archivo",
                downloadHashManifest: "Manifesto de hashes",
            },
            exportTasksExecution: {
                success: "Exportación finalizada con éxito",
                error: "Erro ao exportar a Execución de Tarefas",
            },
        },
        areas: {
            common: {
                title: "Áreas",
                subTitle: "Configuración de áreas.",
                deleteError: "Erro ao eliminar a área",
            },
            createAreaSuccess: "Área creada",
            updateAreaSuccess: "Área actualizada",
            createAreaError: "Non se puido crear a área",
            sequent_backend_area_contest: "Preguntas",
            empty: {
                header: "Aínda non hai áreas.",
                action: "Crear Área",
            },
            formImputs: {
                allowEarlyVoting: "Permitir Votación Anticipada",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Clave de Conta de Servizo de Google Calendar",
                gapiEmail: "Correo de Autenticación de Google Calendar",
                gapiKeyHelper: "A clave gardada non se amosa. Pegue unha clave nova para substituíla.",
                gapiKeySaved: "Clave de Conta de Servizo de Google Calendar gardada",
            },
            errors: {
                invalidGapiKey: "Formato de Clave de Conta de Servizo de Google Calendar inválido",
                saveGapiKey: "Non se puido gardar a Clave de Conta de Servizo de Google Calendar",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Ligazóns de Axuda",
                logoUrl: "URL do Logo",
                css: "CSS Personalizado",
                displayName: "Nome visible",
                displayNameHelp: "O nome da organización nas mensaxes que a mencionan. Baleiro: o nome curto do arrendatario.",
            },
            errors: {
                invalidHelpLinks: "Formato de Ligazóns de Axuda inválido",
            },
        },
        electionTypeScreen: {
            noPermissions: "Non tes permiso para acceder ás configuracións.",
            common: {
                title: "Tipo de Elección",
                subtitle: "Configuración do tipo de elección",
                onlineVoting: "Votación en Liña",
                kioskVoting: "Votación en Quiosco",
                telephoneVoting: "Votación Telefónica",
                settingTitle: "Configuracións",
                settingSubtitle: "Configuración Xeral",
                createNew: "Crear Tipo de Elección",
                emptyHeader: "Aínda non hai Tipos de Elección.",
                emptyBody: "¿Queres crear un?",
            },
            create: {
                title: "Crear Tipo de Elección",
            },
            edit: {
                title: "Editar Tipo de Elección",
            },
            tabs: {
                votingChannels: "CANLES DE VOTACIÓN",
                electionTypes: "TIPOS DE ELECCIÓN",
                languages: "IDIOMAS",
                localization: "LOCALIZACIÓN",
                integrations: "Integracións",
                lookAndFeel: "Aspecto",
                schedules: "EVENTOS PROGRAMADOS",
                trustees: "FIDUCIARIOS",
                BackupRestore: "COPIA DE SEGURIDAD / RESTAURAR",
                logs: "Rexistros",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Aún no hay fideicomisarios.",
                createNew: "Crear fideicomisario",
                title: "Fideicomisario",
                subtitle: "Configuración del fideicomisario",
                emptyBody: "¿Quieres crear uno?",
            },
            create: {
                title: "Crear fideicomisario",
            },
            edit: {
                title: "Editar fideicomisario",
            },
        },
        scheduleScreen: {
            noPermissions: "Non tes permiso para acceder ás configuracións.",
            createScheduleSuccess: "Programación creada",
            createScheduleError: "Erro ao crear a programación",
            deleteScheduleSuccess: "Programación eliminada",
            deleteScheduleError: "Erro ao eliminar a programación",
            common: {
                title: "Programación",
                subtitle: "Configuración de programacións",
                createNew: "Crear Programación",
                emptyHeader: "Aínda non hai Programacións.",
                emptyBody: "¿Queres crear unha?",
            },
            create: {
                title: "Crear Programación",
                selectSchedule: "Seleccione unha programación da lista predefinida ou escriba unha personalizada",
            },
            edit: {
                title: "Editar Programación",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Bloqueo do sistema para a finalización das configuracións de votación por Internet",
                START_PRE_REGISTRATION_OVCS: "Inicio e fin da preinscrición para OVCS",
                END_PRE_REGISTRATION_OVCS: "Fin da preinscrición para OVCS",
                START_TEST_VOTING_PERIOD: "Inicio do período de votación de proba",
                END_TEST_VOTING_PERIOD: "Fin do período de votación de proba",
                START_INTERNET_VOTING_PERIOD: "Inicio do período de votación por Internet",
                END_INTERNET_VOTING_PERIOD: "Fin do período de votación por Internet",
                LAB_TEST: "Proba de Laboratorio",
                FIELD_TEST: "Proba de Campo",
                MOCK_ELECTIONS: "Eleccións Simuladas",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votos por día",
            votesOverTime: "Votos ao longo do tempo",
            timeResolution: "Resolución temporal",
            timeRange: "Intervalo de tempo",
            minute: "Minuto",
            hour: "Hora",
            day: "Día",
            votersByChannels: "Votantes por canle",
            voterLoginURL: "URL de Inicio de Sesión do Votante",
            voterEnrollURL: "URL de Rexistro do Votante",
            voterEnrollKioskURL: "Kiosk URL de inscripción de votantes",
            ballotBoxes: {
                show: "Amosar as urnas",
                loadError: "Non se puideron ler os selos das urnas. Recargue a páxina ou comprobe a conexión co servidor.",
                title: "Urnas",
                sealing: "A votación pechouse ás {{closed}}. As urnas sélanse cando remata o período de graza, ás {{deadline}}.",
                sealed: "A votación pechouse ás {{closed}}. As urnas están seladas: non se pode engadir, cambiar nin borrar ningunha papeleta.",
                failed: "A votación pechouse ás {{closed}}. Non se puido selar unha urna: segue bloqueada e a incidencia está nos rexistros.",
                closedBySignatures: "Pechada por {{names}} cos seus certificados, código de sinatura {{code}}.",
                closedByUser: "Pechada por {{username}}.",
                closedBySchedule: "Pechada polo peche programado da votación.",
                column: {
                    area: "Área",
                    status: "Estado",
                    inTheBox: "Na urna",
                    counted: "Contabilizadas",
                    sealedAt: "Selada",
                    sealHash: "Hash do selo",
                    record: "Acta de selado",
                },
                status: {
                    open: "Aberta",
                    sealing: "Selarase ás {{time}}",
                    publishing: "Selada, publicándose",
                    sealed: "Selada",
                    failed: "Sen selar: incidencia",
                    due: "Selándose agora",
                    overdue: "Selado atrasado",
                },
                help: {
                    publishing: "A urna está bloqueada e o seu selo está no taboleiro de anuncios. A súa acta de selado estase a publicar.",
                    counted: "Papeletas que contan: a última papeleta válida de cada votante elixible. As demais da urna foron substituídas por unha papeleta posterior do votante, descartadas ou emitidas por un votante non elixible.",
                },
                copyHash: "Copiar o hash do selo",
                copied: "Hash do selo copiado",
                copyError: "Non se puido copiar o hash do selo",
                notYet: "Aínda non",
                openRecord: "Abrir a acta de selado de {{area}}",
                downloadRecord: "Descargar a acta de selado de {{area}}",
                recordRestricted: "Restrinxida: pídella a un administrador que poida descargar documentos.",
                recordError: "Non se puido descargar a acta de selado. Téntao de novo.",
                recordMissing: "Falta o documento da acta de selado: comuníqueo como incidencia.",
                beforeClose: "A urna de cada área sélase cando se pecha a votación.",
                notStarted: "A votación aínda non se abriu. A urna de cada área sélase cando se pecha a votación.",
                openOn: "A votación está aberta en {{channels}}. A urna de cada área sélase cando se pecha a votación.",
                paused: "A votación está en pausa. A urna de cada área sélase cando se pecha a votación.",
                holding_one: "A canle {{channels}} está habilitada e sen pechar: deteñaa para selar as urnas.",
                holding_other: "As canles {{channels}} están habilitadas e sen pechar: deteñaas para selar as urnas.",
                sealingNow: "A votación pechouse ás {{closed}}. As urnas estanse a selar.",
                sealingPastGrace: "A votación pechouse ás {{closed}}. O período de graza rematou ás {{deadline}}; as urnas estanse a selar.",
                why: {
                    due: "Estase a selar: isto leva ata un minuto.",
                    channelOpen: "A canle {{channel}} segue habilitada e sen pechar: deteñaa para selar a urna.",
                    channelNotEnabled: "A canle {{channel}} non está pechada nin habilitada nesta elección: deteñaa para selar a urna.",
                    channelHasBallots: "A canle {{channel}} ten papeletas nesta urna e non está pechada: deteñaa para selar a urna.",
                    datafixVotes_one: "Hai {{count}} voto en curso en Datafix: a urna sélase cando se resolva.",
                    datafixVotes_other: "Hai {{count}} votos en curso en Datafix: a urna sélase cando se resolvan.",
                    sequencer_one: "Hai {{count}} papeleta que aínda non está no taboleiro de anuncios: a urna sélase cando o secuenciador a engada.",
                    sequencer_other: "Hai {{count}} papeletas que aínda non están no taboleiro de anuncios: a urna sélase cando o secuenciador as engada.",
                    stale: "Último intento ás {{time}}: é posible que o selador non estea en execución. Comprobe Beat e o worker de selado.",
                    notTried: "Aínda non se intentou: é posible que o selador non estea en execución. Comprobe Beat e o worker de selado.",
                    errorCategory: {
                        board: "O último intento non puido acceder ao taboleiro de anuncios; reinténtase cada minuto.",
                        census: "O último intento non puido ler a lista de votantes; reinténtase cada minuto.",
                        keystore: "O último intento non puido obter a chave de sinatura; reinténtase cada minuto.",
                        storage: "O último intento non puido subir a acta de selado ao almacenamento de ficheiros; reinténtase cada minuto.",
                        settings: "O último intento non puido ler a configuración da elección; reinténtase cada minuto.",
                        other: "O último intento fallou; reinténtase cada minuto. O rexistro do servizo ten os detalles.",
                        ballots: "O último intento atopou unha papeleta que aínda non se pode ler ou que segue en curso; reinténtase cada minuto.",
                        database: "O último intento non puido completarse na base de datos; reinténtase cada minuto.",
                    },
                },
                failure: {
                    ballotIdMismatch: "Unha papeleta non coincide co seu ID da papeleta.",
                    missingContent: "Unha papeleta non ten contido ou non ten ID da papeleta.",
                    unreadable: "Non se pode ler unha papeleta.",
                    inProgress: "Unha papeleta segue en curso.",
                    alreadyOnBoard: "Xa hai un selo desta urna no taboleiro de anuncios.",
                    noBoard: "O evento electoral non ten taboleiro de anuncios.",
                    unknownChannel: "Unha papeleta ten unha canle de votación descoñecida.",
                    unrecorded: "Unha papeleta non ten rexistro de voto no taboleiro de anuncios.",
                },
                incident: {
                    title_one: "Non se puido selar {{count}} urna",
                    title_other: "Non se puideron selar {{count}} urnas",
                    body: "Isto é unha incidencia: cada unha destas urnas segue bloqueada e non se pode escrutar. Siga o procedemento para un selado fallido.",
                    line: "{{election}}, {{area}}: {{reason}}",
                },
            },
            ipAddress: {
                emptyState: "Aínda non hai votos.",
                title: "Enderezos IP",
                ip: "IP",
                country: "País",
                VoteCount: "Contaxe de Votos",
                ElectionName: "Nome da Elección",
                VotersId: "ID dos Votantes",
            },
        },
        electionEventScreen: {
            dataUnavailable: "Os datos non están dispoñibles para este evento electoral.",
            noAccessibleTabs: "Non tes acceso a ningunha pestana dispoñible deste evento electoral.",
            common: {
                subtitle: "Configuración do evento electoral.",
                showMore: "Mostrar Máis",
                showLess: "Mostrar Menos",
                adminPortal: "Portal de Administración",
                allowPublishAfterLockdown: "Só permitir a publicación do evento electoral despois do bloqueo",
                reset: "Restablecer filtro personalizado",
            },
            edit: {
                general: "Xeral",
                dates: "Datas",
                customUrls: "Prefixo de URLs Personalizados",
                votingPeriod: "Período de Votación",
                language: "Idioma",
                allowed: "Canles de Votación Permitidas",
                materials: "Materiais de Soporte",
                ballotReceipts: "Recibos de papeleta",
                ballotDesign: "Deseño da Papeleta",
                templates: "Modelos",
                reorder: "Reordenar eleccións",
                advancedConfigurations: "Configuracións Avanzadas",
                importCandidates: "Importar Candidatos",
                custom_filters: "Filtros Personalizados",
                voter_authentication: "Autenticación de votantes",
                realm_attributes: "Atributos do realm de Keycloak",
                realm_attributes_load_error: "Erro ao cargar os atributos do realm de Keycloak",
                realm_attributes_update_error: "Erro ao actualizar os atributos do realm de Keycloak",
                realm_attributes_not_loaded: "Os atributos do realm de Keycloak non se cargaron; os cambios non se gardaron",
                password_policy: "Política de contrasinais",
                password_policy_load_error: "Erro ao cargar a política de contrasinais de Keycloak",
                password_policy_update_error: "Erro ao actualizar a política de contrasinais de Keycloak",
                password_policy_not_loaded: "A política de contrasinais de Keycloak non se cargou; os cambios non se gardaron",
            },
            customUrls: {
                login: "Iniciar Sesión",
                enrollment: "Rexistro",
            },
            localization: {
                emptyHeader: "Non se estableceron idiomas para o evento",
                selectLanguage: "Seleccionar Idioma",
                notify: {
                    success: "Localización actualizada correctamente",
                    error: "Fallou a actualización da localización",
                    duplicateKey: "Xa existe unha substitución con esta clave e ámbito do portal.",
                    invalidDateTimeFormat: "Formato de data/hora non válido. Usa os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm).",
                    invalidTimeZoneText: "Este texto debe conservar {{placeholders}}.",
                },
                common: {
                    title: "Localización",
                    subTitle: "Configuración de localización",
                },
                labels: {
                    key: "Clave",
                    scope: "Ámbito do portal",
                    value: "Valor",
                },
                scopes: {
                    legacy: "Herdado ({{portal}})",
                    global: "Global",
                    votingPortal: "Portal de votación",
                    ballotVerifier: "Verificador de papeletas",
                    resultsPortal: "Portal de resultados",
                    adminPortal: "Portal de administración",
                    templates: "Informes e mensaxes",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Lonxitude mínima",
                    maximumLength: "Lonxitude máxima",
                    includeUppercase: "Incluír letras maiúsculas",
                    includeLowercase: "Incluír letras minúsculas",
                    includeDigits: "Incluír díxitos",
                    includeSpecialCharacters: "Incluír caracteres especiais",
                    help: {
                        minimumLength: "O número mínimo de caracteres requiridos para o contrasinal.",
                        maximumLength: "O número máximo de caracteres permitidos para o contrasinal.",
                        includeUppercase: "O contrasinal debe incluír polo menos unha letra maiúscula.",
                        includeLowercase: "O contrasinal debe incluír polo menos unha letra minúscula.",
                        includeDigits: "O contrasinal debe incluír polo menos un díxito.",
                        includeSpecialCharacters: "O contrasinal debe incluír polo menos un carácter especial.",
                    },
                    notConfigured: "Non hai ningunha política de contrasinais configurada. Ao gardar aplicaranse os valores predeterminados que se mostran a continuación.",
                    errors: {
                        lengthRange: "As lonxitudes do contrasinal deben ser números enteiros entre 1 e 256.",
                        minimumExceedsMaximum: "A lonxitude mínima non pode superar a lonxitude máxima.",
                        characterClassRequired: "Seleccione polo menos unha clase de caracteres para o contrasinal.",
                    },
                },
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
                startDateTime: "Data e Hora de Inicio",
                endDateTime: "Data e Hora de Fin",
                language: "Idioma",
                votingChannels: "Canles de Votación",
                materialActivated: "Materiais de Soporte Activados",
                supportMaterialsPolicy: {
                    label: "Política de Materiais de Soporte",
                    helperText: "A opción Obrigatorio para Votar require que os votantes abran cada Material de Soporte e confirmen que o leron antes de poder votar.",
                    options: {
                        off: "Desactivado",
                        optional: "Opcional",
                        mandatory_for_voting: "Obrigatorio para Votar",
                    },
                },
                materialTitle: "Título",
                materialSubTitle: "Subtítulo",
                logoUrl: "URL do Logo",
                userVerification: "Pode introducir un modelo personalizado que se utilizará para verificar manualmente os votantes",
                redirectFinishUrl: "URL de Redirección ao Finalizar",
                kioskRedirectFinishUrl: "URL de Redirección ao Finalizar do Quiosco",
                css: "CSS Personalizado",
                skipElectionList: "Omitir Pantalla de Lista de Eleccións",
                showUserProfile: "Mostrar Perfil do Usuario",
                ballotReceipts: {
                    checksPeriod: {
                        policyLabel: "Período de comprobación dos votos emitidos",
                        helper: "Durante canto tempo os votantes poden localizar o seu voto emitido e imprimir o seu recibo no Portal de Votación.",
                        options: {
                            "unlimited": "Sen límite",
                            "until-date": "Ata unha data",
                        },
                    },
                    checksAvailableUntil: "Comprobacións dispoñibles ata ({{timezone}})",
                    checksAvailableUntilRequired: "Introduce a data e a hora ata a que se poden comprobar os votos.",
                },
                voterAccessibilitySettingsPolicy: {
                    policyLabel: "Axustes de accesibilidade do votante",
                    options: {
                        disabled: "Ocultar os axustes de accesibilidade",
                        enabled: "Ofrecer axustes de tamaño de texto, contraste, espazado e movemento",
                    },
                },
                audioInstructionsPolicy: {
                    policyLabel: "Instrucións en audio",
                    options: {
                        "disabled": "Sen instrucións en audio",
                        "recorded": "Só gravacións subidas",
                        "recorded-or-synthesized": "Gravacións subidas, ou a voz do navegador onde non haxa",
                    },
                },
                showCastVoteLogs: {
                    policyLabel: "Mostrar Tab de Logs de Votación",
                    options: {
                        "show-logs-tab": "Mostrar Tab de Logs de Votación",
                        "hide-logs-tab": "No Mostrar Tab de Logs de Votación",
                    },
                },
                lockdownState: {
                    since: "Bloqueado desde {{date}}.",
                    scheduledEnd: "Fin do bloqueo programado para {{date}}.",
                    endScheduled: "Hai un fin do bloqueo programado.",
                    noScheduledEnd: "Non hai un fin do bloqueo programado.",
                    banner: "Este evento electoral está bloqueado.",
                    policyLabel: "Estado de Bloqueo",
                    helperText: "Programe o inicio ou o fin do período de bloqueo para cambiar este estado.",
                    options: {
                        "locked-down": "Bloqueado",
                        "not-locked-down": "Non Bloqueado",
                    },
                },
                ballotBoxSealPolicy: {
                    policyLabel: "Política de Selado de Urnas",
                    helperText: "Cando se pecha a votación, a urna de cada área sélase: un hash asinado das súas papeletas publícase no taboleiro de anuncios, non se pode engadir, cambiar nin borrar ningunha papeleta e a votación non pode volver comezar.",
                    locked: "Non se pode cambiar despois de que se abra a votación.",
                    options: {
                        "seal-at-close": "Selar ao pechar",
                        "do-not-seal": "Non selar",
                    },
                    checking: "Comprobando se a votación se abriu…",
                    lockedUnknown: "Bloqueada: non se puideron ler as eleccións, polo que se descoñece se a votación se abriu.",
                    lockedOpened: "Bloqueada: a votación abriuse en {{names}}.",
                    lockedEvent: "Bloqueada: a votación abriuse neste evento electoral.",
                    refused: "A Política de Selado de Urnas non se pode cambiar despois de que se abra a votación.",
                    settingLocked: "Con Selar ao pechar, o selo depende desta opción.",
                    settingRefused: "Esta opción non se pode cambiar despois de que se abra a votación: con Selar ao pechar, o selo depende dela.",
                    boardRefused: "O taboleiro de anuncios do evento electoral non pode cambiar despois de que se abra a votación: con Selar ao pechar, os selos publícanse nel.",
                },
                ballotBoxSealRecordPolicy: {
                    policyLabel: "Acta de selado de urnas",
                    options: {
                        restricted: "Restrinxida",
                        public: "Pública",
                    },
                    help: {
                        restricted: "Só os administradores poden descargala; compártea cos observadores.",
                        public: "Calquera persoa cos identificadores do evento pode descargala, sen iniciar sesión; mostra como contou cada papeleta.",
                    },
                },
                decodedBallots: {
                    policyLabel: "Incluír papeletas descodificadas na base de datos de resultados",
                    options: { "included": "Incluír", "not-included": "Non incluír" },
                },
                fileIntegrityPolicy: {
                    policyLabel: "Integridade do ficheiro de votantes",
                    helperText: "Esixir o SHA-256 certificado de forma independente antes de importar votantes.",
                    options: {
                        OPTIONAL: "SHA-256 opcional",
                        REQUIRED_SHA256: "SHA-256 obrigatorio",
                    },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Pregunta única",
                        "multiple-contests": "Varias preguntas",
                    },
                    policyLabel: "Política de cifrado de pregunta",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Formato de data e hora do portal de votación",
                    helperText: 'Aplícase a todo o evento. Para substituílo por idioma, engade a clave "votingPortalDateTimeFormat" na pestana Localización usando os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Consulta a documentación para máis detalles.',
                    options: {
                        "legacy-gb-24h": "GB herdado 24 h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO local (yyyy-MM-dd HH:mm)",
                        "us-12h": "EE. UU. 12 h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (data media, hora curta)",
                        "date-only": "Date Only (sen hora)",
                        "custom": "Formato personalizado",
                    },
                    customFormat: {
                        label: "Formato de data e hora personalizado",
                        helperText: "Usa os tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Calquera outro carácter móstrase literalmente.",
                        invalid: "Formato non válido. Usa polo menos un dos tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Sen Conta Atrás",
                    COUNTDOWN: "Conta Atrás",
                    COUNTDOWN_WITH_ALERT: "Conta Atrás con Alerta",
                    sectionTitle: "Portal de Votación",
                    policyLabel: "Política de Conta Atrás do Portal de Votación",
                    coundownSecondsLabel: "tempo en segundos antes da expiración para mostrar a conta atrás",
                    alertSecondsLabel: "tempo en segundos antes da expiración para mostrar a alerta de peche de sesión",
                },
                voterSigningPolicy: {
                    "policyLabel": "Política de Firma de Votantes",
                    "no-signature": "Sin firma",
                    "with-signature": "Con firma",
                },
                receiptsPolicy: {
                    "policyLabel": "Recibos asinados pola urna",
                    "disabled": "Desactivado",
                    "signed-by-ballot-box": "Asinados pola urna",
                    "helperText": "Cando está activado, a urna almacena e asina cada papeleta na pantalla de revisión, e o votante ve un ID de papeleta só cando a urna a recibiu. Os votantes asinan as súas papeletas. Volva publicar as papeletas despois de cambialo.",
                    "lockedHelperText": "Non se pode cambiar unha vez iniciada a votación.",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Política de certificado dixital do votante",
                    enabled: "Habilitado",
                    disabled: "Deshabilitado",
                },
                enrollment: {
                    policyLabel: "Inscripción",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Política de cerimonias de chaves/reconto",
                    options: {
                        "automated-ceremonies": "Permitir cerimonias automáticas",
                        "manual-ceremonies": "Cerimonias manuais",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Reconto automático tras aprobar unha importación",
                    options: {
                        enabled: "Activado",
                        disabled: "Desactivado",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Política de Votación Ponderada",
                    options: {
                        "areas-weighted-voting": "Votación Ponderada por Áreas",
                        "voters-weighted-voting": "Votación Ponderada por Votantes",
                        "disabled-weighted-voting": "Votación Ponderada Desactivada",
                    },
                    noDelegated: "A Votación Ponderada por Votantes non pode combinarse co Voto Delegado",
                    noDecodedBallots: "A Votación Ponderada por Votantes non pode combinarse coa inclusión de papeletas descifradas nos resultados",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Política de Voto Delegado",
                    options: {
                        enabled: "Activado",
                        disabled: "Desactivado",
                    },
                },
                batchAnonymityPolicy: {
                    policyLabel: "Política de Anonimato de Lotes",
                    helperText: "Rexeitar detén o escrutinio cando o lote de papeletas dunha área ten menos de cinco votantes, ou difire do lote que outro escrutinio xa publicou para a mesma área e concurso.",
                    options: {
                        warn: "Advertir",
                        refuse: "Rexeitar",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Política de detección de idioma",
                    options: {
                        "browser-detect": "Detectar desde o navegador",
                        "force-default": "Forzar predeterminado",
                    },
                },
            },
            error: {
                endDate: "A data de fin debe ser posterior á data de inicio",
                startDate: "A data de inicio debe ser no futuro",
                noResult: "Aínda non hai Evento Electoral",
                endDateInvalid: "A data de fin debe ser no futuro",
            },
            voters: {
                title: "Votantes",
            },
            createElectionEventSuccess: "Evento Electoral creado",
            createElectionEventError: "Erro ao crear o evento electoral",
            ivr: {
                tabs: {
                    config: "Configuración",
                    blacklist: "Lista de bloqueo",
                    prompts: "Locucións",
                    emulator: "Emulador",
                },
                common: {
                    saveSuccess: "Gardado correctamente",
                    saveError: "Non se puido gardar",
                    deleteSuccess: "Eliminado correctamente",
                    deleteError: "Non se puido eliminar",
                },
                config: {
                    configuredPhone: "Número de teléfono configurado",
                    infoMsg: "Configure o fluxo do IVR e as súas propiedades a continuación. Para máis detalles, póñase en contacto con Sequent.",
                },
                prompts: {
                    emptyMsg: "Aínda non se creou ningunha mensaxe",
                    infoMsg: "Configure as mensaxes utilizadas polo IVR. As mensaxes de anuncio son obrigatorias, e as mensaxes do sistema pódense sobrescribir para os idiomas desexados. Admítese SSML, tamén para mesturar idiomas.",
                    editorTitle: "Mensaxe",
                    editorSubtitle: "Configuración da mensaxe",
                },
                blacklist: {
                    columns: {
                        phone: "Número de teléfono",
                        reason: "Motivo",
                        createdAt: "Creado o",
                        createdBy: "Creado por",
                        createdBefore: "Creado antes",
                        createdAfter: "Creado despois",
                    },
                    emptyMsg: "Non hai entradas na lista de bloqueo",
                    infoMsg: "Configure a lista de bloqueo do IVR. As chamadas destes números serán desconectadas automaticamente polo sistema.",
                    noFilterMatch: "Ningunha entrada coincide cos filtros indicados",
                    phoneRequired: "O número de teléfono é obrigatorio",
                },
                emulator: {
                    infoMsg: "Seleccione unha área e as eleccións desexadas para probar a sesión IVR.",
                    apiStatus: {
                        unavailable: "O sistema do emulador non está dispoñible na súa contorna",
                        loading: "Cargando o sistema do emulador",
                        error: "Erro ao cargar o sistema do emulador",
                    },
                    hints: {
                        title: "Suxestións",
                        publishRequired: "Calquera cambio realizado nas eleccións, nas preguntas ou nos candidatos debe publicarse primeiro para que estea dispoñible. No emulador só se utilizarán os estilos de papeleta publicados máis recentemente para a área correspondente.",
                        eventChangesImmediate: "Os cambios realizados no evento electoral, como a configuración IVR ou as modificacións das mensaxes, están dispoñibles inmediatamente ao reiniciar a sesión do emulador.",
                        credentials: 'O identificador de votante e o PIN válidos son "123" e "123".',
                    },
                    sendDtmf: "Enviar entrada DTMF",
                    keypadInput: "Entrada do teclado",
                    sendTimeout: "Enviar tempo de espera",
                    disconnected: "Desconectado",
                    startSession: "Iniciar unha nova sesión",
                    endSession: "Finalizar a sesión",
                    noStylesFound: "Non se atoparon estilos de papeleta publicados que coincidan coas súas seleccións",
                    inputPlaceholder: "Prema {{keys}} (tempo de espera={{timeout}} s)",
                    inputPlaceholderOr: "ou",
                    inputPlaceholderAnyKeys: "Introduza ata {{maxDigits}} díxitos (calquera díxito, tempo de espera={{timeout}} s)",
                    blacklistCaller: "Bloquear a persoa que chama",
                    elections: "Eleccións",
                    area: "Área",
                },
            },
            stats: {
                elegibleVoters: "Votantes Elixibles",
                voters: "Votantes Actuais",
                elections: "Eleccións",
                contests: "Preguntas",
                areas: "Áreas",
                sentEmails: "Correos enviados",
                sentSMS: "SMS enviados",
                calendar: {
                    title: "Calendario",
                    scheduled: "Programado",
                },
            },
            keys: {
                createNew: "Crear Cerimonia de Chaves",
                emptyHeader: "Aínda non hai Cerimonia de Chaves.",
                statusLabel: "Estado",
                waitingKeys: "Esperando a Xeración de Chaves...",
                started: "Iniciado o",
                actions: {
                    participate: "Participar na cerimonia de chaves",
                    view: "Ver a cerimonia de chaves",
                },
                breadCrumbs: {
                    configure: "Configurar",
                    ceremony: "Cerimonia",
                    created: "Finalizado",
                    start: "Inicio",
                    status: "Estado",
                    download: "Descargar",
                    check: "Verificar",
                    success: "Finalizado",
                },
                notify: {
                    participateNow: "Fostes invitado a participar nunha Cerimonia de Chaves. Por favor, <1>fai clic na Acción de Chave da cerimonia</1> para participar.",
                },
            },
            tabs: {
                dashboard: "Taboleiro",
                monitoring: "Monitoreo",
                data: "Datos",
                ivr: "IVR",
                localization: "Localización",
                voters: "Votantes",
                areas: "Áreas",
                keys: "Chaves",
                tally: "Escrutinio",
                tallySheetImports: "Importación de actas",
                publish: "Publicar",
                logs: "Rexistros",
                tasks: "Tarefas",
                events: "Eventos Programados",
                notifications: "Notificacións",
                reports: "Informes",
                approvals: "Aprobacións",
                cas: "Certificados",
            },
            tally: {
                emptyHeader: "Aínda non hai Escrutinio.",
                title: "Escrutinio do Evento Electoral",
                elections: "Eleccións",
                electionNumber: "Número de Eleccións",
                trustees: "Fiduciarios",
                status: "Estado",
                permissionLabels: "Etiquetas de Permisos",
                tallyType: {
                    label: "Tipo de Conteo",
                    ELECTORAL_RESULTS: "Resultados Electorales",
                    INITIALIZATION_REPORT: "Resultados de Inicialización",
                },
                create: {
                    title: "Crear Escrutinio",
                    subtitle: "Crear un novo Escrutinio para este Evento Electoral",
                    createTallyButton: "Iniciar Cerimonia de Escrutinio",
                    createInitializationReportButton: "Xerar Informe de Inicialización",
                    error: {
                        create: "Erro ao crear o Escrutinio",
                    },
                    success: "Escrutinio creado",
                },
                logs: {
                    noLogs: "Non hai rexistros dispoñibles",
                },
                notify: {
                    noKeysTally: "A Cerimonia de Escrutinio non pode comezar ata que a Cerimonia de Chaves se complete con éxito.",
                    noPublication: "A Cerimonia de Escrutinio non pode comezar ata que crees unha publicación na pestana Publicar.",
                    participateNow: "Fostes invitado a participar nunha Cerimonia de Escrutinio. Por favor, <1>fai clic na Acción de Chave da cerimonia</1> para participar.",
                    startDisabled: "No puedes continuar con la ceremonia porque no se han seleccionado elecciones o las elecciones no están publicadas.",
                    ceremonyDisabled: "No puedes continuar con la ceremonia porque la sesión de recuento no está conectada o el inicio de la ceremonia no está permitido.",
                },
            },
            importAreas: {
                title: "Importar Áreas",
                subtitle: "Importar datos de áreas",
                areaParagraph: "Importar áreas usando un ficheiro de folla de cálculo en formato CSV (Comma Separated Values).",
                importSuccess: "Áreas importadas correctamente",
                importError: "Erro ao importar as Áreas",
                upsert: "Actualizar ou Inserir Áreas",
            },
            import: {
                eetitle: "Importar Evento Electoral",
                eesubtitle: "Importar datos do evento electoral",
                title: "Importar Votantes",
                subtitle: "Importar datos de votantes",
                voters: "Votantes",
                votersParagraph: "Importar votantes usando un ficheiro de folla de cálculo en formato CSV (Comma Separated Values). Descarga un exemplo de ficheiro CSV de importación aquí.",
                electionEventParagraph: "Importar Eventos Electorais usando un ficheiro JSON.",
                elections: "Eleccións",
                areas: "Áreas",
                sha: "Verificación de Integridade (SHA-256)",
                cancel: "Cancelar",
                import: "Importar",
                fileUploadSuccess: "Ficheiro cargado no servidor - pero aínda non importado",
                fileUploadError: "Erro ao cargar o ficheiro",
                importVotersSuccess: "Importación de Votantes Programada Correctamente",
                importVotersError: "Erro ao importar os Votantes",
                importElectionEventSuccess: "Evento electoral importado correctamente",
                importElectionEventError: "Erro ao importar o evento electoral",
                shaRequiredHelp: "Introduza o SHA-256 hexadecimal certificado de 64 caracteres. É obrigatorio para importar.",
                shaDialog: {
                    ok: "Si, Importar sen Verificación de Integridade",
                    cancel: "Volver Atrás",
                    title: "¿Importar Sen Verificación de Integridade?",
                    description: "Non introduciu o campo de Verificación de Integridade (SHA-256). Por favor, confirme que está a importar o ficheiro correcto e que desexa importalo.",
                },
                passwordDialog: {
                    title: "Contrasinal de Descrifrado",
                    description: "Introduza o contrasinal para descifrar o ficheiro",
                    label: "Contrasinal",
                    copyPassword: "Copiar Contrasinal",
                    ok: "Aceptar",
                },
            },
            export: {
                title: "Exportar Evento Electoral",
                subtitle: "A exportación pode ser unha operación longa. ¿Estás seguro de que queres exportar os rexistros?",
                encryptWithPassword: "Cifrar con Contrasinal",
                passwordForcedNote: "O arquivo protexerase con contrasinal de todos os xeitos: os informes, as solicitudes e os datos do taboleiro cífranse sempre. Marca a caixa para incluír tamén os campos secretos de votante descifrados.",
                integrationSecrets: "Segredos de integración (credenciais de servizo)",
                integrationSecretsNote: "Unha vez descifrado, o arquivo conterá en claro o segredo de liveness de Scanovate. Garda en segredo o arquivo e o seu contrasinal, e impórtao só onde se deba usar ese servizo de Liveness Plus.",
                includeVoters: "Incluir Votantes",
                activityLogs: "Rexistros de Actividade",
                bulletinBoard: "Taboleiro de Anuncios",
                publications: "Publicacións",
                s3Files: "Ficheiros S3",
                scheduledEvents: "Eventos Programados",
                exportSuccess: "Evento Electoral exportado correctamente",
                exportError: "Erro ao exportar o Evento Electoral",
                passwordTitle: "Contrasinal",
                passwordDescription: "Contrasinal para descifrar o ficheiro:",
                copiedSuccess: "Contrasinal copiado ao portapapeis",
                copiedError: "Erro ao copiar o contrasinal",
                reports: "Informes",
                applications: "Aplicaciones",
                tally: "Recuento",
                certificates: "Certificados",
            },
            taskNotification: "{{action}} comezou. Podes ver o seu estado na táboa de Execución de Tarefas.",
        },
        electionScreen: {
            common: {
                title: "Elección",
                subtitle: "Configuración da elección.",
                fileLoaded: "Ficheiro cargado",
                noPermission: "Non tes permiso para acceder a esta elección.",
            },
            edit: {
                general: "Xeral",
                dates: "Datas",
                votingPeriod: "Período de Votación",
                language: "Idioma",
                allowed: "Canles de Votación Permitidas",
                default: "Predeterminado",
                defaultLang: "Idioma Predeterminado",
                receipts: "Recibos",
                image: "Imaxe",
                advanced: "Configuración Avanzada",
                numAllowedVotes: "Número de votos permitidos",
                reorder: "Reordenar preguntas",
                castVoteConfirm: "Modal de Confirmación de Voto Emitido",
                gracePeriodPolicy: "Período de Gracia",
                allowTallyPolicy: "Permitir Recuento",
                permissionLabel: "Etiqueta de Permiso",
                custom_filters: "Filtros Personalizados",
            },
            field: {
                name: "Nome",
                language: "Idioma",
                votingChannels: "Canles de Votación",
                startDateTime: "Data e Hora de Inicio",
                endDateTime: "Data e Hora de Fin",
                startDateTimeWithTimezone: "Data e Hora de Inicio ({{timezone}})",
                endDateTimeWithTimezone: "Data e Hora de Fin ({{timezone}})",
                scheduledOpening: "Apertura Programada",
                scheduledClosing: "Peche Programado",
                alias: "Alias",
                description: "Descrición",
                securityConfirmationHtml: "Confirmación de seguridade HTML",
                ivrPrompt: "Mensaxe IVR",
                externalId: "ID externo",
            },
            securityConfirmationPolicy: {
                label: "Política da caixa de confirmación de seguridade",
                none: "Ningún",
                mandatory: "Obrigatorio",
            },
            error: {
                fileError: "Erro ao cargar o ficheiro",
                fileLoaded: "Ficheiro cargado",
                endDate: "A data de fin debe ser posterior á data de inicio",
                startDate: "A data de inicio debe ser no futuro",
                endDateInvalid: "A data de fin debe ser no futuro",
            },
            createElectionEventSuccess: "Evento Electoral creado",
            createElectionEventError: "Erro ao crear o evento electoral",
            tabs: {
                dashboard: "Taboleiro",
                monitoring: "Monitoreo",
                data: "Datos",
                voters: "Votantes",
                publish: "Publicar",
                logs: "Rexistros",
                approvals: "Aprobacións",
                tallySheets: "Follas de recuento",
            },
            gracePeriodPolicy: {
                "label": "Política de Período de Gracia",
                "no-grace-period": "Sen período de gracia",
                "grace-period-without-alert": "Período de gracia sen alerta",
                "gracePeriodSecs": "Período de gracia en segundos",
            },
            allowTallyPolicy: {
                "allowed": "Permitido",
                "disallowed": "No permitido",
                "requires-voting-period-end": "Permitir cuando termine el periodo de votación",
            },
            initializeReportPolicy: {
                "label": "Política de Informe de Inicialización",
                "not-required": "Non Requirido",
                "required": "Requirido",
            },
            castVoteGoldLevelPolicy: {
                label: "Política de autenticación de nivel ouro",
                options: {
                    "gold-level": "Autenticación de nivel ouro",
                    "no-gold-level": "Sen autenticación de nivel ouro",
                },
            },
            slates: {
                title: "Candidaturas",
                configuration: "Configuración de candidaturas (JSON)",
                helper: "Candidaturas con nome e os candidatos que cada unha presenta en cada contenda. Déixao baleiro para unha elección sen candidaturas.",
                loading: "As contendas e os candidatos da elección aínda se están a cargar. Téntao de novo nun momento.",
                mobileCandidateLists: {
                    label: "Listas de candidatos no móbil",
                    helper: "Como aparece inicialmente a lista de candidatos de cada candidatura no móbil. O votante sempre pode abrila ou pechala.",
                    options: {
                        collapsed: "Contraídas",
                        expanded: "Despregadas",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Política de título da pantalla de inicio",
                options: {
                    "election": "Título da elección",
                    "election-event": "Título do evento electoral",
                },
            },
            consolidatedReportPolicy: {
                label: "Política de informe consolidado",
                options: {
                    "generate": "Xerar",
                    "do-not-generate": "Non xerar",
                },
            },
            declineToVotePolicy: {
                label: "Política de abstención de voto",
                options: {
                    enabled: "Activado",
                    disabled: "Desactivado",
                },
            },
            blankBallotsPolicy: {
                label: "Política de papeletas en branco",
                options: {
                    enabled: "Activado",
                    disabled: "Desactivado",
                },
            },
            votingScreenBackPolicy: {
                label: "Política do botón Atrás da pantalla de votación",
                options: {
                    "election-selection-screen": "Ir á pantalla de selección de eleccións",
                    "start-screen": "Ir á pantalla de inicio da elección",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Arrendatarios",
            },
            new: {
                subtitle: "Crear novo arrendatario",
            },
            createSuccess: "Arrendatario creado",
            createError: "Erro ao crear o arrendatario",
        },
        usersAndRolesScreen: {
            noPermissions: "Non tes permiso para acceder a usuarios ou roles.",
            common: {
                title: "Usuarios e Roles",
                subtitle: "Configuración xeral",
                mobileNumber: "Móbil",
            },
            editPassword: {
                passwordPolicyViolation: "O contrasinal non cumpre a Política de contrasinais deste evento electoral. Revise a política en Datos do evento electoral e introduza un contrasinal válido.",
                passwordPolicyRules: {
                    minimumLength: "A lonxitude mínima do contrasinal é {{count}}.",
                    maximumLength: "A lonxitude máxima do contrasinal é {{count}}.",
                    uppercase: "Caracteres en maiúscula requiridos: {{count}}.",
                    lowercase: "Caracteres en minúscula requiridos: {{count}}.",
                    digits: "Díxitos requiridos: {{count}}.",
                    specialCharacters: "Caracteres especiais requiridos: {{count}}.",
                },
                label: "Cambiar contrasinal",
                temporatyLabel: "Temporal",
                temporatyInfo: "Se está habilitado, o usuario debe cambiar o contrasinal no próximo inicio de sesión",
            },
            users: {
                title: "Usuarios",
                subtitle: "Ver e editar datos de usuarios",
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizacións antes de envialas.",
                    confirm: "Confirmar cambios",
                    noChanges: "Non hai cambios para revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Novo valor",
                },
                edit: {
                    title: "Datos do Usuario",
                    subtitle: "Ver e editar usuario",
                },
                create: {
                    title: "Usuario",
                    subtitle: "Crear usuario",
                },
                fields: {
                    "has_voted": "Votou",
                    "support_materials_viewed": "Materiais de Soporte Vistos",
                    "vote-weight": "Peso do voto",
                    "voted-channel": "Canle de voto",
                    "disable-comment": "Comentario de desactivación",
                    "username": "Nome de Usuario",
                    "first_name": "Nome",
                    "last_name": "Apelidos",
                    "email": "Correo Electrónico",
                    "enabled": "Activado",
                    "emailVerified": "Correo Verificado",
                    "groups": "Grupos",
                    "attributes": "Atributos",
                    "area": "Área",
                    "password": "Contrasinal",
                    "savePassword": "Guardar contraseña",
                    "repeatPassword": "Repetir Contrasinal",
                    "passwordMismatch": "Os contrasinais deben coincidir",
                    "passwordLengthValidate": "O contrasinal debe ter polo menos 8 caracteres",
                    "passwordUppercaseValidate": "O contrasinal debe conter polo menos unha letra maiúscula",
                    "passwordLowercaseValidate": "O contrasinal debe conter polo menos unha letra minúscula",
                    "passwordDigitValidate": "O contrasinal debe conter polo menos un díxito",
                    "passwordSpecialCharValidate": "O contrasinal debe conter polo menos un carácter especial",
                    "trustee": "Actuar como Fiduciario",
                    "permissionLabel": "Etiqueta de Permiso",
                    "authorized-election-ids": "Eleccións",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este usuario?",
                    bulkBody: "¿Estás seguro de que queres eliminar os usuarios seleccionados?",
                    bulkBodySelected: "¿Eliminar os {{count}} usuarios seleccionados? Esta acción non se pode desfacer.",
                    bulkBodyChoose: "Hai {{count}} usuarios seleccionados. No seu lugar, podes eliminar todos os usuarios que coinciden cos filtros actuais, que poden ser máis. Esta acción non se pode desfacer.",
                    okSelected: "Eliminar {{count}} seleccionados",
                    okAllMatching: "Eliminar todos os coincidentes",
                },
                notifications: {
                    exportError: "Erro ao exportar usuarios",
                    deleteError: "Erro ao eliminar o usuario",
                    deleteSuccess: "Usuario eliminado",
                    multipleDeleteSuccess: "Usuarios eliminados",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Carta de información para o votante",
                    generate: "Xerar",
                    confirmation: "Xerar unha Carta de información para este votante? Asignarase un novo contrasinal e incluirase nun PDF cifrado.",
                    generationStarted: "Iniciouse a xeración da Carta de información",
                    generationError: "Non se puido xerar a Carta de información",
                    policyNotConfigured: "A Política de contrasinais non está configurada. Configúrea en Datos do evento electoral antes de xerar unha carta.",
                    policyMinimumLengthMissing: "A Política de contrasinais debe incluír unha lonxitude mínima antes de xerar unha carta.",
                    policyCharacterClassMissing: "A Política de contrasinais debe incluír polo menos unha clase de caracteres antes de xerar unha carta.",
                },
                title: "Votantes",
                subtitle: "Ver e editar datos de votantes",
                secretAttribute: {
                    storedPlaceholder: "Valor cifrado almacenado",
                    reveal: "Mostrar",
                    hide: "Ocultar",
                    revealError: "Non se puido mostrar o campo cifrado do votante",
                    includeInExport: "Incluír campos secretos descifrados do votante",
                    exportWarning: "Exportación sensible: o CSV descargado conterá estes campos en texto plano.",
                    clear: "Borrar",
                    add: "Engadir valor",
                    remove: "Eliminar valor",
                },
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizacións antes de envialas.",
                    confirm: "Confirmar cambios",
                    noChanges: "Non hai cambios para revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Novo valor",
                },
                logs: {
                    label: "Rexistros do Usuario",
                },
                create: {
                    title: "Votante",
                    subtitle: "Crear Votante",
                },
                manualVerification: {
                    label: "Verificar Manualmente",
                    verify: "Verificar manualmente este votante",
                    body: "Verificar manualmente este votante. Obterás un PDF cunha ligazón de código QR que permite ao votante iniciar sesión omitindo o KYC en liña.",
                    noEmailOrPhone: "Este votante no puede ser verificado manualmente porque no tiene una dirección de correo electrónico o un número de teléfono asociado a él.",
                },
                emptyHeader: "Aínda non hai votantes.",
                askCreate: "¿Queres crear un?",
                errors: {
                    editError: "Erro ao editar o votante",
                    editErrorReason: "Erro ao editar o votante: {{reason}}",
                    editSuccess: "Votante editado",
                    createError: "Erro ao crear o votante",
                    createErrorReason: "Erro ao crear o votante: {{reason}}",
                    createSuccess: "Votante creado",
                    attribute: {
                        invalidNamed: 'Rexeitouse "{{field}}": {{constraint}}',
                        fieldsToCorrect: "Algúns campos deben corrixirse antes de gardar",
                        hintBetween: "Entre {{min}} e {{max}} caracteres",
                        hintMin: "Polo menos {{min}} caracteres",
                        hintMax: "Como máximo {{max}} caracteres",
                        andMore: "e {{count}} máis",
                        invalidLength: '"{{field}}" debe ter entre {{min}} e {{max}} caracteres',
                        tooShort: '"{{field}}" debe ter polo menos {{min}} caracteres',
                        tooLong: '"{{field}}" debe ter como máximo {{max}} caracteres',
                        required: '"{{field}}" é obrigatorio',
                        invalidEmail: '"{{field}}" debe ser un enderezo de correo electrónico válido',
                        invalidFormat: '"{{field}}" non ten o formato esperado',
                        invalid: '"{{field}}" ten un valor non válido',
                    },
                    createPasswordError: "Votante creado, pero non se puido establecer o seu contrasinal",
                    createPasswordErrorReason: "Votante creado, pero non se puido establecer o seu contrasinal: {{reason}}",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este votante?",
                    bulkBody: "¿Estás seguro de que queres eliminar os votantes seleccionados?",
                    bulkBodySelected: "¿Eliminar os {{count}} votantes seleccionados? Esta acción non se pode desfacer.",
                    bulkBodyChoose: "Hai {{count}} votantes seleccionados. No seu lugar, podes eliminar todos os votantes que coinciden cos filtros actuais, que poden ser máis. Esta acción non se pode desfacer.",
                    okSelected: "Eliminar {{count}} seleccionados",
                    okAllMatching: "Eliminar todos os coincidentes",
                },
                notifications: {
                    exportError: "Erro ao exportar votantes",
                    deleteError: "Erro ao eliminar o votante",
                    deleteSuccess: "Votante eliminado",
                    multipleDeleteSuccess: "Votantes eliminados",
                    manualVerificationError: "Erro ao verificar manualmente o votante",
                    manualVerificationSuccess: "Votante verificado manualmente con éxito, descargando PDF...",
                },
            },
            roles: {
                title: "Roles",
                edit: {
                    title: "Datos do Rol",
                    subtitle: "Ver e editar rol",
                },
                create: {
                    title: "Rol",
                    subtitle: "Crear rol",
                },
                errors: {
                    createError: "Erro ao crear o rol",
                    createSuccess: "Rol creado",
                },
                fields: {
                    name: "Nome",
                },
                delete: {
                    body: "¿Estás seguro de que queres eliminar este rol?",
                },
                notifications: {
                    deleteError: "Erro ao eliminar o rol",
                    deleteSuccess: "Rol eliminado",
                    permissionEditError: "Erro ao editar o permiso",
                    permissionEditSuccess: "Permiso editado",
                },
            },
            permissions: {
                "voter-information-letter": "Xerar Carta de información para o votante",
                "admin-user": "Administración",
                "admin-dashboard-view": "Vista del Panel de Administración",
                "monitoring-view": "Ver Paneis de Monitorización",
                "monitoring-configure": "Configurar Paneis de Monitorización",
                "election-event-signatures-tab": "Lapela Sinaturas do Evento Electoral",
                "signing-rules-read": "Sinaturas: ver accións protexidas",
                "signing-rules-write": "Sinaturas: editar accións protexidas",
                "signing-certificates-read": "Sinaturas: ver certificados",
                "signing-issuers-write": "Sinaturas: importar e eliminar emisores de confianza",
                "signing-checks-write": "Sinaturas: editar comprobacións de certificados",
                "signing-certificates-register": "Sinaturas: rexistrar certificados",
                "signing-certificates-revoke": "Sinaturas: revogar certificados",
                "signing-requests-read": "Sinaturas: ver solicitudes",
                "signing-requests-cancel": "Sinaturas: cancelar solicitudes",
                "signing-requests-export": "Sinaturas: exportar solicitudes",
                "sign-initialize-voting": "Asinar: inicializar a votación",
                "sign-open-voting": "Asinar: abrir a votación",
                "sign-close-voting": "Asinar: pechar a votación",
                "sign-generate-election-returns": "Asinar: xerar actas electorais",
                "sign-generate-reports": "Asinar: xerar outros informes electorais",
                "sign-transmit-results": "Asinar: transmitir resultados",
                "sign-approve-voter": "Asinar: aprobar manualmente un votante",
                "sign-approve-configuration": "Asinar: aprobar unha versión de configuración",
                "sign-key-ceremony": "Asinar: confirmar un fragmento de chave",
                "sign-tally-key": "Asinar: achegar un fragmento de chave",
                "application-export": "Exportación de Aplicaciones",
                "application-import": "Importación de Aplicaciones",
                "tenant-create": "Crear Inquilino",
                "tenant-read": "Leer Inquilino",
                "tenant-write": "Editar Inquilino",
                "tenant-delete": "Eliminar Inquilino",
                "election-event-create": "Crear Evento Electoral",
                "election-event-read": "Leer Evento Electoral",
                "election-event-write": "Editar Evento Electoral",
                "keycloak-realm-attributes-read": "Ler atributos do realm de Keycloak",
                "keycloak-realm-attributes-write": "Editar atributos do realm de Keycloak",
                "election-event-delete": "Eliminar Evento Electoral",
                "voter-create": "Crear Votante",
                "voter-read": "Leer Votante",
                "voter-write": "Editar Votante",
                "voter-secret-attribute-read": "Mostrar Campos Secretos do Votante",
                "voter-secret-attribute-write": "Editar Campos Secretos do Votante",
                "integration-secret-read": "Exportar Segredos de Integración",
                "user-create": "Crear Usuario",
                "user-read": "Leer Usuario",
                "user-write": "Editar Usuario",
                "user-permission-create": "Crear Permiso de Usuario",
                "user-permission-read": "Leer Permiso de Usuario",
                "user-permission-write": "Editar Permiso de Usuario",
                "role-create": "Crear Rol",
                "role-read": "Leer Rol",
                "role-write": "Editar Rol",
                "role-assign": "Asignar Rol",
                "communication-template-create": "Crear Plantilla de Comunicación",
                "communication-template-read": "Leer Plantilla de Comunicación",
                "communication-template-write": "Editar Plantilla de Comunicación",
                "notification-read": "Leer Notificación",
                "notification-write": "Editar Notificación",
                "notification-send": "Enviar Notificación",
                "area-read": "Leer Área",
                "area-write": "Editar Área",
                "election-state-write": "Editar Estado de Elección",
                "election-type-create": "Crear Tipo de Elección",
                "election-type-read": "Leer Tipo de Elección",
                "election-type-write": "Editar Tipo de Elección",
                "voting-channel-read": "Leer Canal de Votación",
                "voting-channel-write": "Editar Canal de Votación",
                "trustee-create": "Crear Fideicomisario",
                "trustee-read": "Leer Fideicomisario",
                "trustee-write": "Editar Fideicomisario",
                "tally-read": "Leer Recuento",
                "tally-start": "Iniciar Recuento",
                "tally-write": "Editar Recuento",
                "tally-results-read": "Leer Resultados de Recuento",
                "publish-read": "Leer Publicación",
                "publish-write": "Editar Publicación",
                "publish-results-read": "Leer Publicación de Resultados",
                "publish-results-write": "Editar Publicación de Resultados",
                "logs-read": "Leer Registros",
                "electoral-log-audit": "Auditar Rexistro Electoral",
                "electoral-log-console-read": "Explorar Rexistro Electoral",
                "electoral-log-console-query": "Consultar Rexistro Electoral",
                "electoral-log-personal-data-read": "Ler Datos Persoais do Rexistro Electoral",
                "task-queues-read": "Ler Colas de Tarefas",
                "task-queues-write": "Xestionar Colas de Tarefas",
                "task-queues-query": "Consultar Colas de Tarefas",
                "tasks-read": "Leer la Ejecución de Tareas",
                "keys-read": "Leer Claves",
                "document-upload": "Subir Documentos",
                "document-download": "Descargar Documentos",
                "document-password-read": "Ler contrasinais de documentos",
                "tally-sheet-create": "Crear Acta de Recuento",
                "tally-sheet-import-create": "Crear importación de actas de reconto",
                "tally-sheet-import-review": "Revisar importación de actas de reconto",
                "tally-sheet-import-view": "Ver importación de actas de reconto",
                "tally-recount-execute": "Executar reconto de resultados",
                "trustee-ceremony": "Ceremonia de Fideicomisario",
                "tally-sheet-review": "Revisar folla de reconto",
                "tally-sheet-view": "Ver Acta de Recuento",
                "admin-ceremony": "Administrar Ceremonia de Claves",
                "tally-sheet-delete": "Borrar Acta de Recuento",
                "document-read": "Leer Documentos",
                "document-write": "Editar Documentos",
                "support-material-read": "Leer Materiales de Soporte",
                "support-material-write": "Editar Materiales de Soporte",
                "miru-create": "Crear Miru",
                "miru-download": "Descargar Miru",
                "miru-send": "Enviar Miru",
                "miru-sign": "Asinar Miru",
                "contest-write": "Editar Pregunta",
                "contest-read": "Ler Pregunta",
                "candidate-write": "Editar Candidatos",
                "candidate-read": "Leer Candidatos",
                "permission-label-write": "Editar la etiqueta de permiso",
                "scheduled-event-write": "Editar Eventos Programados",
                "contest-create": "Crear Pregunta",
                "contest-delete": "Eliminar Pregunta",
                "candidate-create": "Crear Candidato",
                "candidate-delete": "Eliminar Candidato",
                "election-create": "Crear Elección",
                "election-read": "Ler Elección",
                "election-write": "Editar Elección",
                "election-delete": "Eliminar Elección",
                "election-event-archive": "Arquivar Evento Electoral",
                "election-data-tab": "Ver Datos de la Elección",
                "election-event-areas-tab": "Ver Áreas del Evento Electoral",
                "election-event-data-tab": "Ver Datos del Evento Electoral",
                "election-event-keys-tab": "Ver Claves del Evento Electoral",
                "election-event-logs-tab": "Ver Registros del Evento Electoral",
                "election-event-publish-tab": "Ver Publicación del Evento Electoral",
                "election-event-reports-tab": "Ver Informes del Evento Electoral",
                "election-event-scheduled-tab": "Ver Programación del Evento Electoral",
                "election-event-tally-tab": "Ver Escrutinio del Evento Electoral",
                "election-event-tasks-tab": "Ver Tareas del Evento Electoral",
                "election-event-voters-tab": "Ver Votantes del Evento Electoral",
                "election-publish-tab": "Ver Publicación de la Elección",
                "election-voters-tab": "Ver Votantes de la Elección",
                "report-write": "Editar Informes",
                "report-read": "Leer Informes",
                "users-menu": "Ver usuarios y roles",
                "settings-menu": "Ver configuración",
                "templates-menu": "Ver plantillas",
                "settings-election-types-tab": "Ver configuración de tipos de elección",
                "settings-voting-channels-tab": "Ver configuración de canales de votación",
                "settings-templates-tab": "Ver configuración de plantillas",
                "settings-languages-tab": "Ver configuración de idiomas",
                "settings-localization-tab": "Ver configuración de localización",
                "settings-look-feel-tab": "Ver configuración de apariencia",
                "settings-trustees-tab": "Ver configuración de fideicomisarios",
                "settings-countries-tab": "Ver configuración de países",
                "voter-import": "Importar Votante",
                "ee-voters-columns": "Ver Columnas de Votantes del Evento Electoral",
                "voter-manually-verify": "Verificar Votante Manualmente",
                "ee-voters-logs": "Ver Registros de Votantes del Evento Electoral",
                "voter-export": "Exportar Votante",
                "ee-voters-filters": "Ver Filtros de Votantes del Evento Electoral",
                "voter-delete": "Eliminar Votante",
                "voter-change-password": "Cambiar la Contraseña del Votante",
                "election-event-localization-selector": "Selector de Localización del Evento Electoral",
                "localization-create": "Crear Localización",
                "localization-read": "Leer Localización",
                "localization-write": "Editar Localización",
                "localization-delete": "Eliminar Localización",
                "area-create": "Crear Área",
                "area-delete": "Eliminar Área",
                "area-export": "Exportar Área",
                "area-import": "Importar Área",
                "area-upsert": "Insertar o Actualizar Área",
                "election-event-areas-columns": "Columnas de las Áreas del Evento Electoral",
                "election-event-areas-filters": "Filtros de las Áreas del Evento Electoral",
                "election-event-tasks-back-button": "Volver a las Tareas del Evento Electoral",
                "election-event-tasks-columns": "Columnas de las Tareas del Evento Electoral",
                "election-event-tasks-filters": "Filtros de las Tareas del Evento Electoral",
                "task-export": "Exportar Tareas",
                "application-read": "Leer Aplicación",
                "application-write": "Editar Aplicación",
                "approval-matrix-write": "Editar a Matriz de Aprobación",
                "readiness-check": "Verificar a preparación electoral",
                "forensic-read": "Ler datos forenses de rede illados",
                "voter-pseudonym-resolve": "Resolver un pseudónimo de votante cun motivo auditado",
                "logs-export": "Exportar Registros",
                "tenant-logs-read": "Ler Rexistro do Inquilino",
                "tenant-logs-export": "Exportar Rexistro do Inquilino",
                "election-event-logs-columns": "Columnas de los Registros del Evento Electoral",
                "election-events-logs-filters": "Filtros de los Registros del Evento Electoral",
                "election-event-scheduled-event-columns": "Columnas de los Eventos Programados del Evento Electoral",
                "scheduled-event-create": "Crear Evento Programado",
                "scheduled-event-delete": "Eliminar Evento Programado",
                "election-event-reports-columns": "Columnas de los Informes del Evento Electoral",
                "report-create": "Crear Informe",
                "report-delete": "Eliminar Informe",
                "report-generate": "Generar Informe",
                "report-preview": "Vista Previa del Informe",
                "monitor-authenticated-voters": "Monitoreo de Votantes Autenticados",
                "monitor-all-approve-disapprove-voters": "Leer Monitoreo de Votantes Aprobados y Rechazados",
                "monitor-automatic-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Automáticos",
                "monitor-manually-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Manuales",
                "monitor-enrolled-overseas-voters": "Leer Monitoreo de Votantes Inscritos en el Extranjero",
                "monitor-posts-already-closed-voting": "Leer Monitoreo de Publicaciones con Votación Cerrada",
                "monitor-posts-already-generated-election-results": "Leer Monitoreo de Publicaciones con Resultados Generados",
                "monitor-posts-already-opened-voting": "Leer Monitoreo de Publicaciones con Votación Abierta",
                "monitor-posts-already-started-counting-votes": "Leer Monitoreo de Publicaciones que Comenzaron a Contar Votos",
                "monitor-posts-initialized-the-system": "Leer Monitoreo de Publicaciones que Inicializaron el Sistema",
                "monitor-posts-started-voting": "Leer Monitoreo de Publicaciones que Comenzaron a Votar",
                "monitor-posts-transmitted-results": "Leer Monitoreo de Publicaciones que Transmitieron Resultados",
                "monitor-voters-voted-test-election": "Leer Monitoreo de Votantes en Elección de Prueba",
                "monitor-voters-who-voted": "Leer Monitoreo de Votantes que Votaron",
                "election-event-publish-preview": "Vista Previa de la Publicación del Evento Electoral",
                "election-event-publish-back-button": "Volver a la Publicación del Evento Electoral",
                "election-event-publish-columns": "Columnas de la Publicación del Evento Electoral",
                "election-event-publish-filters": "Filtros de la Publicación del Evento Electoral",
                "publish-create": "Crear Publicación",
                "publish-regenerate": "Regenerar Publicación",
                "publish-export": "Exportar Publicación",
                "publish-start-voting": "Iniciar Votación",
                "publish-pause-voting": "Pausar Votación",
                "publish-stop-voting": "Detener Votación",
                "publish-changes": "Publicar Cambios",
                "election-event-publish-view": "Ver Publicación del Evento Electoral",
                "election-event-keys-columns": "Columnas de las Claves del Evento Electoral",
                "create-ceremony": "Crear Ceremonia",
                "export-ceremony": "Exportar Ceremonia",
                "election-event-tally-columns": "Columnas del Recuento del Evento Electoral",
                "election-event-tally-back-button": "Volver al Recuento del Evento Electoral",
                "transmition-ceremony": "Ceremonia de Transmisión",
                "admin-ip-address-view": "Ver Dirección IP",
                "election-approvals-tab": "Ver Aprobaciones de la Elección",
                "election-event-approvals-tab": "Ver Aprobaciones del Evento Electoral",
                "election-ip-address-view": "Ver Dirección IP de la Elección",
                "election-dashboard-tab": "Ver Dashboard de la Elección",
                "trustees-export": "Exportar Fideicomisarios",
                "user-import": "Importar Usuarios",
                "voter-voted-edit": "Editar a los votantes que votaron",
                "voter-email-tlf-edit": "Editar email/teléfono de los votantes",
                "cloudflare-write": "Editar las reglas de bloqueo por país en Cloudflare",
                "transmission-report-generate": "Generar Informe de Transmisión",
                "google-meet-link": "Xerar Ligazón de Google Meet",
                "service-account": "Conta de servizo",
                "datafix-account": "Conta de corrección de datos",
                "gold": "Ouro",
                "silver": "Prata",
                "election-event-ivr-tab": "Ver IVR do evento electoral",
                "election-event-cas-tab": "Ver CAS do evento electoral",
                "ca-read": "Consultar autoridades de certificación",
                "ca-write": "Editar autoridades de certificación",
                "generate-preview": "Xerar vista previa",
                "preview-read": "Consultar vista previa",
                "tally-resolution-submit": "Enviar resolución do escrutinio",
                "phone-blacklist-read": "Consultar lista negra de teléfonos",
                "phone-blacklist-create": "Crear entradas na lista negra de teléfonos",
                "phone-blacklist-update": "Editar entradas da lista negra de teléfonos",
                "phone-blacklist-delete": "Eliminar entradas da lista negra de teléfonos",
                "election-event-voter-list-reconciliation": "Reconciliar a lista de votantes do evento electoral",
                "messaging-account-read": "Ver contas de mensaxería",
                "messaging-account-write": "Xestionar contas de mensaxería",
                "messaging-config-write": "Configurar a mensaxería do evento electoral",
                "messaging-config-read": "Ver a mensaxería do evento electoral",
            },
        },
        generalSettingsScreen: {
            body: "Activa idiomas no sistema. Só os idiomas activados aquí estarán dispoñibles para eventos electorais.",
        },
        eventsScreen: {
            title: "Eventos Programados",
            subtitle: "Xestiona a configuración da execución automática de eventos como o inicio ou fin do período de votación.",
            messages: {
                createSuccess: "Evento Programado creado correctamente",
                createError: "Erro ao crear o Evento Programado",
                editSuccess: "Evento Programado editado correctamente",
                editError: "Erro ao editar o Evento Programado",
                onlineWithEarlyVoting: "Unha programación de inicio non pode abrir á vez o voto en liña e o voto anticipado: o voto anticipado debe comezar antes ca o voto en liña.",
            },
            eventType: {
                label: "Tipo",
                ALLOW_INIT_REPORT: "Permitir Informe de Inicialización",
                START_VOTING_PERIOD: "Inicio do Período de Votación",
                END_VOTING_PERIOD: "Fin do Período de Votación",
                ALLOW_VOTING_PERIOD_END: "Permitir Fin do Período de Votación",
                START_ENROLLMENT_PERIOD: "Inicio do Período de Rexistro",
                END_ENROLLMENT_PERIOD: "Fin do Período de Rexistro",
                START_LOCKDOWN_PERIOD: "Inicio do Período de Bloqueo",
                END_LOCKDOWN_PERIOD: "Fin do Período de Bloqueo",
                ALLOW_TALLY: "Permitir Recuento",
                START_READINESS_TEST: "Iniciar proba de preparación electoral",
                END_READINESS_TEST: "Finalizar proba de preparación electoral",
                START_FINAL_TESTING: "Iniciar probas finais e bloqueo",
                END_FINAL_TESTING: "Finalizar probas finais e bloqueo",
                START_TEST_VOTING: "Iniciar votación de proba",
                END_TEST_VOTING: "Finalizar votación de proba",
            },
            warning: {
                votingWindowDays: "O período de votación de {{election}} abrangue {{days}} días locais (do {{start_local}} ao {{end_local}}, {{time_zone}}); a regra pide {{expected}}.",
                finalTestingLeadTime: "As probas finais de {{election}} comezan o {{final_testing_local}}, menos de {{minimum_days}} días antes de que se abra a votación o {{voting_start_local}} ({{time_zone}}).",
                closeBeforeOpen: "A votación de {{election}} péchase antes ou no momento de abrirse ({{start_local}} a {{end_local}}, {{time_zone}}).",
                shortLastDay: "O último día de votación de {{election}} ten {{hours}} horas, menos de {{minimum_hours}}: a votación péchase o {{end_local}} ({{time_zone}}).",
            },
            election: {
                label: "Elección",
            },
            empty: {
                header: "Aínda non hai Eventos Programados.",
                body: "¿Queres crear un?",
                button: "Crear Evento Programado",
            },
            create: {
                title: "Crear Evento Programado",
                subtitle: "Crear unha nova configuración de Evento Programado.",
            },
            edit: {
                title: "Editar Evento Programado",
                subtitle: "Editar configuración do Evento Programado.",
                delete: "¿Estás seguro de que queres eliminar este Evento Programado?",
            },
            fields: {
                electionId: "Elección",
                eventProcessor: "Tipo",
                stoppedAt: "Detido o",
                scheduledDate: "Programado para",
            },
        },
        reportsScreen: {
            title: "Informes",
            subtitle: "Xerar informes para os eventos electorais",
            messages: {
                createSuccess: "Informe creado correctamente",
                createError: "Erro ao crear o Informe",
                submitError: "Erro ao enviar o Informe",
                updateSuccess: "Informe actualizado correctamente",
                passwordMismatch: "Las contraseñas no coinciden. Asegúrate de que ambos campos contengan la misma contraseña.",
                incorectPassword: "Contraseña incorrecta",
                decryptFileTitle: "Descifrar archivo",
                decryptInstructions: "1. '-in': La ruta al archivo cifrado. \n2. '-out': La ruta donde se guardará el archivo descifrado. \n3. '-pass': La contraseña utilizada para cifrar el archivo. \n",
                encryptSuccess: "Configuración do cifrado do informe realizada con éxito",
                encryptError: "Erro ao configurar o cifrado do informe",
            },
            reportType: {
                BALLOT_RECEIPT: "Recibo da Papeleta",
                ELECTORAL_RESULTS: "Resultados Electorais",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
                STATISTICAL_REPORT: "Informe Estatístico",
                OVCS_EVENTS: "Monitorización de Votación no Estranxeiro - Eventos OVCS",
                AUDIT_LOGS: "Rexistros de Auditoría",
                ACTIVITY_LOG: "Rexistro de Actividade",
                STATUS: "Estado",
                OVCS_INFORMATION: "Información de OVCS",
                OVERSEAS_VOTERS: "Lista de votantes no estranxeiro",
                OV_USERS_WHO_VOTED: "Lista de Votantes no Estranxeiro que Votaron",
                OV_WITH_VOTING_STATUS: "Lista de Votantes en el Extranjero con Estado de Votación",
                OVCS_STATISTICS: "Monitorización de Votación no Estranxeiro - Estatísticas OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Lista de Votantes no Estranxeiro que se Preinscribiron pero Non Aprobados",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Lista de Votantes no Estranxeiro que se Preinscribiron pero suxeitos a Validación Manual",
            },
            reportEncryptionPolicy: {
                title: "Política de cifrado",
                UNENCRYPTED: "Sin cifrar",
                CONFIGURED_PASSWORD: "Contraseña configurada",
            },
            empty: {
                header: "Aínda non hai Informes.",
                body: "¿Queres crear un?",
                button: "Crear Informe",
            },
            create: {
                title: "Crear Informe",
                subtitle: "Crear unha nova configuración de Informe.",
            },
            edit: {
                title: "Editar Informe",
                subtitle: "Editar configuración do Informe.",
                delete: "¿Estás seguro de que queres eliminar este Informe?",
            },
            fields: {
                electionId: "Elección",
                template: "Modelo",
                reportType: "Tipo de Informe",
                repeatable: "Repetible",
                cronExpression: "Expresión Cron",
                emailRecipients: "Destinatarios de Correo",
                emailRecipientsPlaceholder: "Escribe o correo e presiona Enter",
            },
            delete: {
                body: "¿Estás seguro de que queres eliminar este Informe?",
            },
            actions: {
                generate: "Xerar",
                delete: "Eliminar",
                edit: "Editar",
                preview: "Vista Previa",
            },
        },
        googleMeet: {
            title: "Xerar Ligazón de Google Meet",
            generateButton: "Google Meet",
            meetingTitle: "Título da Reunión",
            description: "Descrición (Opcional)",
            startDate: "Data de Inicio",
            startTime: "Hora de Inicio",
            duration: "Duración (minutos)",
            attendeeEmails: "Emails dos Participantes",
            attendeeEmailHelp: "Emails separados por comas para os participantes da reunión",
            note: "Nota: Isto creará un evento de calendario no teu Google Calendar cun enlace de Google Meet. Necesitarás iniciar sesión na túa conta de Google.",
            success: "Ligazón de Google Meet Xerada con Éxito!",
            copy: "Copiar ao portapapeis",
            copied: "Ligazón copiada ao portapapeis!",
            instructions: "Comparte esta ligazón cos participantes para unirse á reunión. O evento de calendario foi engadido ao teu Google Calendar.",
            generating: "Xerando...",
            generate: "Xerar Ligazón de Meet",
        },
        common: {
            export: "A exportación pode ser unha operación longa. ¿Estás seguro de que queres exportar os rexistros?",
            resources: {
                electionEvent: "Evento Electoral",
                election: "Elección",
                contest: "Pregunta",
                candidate: "Candidato",
                noResult: {
                    askCreate: "¿Queres crear un?",
                },
            },
            label: {
                add: "Engadir",
                actions: "Accións",
                create: "Crear",
                delete: "Eliminar",
                archive: "Arquivar",
                unarchive: "Desarquivar",
                cancel: "Cancelar",
                edit: "Editar",
                yes: "Si",
                no: "Non",
                save: "Gardar",
                close: "Pechar",
                back: "Atrás",
                next: "Seguinte",
                warning: "Aviso",
                json: "Vista Previa",
                noResult: "Sen resultados",
                import: "Importar",
                export: "Exportar",
                loadingData: "Cargando datos...",
                exportFormat: "Exportar en formato {{format}} - Resultados de '{{item}}'",
                allResults: "evento electoral",
                globalAreaResults: "todas as áreas",
                title: "Título",
                subtitle: "Subtítulo",
                kind: "Tipo de ficheiro",
                filter: "Filtros Personalizados",
                approve: "Aprobar",
                continue: "Continuar",
                logout: "Pechar sesión",
                selectTenant: "Seleccionar cliente",
                processing: "Procesando...",
                tenantName: "Nome do inquilino",
            },
            language: {
                es: "Español",
                en: "Inglés",
                fr: "Francés",
                cat: "Valenciano",
                tl: "Tagalo",
                gl: "Galego",
                nl: "Holandés",
                eu: "Euskera",
            },
            channel: {
                online: "En Liña",
                kiosk: "Quiosco",
                early_voting: "Votación anticipada",
                telephone: "Votación telefónica",
                other: "Outros",
            },
            message: {
                delete: "¿Estás seguro de que queres eliminar este elemento?",
                continueOrLogout: "¿Queres continuar ou pechar sesión?",
            },
        },
        createResource: {
            electionEvent: "Crear un Evento Electoral",
            election: "Crear unha Elección",
            contest: "Crear unha Pregunta",
            candidate: "Crear un Candidato",
        },
        importResource: {
            electionEvent: "Importar un Evento Electoral",
            election: "Importar una Elección",
            contest: "Importar unha Pregunta",
            candidate: "Importar un Candidato",
            ImportHashMismatch: "Os hash non coinciden. Fallo na comprobación de integridade.",
        },
        sideMenu: {
            electionEvents: "Eventos Electorais",
            search: "Buscar",
            usersAndRoles: "Usuarios e Roles",
            electoralLogConsole: "Rexistro Electoral",
            taskQueues: "Colas de Tarefas",
            logs: "Rexistros",
            settings: "Configuracións",
            help: "Axuda",
            templates: "Modelos",
            active: "Activo",
            archived: "Arquivado",
            addResource: {
                electionEvent: "Crear un Evento Electoral",
                election: "Crear unha Elección",
                contest: "Crear unha Pregunta",
                candidate: "Crear un Candidato",
            },
            menuActions: {
                archive: {
                    electionEvent: "Arquivar este Evento Electoral",
                },
                unarchive: {
                    electionEvent: "Desarquivar este Evento Electoral",
                    election: "Desarquivar esta Elección",
                    contest: "Desarquivar esta Pregunta",
                    candidate: "Desarquivar este Candidato",
                },
                remove: {
                    electionEvent: "Eliminar este Evento Electoral",
                    election: "Eliminar esta Elección",
                    contest: "Eliminar esta Pregunta",
                    candidate: "Eliminar este Candidato",
                },
                messages: {
                    confirm: {
                        archive: "¿Estás seguro de que queres arquivar este elemento?",
                        unarchive: "¿Estás seguro de que queres desarquivar este elemento?",
                        delete: "¿Estás seguro de que queres eliminar este elemento?",
                        sealsUnknown: "Non se puideron comprobar os selos das urnas: se ten urnas seladas, rexeitarase a eliminación.",
                        archiveNamed: '¿Estás seguro de que queres arquivar "{{name}}"?',
                        unarchiveNamed: '¿Estás seguro de que queres desarquivar "{{name}}"?',
                        deleteNamed: '¿Estás seguro de que queres eliminar "{{name}}"?',
                    },
                    notification: {
                        success: {
                            archive: "O elemento foi arquivado",
                            unarchive: "O elemento foi desarquivado",
                            delete: "O elemento foi eliminado",
                            reloading: "Espere. La página se recargara en unos momentos",
                        },
                        error: {
                            archive: "Erro ao tentar arquivar este elemento",
                            unarchive: "Erro ao tentar desarquivar este elemento",
                            delete: "Erro ao tentar eliminar este elemento",
                            deleteSealedElection: "Esta elección ten urnas seladas e non se pode eliminar. No seu lugar, arquive o seu evento electoral.",
                            deleteSealedEvent: "Este evento electoral ten urnas seladas e non se pode eliminar. No seu lugar, arquíveo.",
                            deleteMaybeSealed: "Erro ao tentar eliminar este elemento. Se ten urnas seladas, non se pode eliminar.",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuración do candidato.",
            },
            edit: {
                externalId: "ID externo",
                general: "Xeral",
                type: "Tipo",
                image: "Imaxe",
                isDisabled: "Desactivado",
                isExplicitInvalid: "Voto Nulo",
                isExplicitBlank: "Voto en Branco",
                isCategoryList: "Lista de Categoría",
                isWriteIn: "Escrita",
            },
            field: {
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
            },
            options: {
                "candidate": "Candidato",
                "option": "Opción",
                "write-in": "Escrita",
                "open-list": "Lista Aberta",
                "closed-list": "Lista Pechada",
                "semi-open-list": "Lista Semi Aberta",
                "invalid-vote": "Voto Nulo",
                "blank-vote": "Voto en Branco",
            },
            invalidVotePosition: {
                label: "Posición do Voto Nulo",
                null: "Ningunha (Por defecto)",
                top: "Arriba",
                bottom: "Abaixo",
            },
            error: {},
            createCandidateSuccess: "Candidato creado",
            createCandidateError: "Erro ao crear o candidato",
        },
        contestScreen: {
            common: {
                subtitle: "Configuración da pregunta.",
            },
            edit: {
                externalId: "ID externo",
                general: "Xeral",
                type: "Tipo",
                image: "Imaxe",
                system: "Sistema de Votación en Papeleta",
                design: "Deseño da Papeleta",
                reorder: "Reordenar candidatos",
                policies: "Políticas",
            },
            field: {
                name: "Nome",
                alias: "Alias",
                description: "Descrición",
            },
            options: {
                "non-preferential": "Non Preferencial",
                "plurality-at-large": "Pluralidade en Xeral",
                "instant-runoff": "Segunda Volta Instantánea",
                "random": "Aleatorio",
                "external-procedure": "Procedemento externo",
                "custom": "Personalizado",
                "alphabetical": "Alfabético",
            },
            tieBreakingPolicy: {
                label: "Política de desempate",
            },
            auditButtonConfig: {
                "label": "Opcións de Visualización do Botón de Auditoría",
                "show": "Mostrar",
                "not-show": "Non Mostrar",
                "show-in-help": "Mostrar na Ventá de Axuda",
            },
            underVotePolicy: {
                "label": "Política de Voto Inferior",
                "allowed": "Permitido",
                "warn-only-in-review": "Avisar na Revisión",
                "warn": "Avisar",
                "warn-and-alert": "Avisar e Alertar",
                "warn-and-confirm-in-review": "Avisar e Confirmar na Revisión",
            },
            invalidVotePolicy: {
                "label": "Política de Voto Nulo",
                "allowed": "Permitido",
                "warn": "Avisar",
                "warn-invalid-implicit-and-explicit": "Avisar Votos Nulos Implícitos e Explícitos",
                "not-allowed": "Non Permitido",
                "allowed-with-exclusive-explicit": "Permitido con Voto Nulo Explícito Exclusivo",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Forma do Icono de Caixa de Selección dos Candidatos",
                "square-checkbox": "Caixa de Selección Cadrada",
                "round-checkbox": "Caixa de Selección Redonda",
            },
            candidatesLayout: {
                "label": "Disposición das candidaturas",
                "helperText": "A grade de papeleta en papel mostra as candidaturas como celas numeradas cun círculo para encher, columna a columna, segundo Columnas (4 se está baleiro). As votacións por orde de preferencia sempre usan a lista.",
                "list": "Lista",
                "paper-grid": "Grade de papeleta en papel",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidatos e Listas",
                "allow-selecting-candidates": "Só Candidatos",
                "allow-selecting-lists": "Só Listas",
                "disabled": "Desactivado",
            },
            collapsibleListsPolicy: {
                "label": "Listas plegables",
                "disabled": "Deshabilitado",
                "enabled-expanded": "Habilitado (comeza expandido)",
                "enabled-collapsed": "Habilitado (comeza contraído)",
            },
            blankVotePolicy: {
                "label": "Política de Voto en Branco",
                "allowed": "Permitido",
                "warn-only-in-review": "Avisar na Revisión",
                "warn": "Avisar",
                "not-allowed": "Non Permitido",
            },
            overVotePolicy: {
                "label": "Política de Sobrescritura de Voto",
                "allowed": "Permitido",
                "allowed-with-msg": "Permitido con Mensaxe de Aviso",
                "allowed-with-msg-and-alert": "Permitido con Mensaxe de Aviso e Alerta",
                "not-allowed-with-msg-and-alert": "Non Permitido con Mensaxe de Aviso e Alerta",
                "not-allowed-with-msg-and-disable": "Non Permitido con Mensaxe de Aviso e Desactivar seleccións adicionais",
            },
            duplicatedRankPolicy: {
                "label": "Voto non válido - Política de posición duplicada",
                "allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante pode continuar)",
                "not-allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante non pode continuar)",
            },
            preferenceGapsPolicy: {
                "label": "Voto non válido - Política de rangos omitidos",
                "allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante pode continuar)",
                "not-allowed-warn-and-dialog": "Mostrar aviso e diálogo (o votante non pode continuar)",
            },
            paginationPolicy: {
                label: "Nome da Páxina",
            },
            isAcclaimed: {
                label: "Resolto por aclamación",
                helperText: "Os votantes ven esta pregunta pero non poden seleccionar nada, non se rexistra nada e todas as candidaturas se declaran gañadoras con cero votos. Configúreo antes de publicar as papeletas: cambialo despois invalida as papeletas xa emitidas.",
            },
            allowWriteins: {
                label: "Permitir candidaturas manuais",
            },
            maxVotes: {
                helperText: "Número máximo de candidatos que un votante pode seleccionar (votación non preferencial).",
                helperTextPreferential: "Posición de rango máis alta dispoñible para os votantes (ex. '5' significa posicións 1–5). Debe ser polo menos igual ao número de candidatos a ordenar (votación preferencial).",
            },
            error: {},
            createContestSuccess: "Pregunta creada",
            createContestError: "Erro ao crear a pregunta",
        },
        keysGeneration: __assign(__assign({}, englishTranslation.translations.keysGeneration), { downloadStep: __assign(__assign({}, englishTranslation.translations.keysGeneration.downloadStep), { title: "Descargar ficheiro de custodia", downloadButton: "Descargar ficheiro de custodia", confirmdDialog: __assign(__assign({}, englishTranslation.translations.keysGeneration.downloadStep.confirmdDialog), { title: "Gardar o ficheiro de custodia" }) }), checkStep: __assign(__assign({}, englishTranslation.translations.keysGeneration.checkStep), { subtitle: "Carga o ficheiro de custodia gardado ou unha proba de custodia asinada:", required: "É necesario confirmar a custodia", reconfirmButton: "Confirmar de novo a custodia (opcional)", reconfirmDescription: "A túa custodia xa está confirmada. Esta confirmación adicional é opcional." }), serverCustody: {
                recoveryInstructions: "Se importou este evento electoral ou perdeu o ficheiro gardado, descargue aquí o ficheiro de custodia actual. Gárdeo e logo cárgueo a continuación.",
                fileFormat: "Formato admitido: JSON",
                waiting: "Agardando a que o servidor custodio cree unha proba de custodia…",
                unavailable: "O servidor custodio non respondeu. Comproba que está activo e volve cargar o ficheiro de custodia.",
                failed: "O servidor custodio non puido crear a proba: {{error}}",
                invalidReply: "O servidor custodio devolveu unha resposta incompleta. Téntao de novo.",
                cancelled: "A solicitude cancelouse. Volve cargar o ficheiro para continuar.",
                downloadInstructions: "Descarga e garda este ficheiro de custodia. Carga o mesmo ficheiro no seguinte paso e nos recontos futuros. Non é unha copia de seguridade das túas claves privadas.",
                uploadInstructions: "Carga o ficheiro de custodia descargado. O servidor custodio creará a proba. Tamén podes cargar unha proba creada por un custodio sen conexión ou no navegador.",
                tallyInstructions: "Carga o ficheiro gardado durante a cerimonia de claves. O servidor custodio creará unha nova proba para este reconto. Tamén se aceptan probas de custodios sen conexión ou no navegador.",
            }, configureStep: {
                create: "Crear Cerimonia de Chaves",
                name: "Nome da Cerimonia de Chaves",
                allElections: "Todas as Eleccións",
                title: "Crear Cerimonia de Chaves do Evento Electoral",
                subtitle: "Cada autoridade xera e conserva as súas claves localmente e confirma a súa custodia. Escolle as autoridades e o número mínimo necesario para o reconto.",
                trusteeList: "Fiduciarios",
                threshold: "Limiar",
                errorMinTrustees_one: "Seleccionaches só {{selected}} fiduciario, pero debes seleccionar polo menos {{threshold}}.",
                errorMinTrustees_many: "Seleccionaches só {{selected}} fiduciarios, pero debes seleccionar polo menos {{threshold}}.",
                errorMinTrustees_other: "Seleccionaches só {{selected}} fiduciarios, pero debes seleccionar polo menos {{threshold}}.",
                errorThreshold: "Seleccionaches un limiar de {{selected}}, pero debe estar entre {{min}} e {{max}}.",
                errorCreatingCeremony: "Erro ao crear a Cerimonia de Chaves: {{error}}",
                createCeremonySuccess: "Cerimonia de Chaves creada",
                confirmdDialog: {
                    ok: "Si, Crear Cerimonia de Chaves",
                    cancel: "Cancelar",
                    title: "¿Estás seguro de que queres Crear a Cerimonia de Chaves?",
                    automaticCeremonyTitle: "¿Estás seguro de que queres crear unha cerimonia de chaves automática?",
                    description: "Estás a piques de Crear a Cerimonia de Chaves. Esta acción notificará aos Fiduciarios para participar na creación e distribución das Chaves do Evento Electoral.",
                    automaticCeremonyDescription: "As cerimonias automáticas omiten as confirmacións manuais de custodia. Os executores das autoridades deben xerar e verificar as claves electorais.",
                },
                filterTrustees: "Filtrar Autoridades",
                errorPermisionLabels: "Non se pode crear a cerimonia de chaves: falta unha ou máis etiquetas de permisos.",
                automaticCeremonyToggle: "Ceremonia automática",
            }, 
            // Native custody instructions use the English fallback until translated.
            ceremonyStep: __assign(__assign({}, englishTranslation.translations.keysGeneration.ceremonyStep), { custodyConfirmed: "Custodia confirmada", custodyComplete: "A túa parte rematou. Non tes que realizar ningunha outra acción.", waitingForTrustees: "Agardando a que as autoridades restantes completen a confirmación de custodia e calquera aprobación requirida.", moreActions: "Máis accións", cancel: "Cancelar Cerimonia de Chaves", progressHeader: "Progreso da Cerimonia de Chaves", executionStatus: "Estado: {{status}}", confirmdDialog: {
                    ok: "Si, Cancelar a Cerimonia de Chaves",
                    cancel: "Volver á Cerimonia de Chaves",
                    title: "¿Estás seguro de que queres Cancelar a Cerimonia de Chaves?",
                    description: "Estás a piques de Cancelar a Cerimonia de Chaves. Despois de realizar esta acción, para ter unha Cerimonia de Chaves exitosa terás que crear unha nova.",
                }, header: __assign(__assign({}, englishTranslation.translations.keysGeneration.ceremonyStep.header), { trusteeName: "Nome do Fiduciario", fragment: "Fragmento de Chave Xerado" }), logsHeader: {
                    title: "Rexistros",
                    date: "Data",
                    entry: "Entrada",
                }, emptyLogs: "Aínda non hai rexistros." }) }),
        miruExport: {
            create: {
                success: "Creando Paquete de Transmisión...",
                error: "Erro ao crear o Paquete de Transmisión ",
            },
            send: {
                success: "Enviando Paquete de Transmisión...",
                error: "Erro ao enviar o Paquete de Transmisión ",
            },
        },
        tally: {
            errorUploadingSignature: "Houbo un erro ao cargar a sinatura",
            downloadTransmissionPackage: "Descargar Paquete de Transmisión",
            resultsPublication: {
                sectionTitle: "Publicar no sitio web de resultados",
                policyTitle: "Sitio web de resultados",
                policyAccess: "Acceso ao sitio web de resultados",
                policyVisibility: "Visibilidade do sitio web de resultados",
                enabled: "Activado",
                disabled: "Desactivado",
                fullEvent: "Evento completo",
                areaBased: "Por área",
                publishStarted: "Publicación de resultados iniciada",
                publishError: "Non se puido iniciar a publicación de resultados",
                revoked: "Publicación de resultados revogada",
                revokeError: "Non se puido revogar a publicación de resultados",
                waitingForTally: "Os resultados pódense publicar cando este reconto remate.",
                writePermissionRequired: "Precisas o permiso publish-results-write para publicar ou revogar resultados.",
                readPermissionRequired: "Precisas o permiso publish-results-read para ver o historial de publicacións.",
                disabledPolicy: "A publicación no sitio web de resultados está desactivada para este evento electoral. Actívaa nos datos do evento electoral antes de publicar resultados.",
                loadingElectionContext: "A publicación de resultados está a cargar o contexto da elección.",
                route: "Ruta",
                eventResults: "Resultados do evento",
                electionResults: "Resultados da elección",
                election: "Elección",
                access: "Acceso",
                publicAccess: "Acceso público",
                authenticatedAccess: "Acceso autenticado",
                visibility: "Visibilidade",
                fullPublishedScope: "Ámbito publicado completo",
                personalVisibility: "Visibilidade persoal",
                contests: "Preguntas",
                noTalliedContests: "Non hai preguntas escrutadas dispoñibles.",
                publishSelectedContests: "Publicar as preguntas seleccionadas",
                selectedContestCount_one: "{{count}} pregunta seleccionada",
                selectedContestCount_many: "{{count}} preguntas seleccionadas",
                selectedContestCount_other: "{{count}} preguntas seleccionadas",
                history: "Historial de publicacións",
                version: "Versión",
                status: "Estado",
                published: "Publicado",
                revokedAt: "Revogado",
                actions: "Accións",
                open: "Abrir",
                revoke: "Revogar",
                noPublications: "Aínda non hai publicacións.",
                confirmTitle: "Iniciar a publicación no sitio web de resultados?",
                confirmDescription: "Isto creará unha nova publicación a partir do reconto actual. Os resultados que ven os votantes seguirán activos ata que esta tarefa de publicación remate correctamente.",
                close: "Pechar",
            },
            transmissionPackage: {
                title: "Paquete de Transmisión para a Área '{{name}}' e Elección '{{eventName}}'",
                description: "Permítelle exportar un Paquete de Transmisión a Servidores de Destino ou descargalo.",
                erFileSha256: "Ficheiro ER SHA-256:",
                actions: {
                    send: {
                        title: "Enviar",
                        dialog: {
                            title: "¿Queres Enviar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere Enviar o Paquete de Transmisión para a Área `{{name}}` aos Servidores de Destino.",
                            confirm: "Enviar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                        disabled: "Faltan as sinaturas requiridas ou o paquete de transmisión xa se enviou a todos os destinos.",
                    },
                    regenerate: {
                        title: "Rexenerar",
                        dialog: {
                            title: "¿Queres rexenerar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere rexenerar o Paquete de Transmisión para a Área `{{name}}`",
                            confirm: "Rexenerar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                    },
                    sign: {
                        title: "Asinar",
                        dialog: {
                            title: "¿Queres asinar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere asinar o Paquete de Transmisión para a Área `{{name}}`",
                            confirm: "Asinar Paquete de Transmisión",
                            cancel: "Pechar",
                            input: {
                                placeholder: "Introduce o teu contrasinal",
                            },
                        },
                    },
                    download: {
                        title: "Descargar",
                        emlTitle: "Descargar EML {{date}}",
                        transmissionPackageTitle: "Descargar Paquete de Transmisión {{date}}",
                        transmissionReportTitle: "Descargar informe de transmisión",
                        csvTitle: "Descargar CSV de resultados {{date}}",
                        ovcsPublicKeyTitle: "Descargar a chave pública da OVCS",
                        recordError: "Non se puido rexistrar a descarga, así que non se iniciou. Téntao de novo.",
                        dialog: {
                            title: "¿Queres Descargar o Paquete de Transmisión?",
                            description: "Por favor, confirme que quere Descargar o Paquete de Transmisión para a Área `{{name}}.`",
                            confirm: "Descargar Paquete de Transmisión",
                            cancel: "Pechar",
                        },
                    },
                },
                destinationServers: {
                    title: "Servidores de Destino",
                    description: "A táboa a continuación mostra o estado de envío de cada un dos Servidores de Destino.",
                    status: "Enviado a {{signed}} de {{total}}",
                    manualReceipt: "Recepción manual",
                    handOver: "Descarga o paquete e entrégao en man",
                    sealedFor: "Selado para a súa chave, SHA-256 {{key}}…",
                    table: {
                        serverName: "Nome do Servidor",
                        sendStatus: "Estado de Envío",
                    },
                },
                signatures: {
                    title: "Sinaturas",
                    description: "Os membros poden asinar o paquete de transmisión. A táboa mostra o estado de sinatura de cada membro.",
                    status: "{{signed}} de {{total}}, necesítanse {{minimum}}",
                    statusNoMinimum: "{{signed}} de {{total}}",
                    table: {
                        trusteeName: "Membro",
                        signed: "Asinou",
                    },
                },
            },
            sendToTransmissionPackageServers: "Enviar Paquete de Transmisión para a Área '{{name}}'",
            uploadTransmissionPackage: "Asinar Paquete de Transmisión",
            uploadTransmissionPackageDesc: "Carga a túa Sinatura para asinar o Paquete de Transmisión. Esta é unha operación opcional.",
            exportElectionArea: "Enviar Paquete de Transmisión para a Área '{{name}}'",
            generateReport: "Generar {{name}}",
            templateTitle: "Modelo de Resultados",
            templateSubTitle: "Sobrescribir opcionalmente o modelo de resultados.",
            keysCeremonyTitle: "Cerimonia de Chaves",
            keysCeremonySubTitle: "Selecciona a Cerimonia de Chaves para este escrutinio",
            ceremonyTitle: "Eleccións para Escrutar",
            initializationTitle: "Eleccións para o Informe de Inicialización",
            ceremonySubTitle: "Elixe as eleccións que queres escrutar",
            tallyTitle: "Progreso do Escrutinio das Eleccións",
            logsTitle: "Rexistros",
            resultsTitle: "Resultados e Participación",
            generalInfoTitle: "Información Xeral",
            sessionId: "ID da sesión de reconto",
            selectedQuorum: "Quórum seleccionado",
            trusteeTallyTitle: "Fiduciarios",
            trusteeTallySubTitle: "Estado de confirmación da custodia",
            ballotBoxes: {
                unavailable: "Selos non dispoñibles",
                sealed: "{{sealed}} de {{total}} seladas",
                publishing: "Seladas, {{published}} de {{total}} actas de selado publicadas",
                sealing: "Selarase ás {{time}}",
                notSealed: "Sen selar",
                help: "Unha elección pódese escrutar cando todas as súas urnas están seladas e as súas actas de selado están publicadas.",
                failed: "Sen selar: incidencia",
                overdue: "Selado atrasado",
                blocked: "{{name}}: {{reason}}",
                reason: {
                    "not-sealed": "a votación non se pechou, polo que as súas urnas aínda non teñen selos",
                    "sealing": "as súas urnas sélanse cando remata o período de graza",
                    "overdue": "as súas urnas superaron o prazo e aínda non están seladas (consulte o seu Taboleiro)",
                    "publishing": "as actas de selado dalgunhas das súas urnas aínda se están a publicar",
                    "failed": "non se puido selar unha urna, o que é unha incidencia (consulte o seu Taboleiro)",
                    "unavailable": "non se puideron ler os selos das súas urnas",
                },
            },
            eligibility: {
                ballotBoxesUnavailable: "Non se puideron ler os selos das urnas dunha elección seleccionada, polo que aínda non se pode escrutar. Recargue a páxina para tentalo de novo.",
                selectElection: "Selecciona polo menos unha elección.",
                publishElection: "Publica cada elección seleccionada antes de crear o seu escrutinio.",
                tallyDisallowed: "O escrutinio está desactivado para unha elección seleccionada.",
                endVoting: "Finaliza a votación de cada elección seleccionada e detén as súas canles activas antes de crear o escrutinio.",
                sealBallotBoxes: "Unha elección pódese escrutar cando todas as súas urnas están seladas e as súas actas de selado están publicadas.",
            },
            createTallySuccess: "Escrutinio creado",
            createTallyError: "Non se puido crear o Escrutinio",
            startTallySuccess: "Escrutinio iniciado",
            startTallyError: "Non se puido iniciar o Escrutinio",
            startTallyCeremonySuccess: "Cerimonia de Escrutinio iniciada",
            startTallyCeremonyError: "Non se puido iniciar a Cerimonia de Escrutinio",
            cancelTallyCeremonySuccess: "Cerimonia de Escrutinio cancelada",
            cancelTallyCeremonyError: "Non se puido cancelar a Cerimonia de Escrutinio",
            recountTallyCeremony: "Repetir o reconto",
            recountTallyCeremonyMessage: "Isto xerará un novo evento de resultados para a sesión de escrutinio completada.",
            recountTallyCeremonyStarting: "Iniciando o reconto...",
            recountTallyCeremonySuccess: "Reconto iniciado",
            recountTallyCeremonyError: "Non se puido iniciar o reconto",
            recountTallyCeremonyOk: "Repetir o reconto",
            trusteeTitle: "Proceso dos Fiduciarios",
            trusteeSubTitle: "Carga o ficheiro de custodia gardado ou unha proba de custodia asinada:",
            invited: "Fostes invitado a participar nunha Cerimonia de Escrutinio. Por favor ",
            click: "fai clic na Acción de Escrutinio",
            participate: "para participar.",
            breadcrumbSteps: {
                start: "Inicio",
                finish: "Finalizar",
                tally: "Escrutinio",
                results: "Resultados",
                ceremony: "Cerimonia",
            },
            common: {
                title: "Escrutinio",
                subTitle: "Configuración do Escrutinio.",
                cancel: "Atrás",
                next: "Seguinte",
                date: "Data do Escrutinio",
                global: "Global",
                noTrustees: "Aínda non hai fiduciarios",
                imported: " autoridades confirmaron a custodia",
                needed: " fiduciarios necesarios",
                start: "Iniciar Escrutinio",
                ceremony: "Iniciar Cerimonia de Escrutinio",
                initialization: "Iniciar Informe de Inicialización",
                results: "Resultados",
                dialog: {
                    ok: "Aceptar",
                    okTally: "Iniciar Escrutinio",
                    okCancel: "Cancelar Escrutinio",
                    cancel: "Pechar",
                    title: "¿Estás seguro de que queres iniciar unha cerimonia?",
                    tallyTitle: "¿Estás seguro de que queres iniciar o escrutinio?",
                    cancelTitle: "¿Estás seguro de que queres cancelar o escrutinio?",
                    message: "Esta cerimonia solicita probas públicas de custodia ás autoridades. Mantén os seus executores activos co estado local do protocolo.",
                    cancelMessage: "Estás a piques de cancelar a cerimonia de escrutinio. Esta acción non se pode desfacer.",
                    ceremony: "As autoridades necesarias confirmaron a custodia. Iniciar o reconto cos seus executores activos?",
                    startAutomatedTallyMessage: "Seleccione 'Start Tally' para executar o proceso de reconto e mostrar os resultados, ou 'Close' para cancelar.",
                },
            },
            table: {
                ballotBoxes: "Urnas",
                elections: "Eleccións",
                selected: "Seleccionado",
                status: "Estado",
                progress: "Progreso",
                method: "Método de Escrutinio",
                elegible: "Votantes Elixibles",
                number: "Número de Votos",
                total: "Total",
                turnout: "%",
                candidates: "Resultados dos Candidatos",
                options: "Opcións",
                global: "Resumo de Participación",
                elegible_census: "Votantes Elixibles",
                cast_votes: "Número de Votos",
                cast_votes_percent: "Porcentaxe de Votos",
                total_votes: "Total de Votantes",
                total_votes_percent: "Participación",
                total_votes_counted: "Total de Votos Contabilizados",
                total_auditable_votes: "Total de Votos Auditable",
                total_valid_votes: "Total de Votos Válidos",
                total_valid_votes_percent: "Porcentaxe de Votos Válidos",
                total_invalid_votes: "Total de Votos Nulos",
                total_invalid_votes_percent: "Porcentaxe de Votos Nulos",
                explicit_invalid_votes: "Votos Nulos Explícitos",
                explicit_invalid_votes_percent: "Porcentaxe de Votos Nulos Explícitos",
                implicit_invalid_votes: "Votos Nulos Implícitos",
                implicit_invalid_votes_percent: "Porcentaxe de Votos Nulos Implícitos",
                blank_votes: "Votos en Branco",
                explicit_blank_votes: "Votos en Branco Explícitos",
                implicit_blank_votes: "Votos en Branco Implícitos",
                blank_votes_percent: "Porcentaxe de Votos en Branco",
                number_of_votes: "Número de Votos",
                winning_position: "Posición Gañadora",
                weight: "Peso",
                preferential: {
                    candidate: "Candidato",
                    winner: "Gañador",
                    eliminated: "Eliminado",
                    round: "Rolda",
                },
                total_declined_to_vote: "Total de votos de renuncia",
                total_blank_ballots: "Total de Papeletas en Branco",
                participation_by_channel: "Participación por canle",
                channel: "Canle",
                channel_online: "En liña",
                channel_kiosk: "Quiosco",
                channel_early_voting: "Votación anticipada",
                channel_telephone: "Teléfono",
                channel_paper: "Papel",
                channel_postal: "Postal",
                channel_in_person: "Presencial",
                acclamation_note: "Elixido por aclamación. Esta pregunta resolveuse sen votación, polo que non se rexistrou ningún voto.",
            },
            pendingResolutions: {
                round: "Rolda {{round}}",
                tieResolutionRequired: "Resolución de empate necesaria",
                tieResolved: "Empate resolto",
                globalArea: "Global",
                pendingResolutionsHeader: "Resolucións pendentes",
                pendingResolutionStatus: "Resolución pendente",
                resolvedStatus: "Resolto",
                resolutionTitle: "Resolución",
                selectContest: "Seleccione un elemento á esquerda para ver os detalles",
                selectCandidateToAdvance: "Seleccione o candidato a avanzar",
                undoResolution: "Desfacer resolución",
                applyResolutions: "Aplicar resolucións e recalcular",
                submitSuccess: "Resolucións enviadas. O escrutinio está a retomarse...",
                submitError: "Erro ao enviar as resolucións. Por favor, ténteo de novo.",
                filter: "Filtrar",
                save: "Gardar",
                pendingApplyStatus: "Cálculo pendente",
                filterElection: "Elección",
                filterContest: "Pregunta",
                filterArea: "Área",
                filterStatusLabel: "Estado",
                clearFilters: "Borrar filtros",
                candidateWithVotes: "{{name}} ({{votes}} votos)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} votos, {{percent}}%)",
                tieInfoTitle: "Escrutinio pausado por empate sen resolver (Rolda {{round}})",
                tieInfoBody: "Candidatos empatados ({{votes}} votos, {{percent}}%): {{candidates}}. Requírese desempate manual para continuar o escrutinio.",
                tallyResumedTitle: "Escrutinio retomado tras aplicar a resolución",
                tallyResumedBody: "O empate foi resolto o {{date}} por {{user}}",
            },
            chart: {
                votesForCandidates: "Votos polos Candidatos",
                blankVotes: "Votos en Branco",
                invalidVotes: "Votos Inválidos",
                totalVoters: "Total de Votantes",
                nonVoters: "Non Votantes",
            },
            exportAllAreas: "Exportar os resultados de todas as áreas en formato {{format}} para '{{item}}'",
        },
        publish: {
            initialization: {
                countryInfo: "Xere o informe para todo o posto ou para un país. A votación permanece bloqueada ata completar toda a inicialización requirida por país e para o evento.",
                countriesError: "Non se puideron cargar os países elixibles. Peche e volva intentalo.",
                noCountries: "Este posto non ten países elixibles con estilos de papeleta activos. Comprobe as súas áreas e a publicación antes de inicializar.",
                country: "País",
                entirePost: "Todo o posto",
            },
            preview: {
                publicationAreas: "Seleccionar Área para Vista Previa",
                action: "Vista Previa",
                copy: "Copiar ligazón",
                copy_success: "Ligazón de vista previa copiada correctamente",
                copy_error: "Erro ao copiar a ligazón de vista previa",
                success: "Vista previa aberta correctamente",
            },
            header: {
                change: "Cambios a Publicar",
                viewChange: "Ver Publicación",
                history: "Historial de Publicacións",
            },
            action: {
                generateInitializationReport: "Xerar Informe de Inicialización",
                startVotingPeriod: "Iniciar Votación",
                startKioskVoting: "Iniciar Votación en Quiosco",
                startOnlineVoting: "Iniciar Votación en Liña",
                startEarlyVoting: "Iniciar Votación Anticipada",
                startTelephoneVoting: "Iniciar Votación Telefónica",
                stopVotingPeriod: "Detener Votación",
                stopOnlineVoting: "Detener Votación en Liña",
                stopEarlyVoting: "Detener Votación Anticipada",
                stopTelephoneVoting: "Detener Votación Telefónica",
                stopKioskVotingPeriod: "Detener Votación en Quiosco",
                pauseVotingPeriod: "Pausar Votación",
                pauseKioskVoting: "Pausar Votación en Quiosco",
                pauseOnlineVoting: "Pausar Votación en Liña",
                pauseEarlyVoting: "Pausar Votación Anticipada",
                pauseTelephoneVoting: "Pausar Votación Telefónica",
                generate: "Rexenerar",
                publish: "Publicar Cambios",
                back: "Atrás",
            },
            label: {
                current: "Actual",
                previous: "Publicación Anterior",
                publication: "Publicación",
                diff: "Cambios para Publicar",
            },
            empty: {
                header: "Aínda non hai Publicación.",
                action: "Xerar Publicación",
            },
            forbidden: {
                header: "Non se pode Publicar ata que a Cerimonia de Chaves estea completa.",
            },
            skippedElections: {
                dismiss: "Descartar",
                title: "Algunhas eleccións seguen pechadas",
                ballotBoxSealPolicy: "{{name}} segue pechada: a súa votación pechouse e Selar ao pechar fai que o peche sexa definitivo.",
                other: "{{name}} quedou como estaba ({{reason}}).",
            },
            dialog: {
                title: "Confirmar Acción",
                info: "Fixeches clic nunha acción sensible, polo que necesitamos que confirmes para continuar",
                initializationInfo: "Estás a piques de xerar o informe de inicialización. ¿Estás seguro de que queres continuar?",
                startInfo: "Estás a piques de iniciar o período de votación. ¿Estás seguro de que queres continuar?",
                stopInfo: "Estás a piques de deter o período de votación. ¿Estás seguro de que queres continuar?",
                stopSeal: "Estás a piques de deter a votación en {{name}}. A continuación, as súas urnas sélanse: non se pode engadir, cambiar nin borrar ningunha papeleta, e a votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                stopSealEvent: "Estás a piques de deter a votación en todas as eleccións. A continuación, as súas urnas sélanse: non se pode engadir, cambiar nin borrar ningunha papeleta, e a votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                startSealNote: "Con Selar ao pechar, a votación pechada segue pechada: as eleccións cuxa votación se pechou non se abrirán.",
                channel: {
                    ONLINE: "En Liña",
                    KIOSK: "Quiosco",
                    EARLY_VOTING: "Votación anticipada",
                    TELEPHONE: "Teléfono",
                },
                kioskStopInfo: "Estás a piques de deter o período de votación en quiosco. ¿Estás seguro de que queres continuar?",
                pauseInfo: "Estás a piques de pausar o período de votación. ¿Estás seguro de que queres continuar?",
                publishInfo: "Estás a piques de xerar unha publicación. ¿Estás seguro de que queres continuar?",
                ok: "Confirmar",
                ko: "Cancelar",
                error: "Erro ao cargar a publicación de papeletas",
                error_publish: "Erro ao publicar a publicación de papeletas",
                error_capacity: "Erro ao xerar o estilo de papeleta: {{message}}",
                error_status: "Erro ao cambiar o estado da publicación de papeletas",
                error_preview: "Erro ao previsualizar a publicación",
                diff: "Renderizar todos os cambios pode facer que a páxina non responda. ¿Estás seguro de que queres continuar?",
                confirmation: "A acción que estás a piques de realizar é sensible e require confirmación. Por favor, introduce o teu contrasinal para continuar con {{action}}.",
                stopSealNotYet: "Estás a piques de deter o período de votación. {{holding}} ¿Estás seguro de que queres continuar?",
                sealHolding_one: "Con Selar ao pechar, as súas urnas sélanse cando todas as canles habilitadas estean pechadas: a canle {{channels}} segue habilitada e sen pechar.",
                sealHolding_other: "Con Selar ao pechar, as súas urnas sélanse cando todas as canles habilitadas estean pechadas: as canles {{channels}} seguen habilitadas e sen pechar.",
                sealNotEnabled: "A canle {{channel}} non está pechada nin habilitada nesta elección: deteñaa para selar as urnas.",
                sealNotEnabledPost: "En {{post}}, a canle {{channel}} non está pechada nin habilitada: deteñaa nesa elección para selar as súas urnas.",
                sealNoChannel: "Ningunha canle está habilitada nesta elección e ningunha estivo aberta, así que as súas urnas non se selan.",
                stopNeverOpened_one: "A canle {{channels}} nunca se abriu: se a detés, xa non se abrirá.",
                stopNeverOpened_other: "As canles {{channels}} nunca se abriron: se as detés, xa non se abrirán.",
                stopSealGrace_one: "Estás a piques de deter a votación en {{name}}. As súas urnas sélanse cando remata o período de graza, {{count}} minuto despois: a partir dese momento non se pode engadir, cambiar nin borrar ningunha papeleta. A votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                stopSealGrace_other: "Estás a piques de deter a votación en {{name}}. As súas urnas sélanse cando remata o período de graza, {{count}} minutos despois: a partir dese momento non se pode engadir, cambiar nin borrar ningunha papeleta. A votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                stopSealEventGrace_one: "Estás a piques de deter a votación en todas as eleccións. As súas urnas sélanse cando remata o período de graza de cada elección, ata {{count}} minuto despois: a partir dese momento non se pode engadir, cambiar nin borrar ningunha papeleta. A votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                stopSealEventGrace_other: "Estás a piques de deter a votación en todas as eleccións. As súas urnas sélanse cando remata o período de graza de cada elección, ata {{count}} minutos despois: a partir dese momento non se pode engadir, cambiar nin borrar ningunha papeleta. A votación non pode volver comezar. ¿Estás seguro de que queres continuar?",
                stopSealEventSome: "Estás a piques de deter a votación en todas as eleccións. {{sealed}} {{holding}} ¿Estás seguro de que queres continuar?",
                sealedNowPart: "A continuación, as urnas de {{names}} sélanse: non se pode engadir, cambiar nin borrar ningunha papeleta, e a votación non pode volver comezar alí.",
                sealedGracePart_one: "As urnas de {{names}} sélanse cando remata o seu período de graza, ata {{count}} minuto despois.",
                sealedGracePart_other: "As urnas de {{names}} sélanse cando remata o seu período de graza, ata {{count}} minutos despois.",
                holdingEventPart_one: "{{names}} mantén outra canle habilitada e sen pechar: as súas urnas sélanse cando esa canle estea pechada.",
                holdingEventPart_other: "{{names}} manteñen outra canle habilitada e sen pechar: as súas urnas sélanse cando esas canles estean pechadas.",
                noChannelEventPart_one: "{{names}} non habilita ningunha canle e ningunha estivo aberta: as súas urnas non se selan.",
                noChannelEventPart_other: "{{names}} non habilitan ningunha canle e ningunha estivo aberta: as súas urnas non se selan.",
                startSealNoteList: "Con Selar ao pechar, a votación pechada segue pechada: {{items}}.",
                startKeptChannels_one: "{{post}}: a canle {{channels}} segue pechada",
                startKeptChannels_other: "{{post}}: as canles {{channels}} seguen pechadas",
                startKeptSealed: "{{post}} segue pechado, xa que as súas urnas están seladas",
                startNotEnabledList: "Con Selar ao pechar, un inicio abre unha canle só nos Posts que a habilitan: {{items}}.",
                startNotEnabledChannels_one: "{{post}}: a canle {{channels}} non está habilitada alí e segue Non iniciada",
                startNotEnabledChannels_other: "{{post}}: as canles {{channels}} non están habilitadas alí e seguen Non iniciadas",
                stopNeverOpenedPosts_one: "{{names}} nunca se abriu: ao detelo, péchase e sélanse as súas urnas baleiras.",
                stopNeverOpenedPosts_other: "{{names}} nunca se abriron: ao detelos, péchanse e sélanse as súas urnas baleiras.",
            },
            notifications: {
                generated: "Papeleta xerada",
                published: "Papeleta publicada",
                change_status: "Estado da elección cambiado",
            },
            sealRefusals: {
                startAgain: "A votación non pode volver comezar: con Selar ao pechar, a votación que xa se pechou segue pechada e as súas urnas están seladas.",
                startDisabled: "Iniciar Votación non está dispoñible: as urnas desta elección están seladas ou selándose, e con Selar ao pechar a votación pechada segue pechada.",
                closedIsFinal: "A votación pechada non pode cambiar: con Selar ao pechar, a votación pechada segue pechada.",
            },
        },
        emailEditor: {
            subject: "Asunto do Correo",
            tabs: {
                plaintext: "Corpo de Texto Simple",
                richtext: "Corpo de Texto Enriquecido",
            },
        },
        sendCommunication: {
            send: "Enviar",
            title: "Enviar Notificación",
            subtitle: "Enviar unha notificación aos votantes.",
            sendButton: "Enviar Notificación",
            voters: "Audiencia",
            schedule: "Programar",
            nowInput: "Enviar agora",
            dateInput: "Data e hora para comezar a enviar notificacións",
            chooseDate: "Por favor, escolle unha data",
            languages: "Idiomas",
            smsMessage: "Mensaxe SMS",
            errorSending: "Erro ao enviar a notificación: {{error}}",
            successSending: "Notificación programada correctamente",
            method: "Método do Modelo",
            type: "Tipo de Comunicación",
            alias: "Alias do Modelo",
            votersSelection: {
                ALL_USERS: "Todos",
                NOT_VOTED: "Os que aínda non votaron",
                VOTED: "Os que xa votaron",
                SELECTED: "A {{total}} {{voters}} seleccionados",
            },
            path: {
                users: "usuarios",
                voters: "votantes",
            },
            methodTitle: "Modelo de Comunicación",
            communicationMethod: {
                EMAIL: "Correo",
                SMS: "SMS",
                WHATSAPP: "WhatsApp",
                VIBER: "Viber",
                MESSENGER: "Facebook Messenger",
            },
            communicationType: {
                CREDENTIALS: "Credenciais",
                BALLOT_RECEIPT: "Recibo da Papeleta",
            },
            email: {
                subject: "Asunto",
            },
        },
        tallysheet: {
            title: "Urnas",
            subtitle: "Urnas dixitalizadas por canal",
            createTallySuccess: "Acta de Escrutinio gardada",
            createTallyError: "Erro ao gardar a Acta de Escrutinio",
            createTallyErrorSameKindExists: "A folla de reconto xa existe para esta pregunta co mesmo canal e área",
            allFieldsRequired: "Todos os campos son obrigatorios",
            header: {
                change: "Cambios a Publicar",
                viewChange: "Ver Publicación",
                history: "Historial de Publicacións",
            },
            action: {
                start: "Iniciar Elección",
                stop: "Detener Elección",
                pause: "Pausar",
                generate: "Rexenerar",
                publish: "Publicar Cambios",
                back: "Atrás",
            },
            inputError: {
                totalValidDoesNotMatch: "Os votos de candidatos ({{candidateVotesSum}}) deben estar entre {{lowerBound}} e {{upperBound}} segundo as regras de votación desta pregunta ({{nonBlankValidVotes}} votos válidos non en branco × ata {{maxMarks}} marcas por papeleta)",
                censusTooSmall: "O total de votos ({{totalVotes}}) non pode ser maior que o censo ({{census}})",
                totalInvalidDoesNotMatch: "O total de votos non válidos ({{totalInvalid}}) debe ser igual aos votos non válidos implícitos ({{implicitInvalid}}) máis os votos non válidos explícitos ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "O total de votos ({{totalVotes}}) debe ser igual ao total de votos válidos ({{totalValidVotes}}) máis o total de votos non válidos ({{totalInvalid}})",
                unknownCountingAlgorithm: "O algoritmo de reconto desta pregunta ({{countingAlgorithm}}) non se recoñece, polo que non se pode determinar o número permitido de votos de candidatos. Revise a configuración da pregunta.",
                blankBallotsInconsistent: "As Papeletas en Branco deben ter o mesmo valor en todas as follas de escrutinio desta urna",
                blankBallotsOutOfBounds: "O valor de Papeletas en Branco está fóra do rango que implican os recontos de votos en branco por pregunta desta urna",
            },
            label: {
                area: "Área",
                channel: "Canle",
                total_votes: "Total de Votos",
                total_valid_votes: "Total de Votos Válidos",
                total_invalid: "Total de Votos Nulos",
                explicit_invalid: "Votos Nulos Explícitos",
                implicit_invalid: "Votos Nulos Implícitos",
                total_blank_votes: "Votos en Branco",
                blank_ballots: "Papeletas en Branco",
                census: "Censo",
            },
            common: {
                tallyCeremony: {
                    manage: "Xestionar Cerimonia de Escrutinio",
                    view: "Ver Cerimonia de Escrutinio",
                    cancel: "Cancelar Cerimonia de Escrutinio",
                    addKey: "Engadir Chave de Escrutinio",
                },
                edit: "Editar",
                confirm: "Confirmar",
                back: "Atrás",
                next: "Seguinte",
                cancel: "Atrás",
                data: "Datos",
                title: "Acta de Escrutinio",
                subtitle: "Configuración da Acta de Escrutinio.",
                candidates: "Candidatos",
                save: "Gardar",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                show: "Amosar",
                add: "Engadir",
                versions: "Versións",
                warningDisapprove: "Está seguro de desaprobar esta Folla de Reconto?",
                warningApprove: "Está seguro de aprobar esta Folla de Reconto?",
            },
            empty: {
                header: "Aínda non hai Acta de Escrutinio.",
                action: "Xerar Acta de Escrutinio",
                add: "Engadir",
            },
            breadcrumbSteps: {
                start: "Inicio",
                edit: "Editar",
                confirm: "Confirmar",
                view: "Ver",
            },
            table: {
                area: "Área",
                contest: "Pregunta",
                approvedVersion: "Versión aprobada",
                latestVersion: "Última versión",
                labels: "Etiquetas",
                annotations: "Anotacións",
            },
            versionsTable: {
                title: "Versións da urna",
                version: "Versión",
                createdBy: "Creado por",
                reviewedBy: "Revisado por",
                createdAt: "Creado o",
                reviewedAt: "Revisado o",
                sourceImport: "Importación de orixe",
                importStatus: "Estado da importación",
                openImport: "Abrir importación",
                sourceFile: "Ficheiro de orixe",
            },
            message: {
                reviewError: "Erro ao revisar a acta de escrutinio",
                reviewSuccess: "Acta de escrutinio revisada",
            },
        },
        application: {
            import: {
                title: "Importar Aplicaciones",
                subtitle: "Importar datos de aplicaciones",
                paragraph: "Importa aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
                messages: {
                    success: "Aplicaciones importadas con éxito",
                    error: "Error al importar las aplicaciones",
                },
            },
            export: {
                title: "Exportar Aplicaciones",
                subtitle: "Exportar datos de aplicaciones",
                button: "Exportar",
                paragraph: "Exporta aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV).",
                messages: {
                    success: "Aplicaciones exportadas con éxito",
                    error: "Error al exportar las aplicaciones",
                },
            },
        },
        template: {
            noPermissions: "Non tes permiso para acceder aos modelos.",
            title: "Modelos",
            subtitle: "Lista de modelos",
            chooseMethods: "Escoller Métodos",
            default: "Usar modelo predeterminado",
            empty: {
                title: "Aínda non hai Modelo",
                subtitle: "¿Queres crear un?",
            },
            action: {
                createOne: "Crear Modelo",
            },
            create: {
                title: "Crear un Modelo",
                success: "Modelo creado",
                error: "Erro ao crear o Modelo",
            },
            update: {
                success: "Modelo actualizado",
                error: "Erro ao actualizar o Modelo",
            },
            edit: {
                title: "Editar un Modelo",
            },
            form: {
                smsMessage: "Mensaxe SMS",
                document: "Documento",
                pdfOptions: "Opciones de PDF",
                name: "Nome do Modelo",
                alias: "Alias do Modelo",
                type: "Tipo",
                communicationMethod: "Método",
                reportOptions: "Opciones de Informe",
            },
            type: {
                CREDENTIALS: "Credenciales",
                INITIALIZATION_REPORT: "Informe de Inicialización",
                ELECTORAL_RESULTS: "Resultados Electorales",
                BALLOT_IMAGES: "Imágenes de Boletas",
                BALLOT_RECEIPT: "Recibo de Voto",
                ACTIVITY_LOGS: "Registros de Actividades",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
            },
            method: {
                email: "Correo",
                sms: "SMS",
                document: "Documento",
                whatsapp: "WhatsApp",
                viber: "Viber",
                messenger: "Facebook Messenger",
            },
            import: {
                title: "Importar Plantillas",
                subtitle: "Importar datos de plantillas",
                paragraph: "Importa plantillas usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
            },
        },
        materials: {
            audioInstructions: {
                screenLabel: "Instrucións en audio para a pantalla",
                languageLabel: "Idioma da gravación",
                none: "Non son instrucións en audio",
                helperText: "Os votantes oen este ficheiro cando piden as instrucións nesa pantalla.",
                screens: {
                    "election-chooser": "Lista de eleccións",
                    "start": "Inicio",
                    "ballot": "Papeleta",
                    "review": "Revisión",
                    "confirmation": "Confirmación",
                    "audit": "Auditoría",
                    "ballot-locator": "Localizador de papeletas",
                    "support-materials": "Materiais de apoio",
                },
            },
            createMaterialSuccess: "Material de soporte creado",
            createMaterialError: "Erro ao crear o material de soporte",
            updateMaterialSuccess: "Material de soporte actualizado",
            updateMaterialError: "Erro ao actualizar o material de soporte",
            common: {
                title: "Material de Soporte",
                subtitle: "Introducir datos do material de soporte.",
            },
            error: {
                title: "O título é obrigatorio",
                document: "O documento é obrigatorio",
            },
            fields: {
                isHidden: "Está Oculto",
                publicUrl: "URL Pública",
            },
            empty: {
                header: "Aínda non hai material de apoio",
                action: "Xerar material de apoio",
            },
        },
        widget: {
            logs: "Rexistros",
        },
        settings: {
            countries: {
                title: "Bloqueo de Países",
                votingDescription: "Elixe abaixo os países dos que queres bloquear a votación.",
                enrollmentDescription: "Elixe abaixo os países dos que queres bloquear o rexistro.",
                error: {
                    errorSaving: "Erro ao gardar a lista de países",
                },
            },
            backupRestore: {
                title: "Copia de seguridad / Restaurar configuración del inquilino",
                backup: {
                    label: "Respaldo",
                    subtitle: "Copia de seguridad de las configuraciones del inquilino",
                },
                restore: {
                    label: "Restaurar",
                    subtitle: "Restaurar la configuración del inquilino",
                    title: "Importar configuraciones del inquilino",
                    paragraph: "Importar configuraciones del inquilino, configuraciones de Keycloak, roles y datos de permisos usando una carpeta comprimida.",
                    tenantConfigOption: "Importar configuraciones del inquilino",
                    keycloakConfigOption: "Importar configuraciones de Keycloak",
                    RolesConfigOption: "Importar configuraciones de roles y permisos",
                },
            },
            previewScreen: {
                label: "Vistas Previas",
                noContent: "Non se atoparon vistas previas",
                table: {
                    title: "Vistas previas externas",
                    description: "Un rexistro das vistas previas de estilos de papeleta xeradas mediante peticións externas",
                    requestedBy: "Solicitado por",
                    document: "Documento",
                    url: "URL",
                },
            },
            languages: {
                logsTimezone: "Fuso horario do rexistro do inquilino",
                default: "Idioma predeterminado",
            },
        },
        approvalsScreen: {
            column: {
                status: "Estado",
                id: "ID da solicitude",
                applicantId: "ID do solicitante",
                verificationType: "Verificación",
                createdAt: "Solicitada",
                verified_by: "Verificada por",
                voter: "Votante",
                what: "Que pasou",
                post: "Posto",
                when: "Cando",
            },
            status: {
                PENDING: "Pendente de revisión",
                ACCEPTED: "Aprobada",
                REJECTED: "Rexeitada",
            },
            verification: {
                AUTOMATIC: "Automática",
                MANUAL: "Manual",
            },
            time: {
                minutes_one: "{{count}} minuto",
                minutes_other: "{{count}} minutos",
                hours_one: "{{count}} hora",
                hours_other: "{{count}} horas",
                days_one: "{{count}} día",
                days_other: "{{count}} días",
            },
            summary: {
                join: "{{head}} e {{last}}",
                differs_one: "{{fields}} non coincide co rexistro",
                differs_other: "{{fields}} non coinciden co rexistro",
                typedByHand: "Datos escritos á man, non lidos dun documento escaneado",
                needsFaceToFace: "Precisa unha comprobación cara a cara",
                scanVerified: "Documento escaneado e verificado",
                noVoter: "Non se atopou ningún votante no rexistro",
                allMatch: "Todos os datos coinciden co rexistro",
                needsReview: "Á espera de que unha persoa decida",
                approvedBy: "Aprobada por {{name}}",
                approvedAuto: "Aprobada automaticamente",
                rejectedBy: "Rexeitada por {{name}}",
                rejectedAuto: "Rexeitada automaticamente",
            },
            list: {
                title: "Aprobacións",
                subtitle: "As inscricións que as regras non poden decidir por si soas agardan aquí por unha persoa.",
                search: "Buscar",
                review: "Revisar a inscrición",
                openRecord: "Abrir a inscrición",
                seeRule: "Ver a regra que decidiu",
                unnamed: "Solicitante sen nome",
                waiting: "Leva {{time}} agardando",
                applied: "Solicitada o {{date}}",
                empty: {
                    title: "Aquí non hai nada",
                    text: "As inscricións con este estado aparecerán aquí. Probe con outra busca ou outro estado.",
                },
                searchHelp: "Un nome, un correo electrónico ou un número de identificación, ou a referencia de soporte que se lle deu ao votante, como Q5KW-8RFX.",
                referenceError: "Non se puido buscar a referencia de soporte.",
            },
            flow: {
                stepsLabel: "Pasos da revisión",
                steps: {
                    identity: "Comprobar a identidade",
                    voter: "Buscar o votante",
                    decide: "Decidir",
                },
                continue: "Continuar",
                backToList: "Volver a Aprobacións",
                identity: {
                    details: "Datos da inscrición",
                    confirm: "Comprobei o documento de identidade do votante en persoa ou por videochamada, e coincide con esta inscrición.",
                    checked: "Comprobación cara a cara confirmada",
                    notChecked: "Comprobación cara a cara aínda sen confirmar",
                },
                voter: {
                    none: "Ningún destes é o votante",
                    noneHint: "Nese caso a inscrición só se pode rexeitar, por non haber un votante coincidente.",
                    noneChosen: "Ningún destes é o votante",
                    notChosen: "Aínda non se escolleu ningún votante",
                },
                decide: {
                    approve: "Aprobar",
                    reject: "Rexeitar",
                    approveText: "Vincula esta inscrición con {{voter}} no rexistro. Avísase o votante por correo electrónico ou SMS e poderá iniciar sesión para votar cando se abra a votación.",
                    rejectText: "Díselle ao votante o motivo. Isto non se pode desfacer.",
                    chooseVoter: "Escolla o votante coincidente no paso 2 para aprobar.",
                    noVoter: "Non atopou un votante coincidente, así que esta inscrición só se pode rexeitar.",
                    enrolled: "O votante escollido xa está inscrito.",
                    faceToFace: "Confirme a comprobación cara a cara no paso 1 para aprobar.",
                },
            },
            review: {
                loadError: "Non se puido cargar a inscrición.",
                applied: "Solicitada o {{date}}",
                waiting: "Leva {{time}} agardando",
                whyTitle: "Por que fai falta unha persoa",
                decisionTitle: "Como se decidiu",
                rule: "Regra {{rule}} da versión {{version}} da matriz",
                ruleLast: "Última regra da versión {{version}} da matriz",
                seeRule: "Ver a regra",
                why: {
                    typedByHand: "O votante escribiu os seus datos á man en lugar de escanear un documento de identidade. Estas inscricións nunca se aproban automaticamente: antes, un funcionario confirma quen é.",
                    differs_one: "Un dato non coincide co rexistro: {{details}}. As regras de aprobación piden que unha persoa revise esta inscrición.",
                    differs_other: "{{count}} datos non coinciden co rexistro: {{details}}. As regras de aprobación piden que unha persoa revise esta inscrición.",
                    differsFields_one: "Un dato non coincide co rexistro: {{fields}}. As regras de aprobación piden que unha persoa revise esta inscrición.",
                    differsFields_other: "{{count}} datos non coinciden co rexistro: {{fields}}. As regras de aprobación piden que unha persoa revise esta inscrición.",
                    difference: "en {{field}}, a inscrición di “{{enrollment}}” e o rexistro di “{{registry}}”",
                    noVoter: "Ningún votante do rexistro ten estes datos. As regras de aprobación piden que unha persoa revise esta inscrición.",
                    severalVoters: "Máis dun votante do rexistro encaixa con esta inscrición. Unha persoa escolle o correcto.",
                    pending: "As regras de aprobación piden que unha persoa revise esta inscrición.",
                    unknown: "Esta inscrición está á espera de que unha persoa decida.",
                    approvedAuto: "As regras de aprobación aprobaron esta inscrición automaticamente. Superáronse todas as comprobacións que esixen.",
                    approvedBy: "{{name}} aprobou esta inscrición o {{date}}.",
                    rejectedAuto: "As regras de aprobación rexeitaron esta inscrición automaticamente: {{reason}}.",
                    rejectedBy: "{{name}} rexeitou esta inscrición o {{date}}: {{reason}}.",
                },
                registryHelp: "Buscamos votantes cos mesmos datos: {{fields}}. Escolla aquel ao que pertence esta inscrición.",
                registrySearching: "Estes son os votantes do rexistro que coinciden coa súa busca. Escolla aquel ao que pertence esta inscrición.",
                registrySearch: "Non está na lista? Busque no rexistro por nome ou correo electrónico",
                registryLoading: "Buscando no rexistro",
                registryError: "Non se puido buscar no rexistro.",
                noCandidates: "Ningún votante do rexistro coincide. Probe a buscar por nome ou correo electrónico.",
                candidates: "Votantes do rexistro",
                alreadyEnrolled: "Xa inscrito",
                bestMatch: "Mellor coincidencia",
                detailsMatch: "Coinciden {{count}} de {{total}} datos",
                compareTitle: "Comparación con {{name}} no rexistro",
                col: {
                    detail: "Dato",
                    enrollment: "Na inscrición",
                    registry: "No rexistro",
                    result: "Resultado",
                },
                same: "Igual",
                differs: "Distinto",
                compareNote: "Nos nomes non se teñen en conta maiúsculas, acentos nin guións.",
                compareJoint: "Para permisos de conducir e libretas de mariño, o nome e o segundo nome compáranse xuntos.",
                applicationId: "ID da solicitude",
                copy: "Copiar",
                copied: "Copiado",
                approve: "Aprobar a inscrición",
                approveDialog: {
                    title: "Aprobar a {{name}}?",
                    body: "Isto vincula a inscrición co votante do rexistro que aparece abaixo. Avísase o votante por correo electrónico ou SMS e poderá iniciar sesión para votar cando se abra a votación.",
                    checked: "Comprobou o documento de identidade do votante cara a cara.",
                    irreversible: "Isto non se pode desfacer.",
                    confirm: "Aprobar",
                },
                reject: "Rexeitar a inscrición",
            },
            idCheck: {
                title: "Comprobación do documento",
                method: {
                    VERIFIED: "Documento escaneado e verificado",
                    MANUAL_ENTRY: "Escrito á man",
                    UNKNOWN: "Non indicado",
                },
                verified: "O proceso de inscrición verificou o documento de identidade do votante",
                typedByHand: "O votante escribiu os seus datos á man",
                unknown: "O proceso de inscrición non indicou como se comprobou a identidade",
                faceToFaceTitle: "Comprobe a súa identidade cara a cara antes de aprobar",
                faceToFaceText: "Reúnase co votante en persoa ou por videochamada e compare o seu documento de identidade cos datos desta páxina.",
            },
            reject: {
                rejectReason: "Motivo do rexeitamento",
                message: "Mensaxe para o votante",
                messageRequired: "Escriba unha mensaxe para o votante cando o motivo sexa Outro.",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Faltan datos",
                    "no-matching-voter": "Votante non coincidente",
                    "voter-already-approved": "Xa aprobado",
                    "EMAIL_IN_USE": "Correo usado por outro votante",
                    "other": "Outro",
                },
                hint: {
                    "insufficient-information": "Faltan datos ou non se poden ler.",
                    "no-matching-voter": "A persoa non está no rexistro de votantes.",
                    "voter-already-approved": "Este votante xa está inscrito.",
                    "other": "Escriba a súa propia mensaxe.",
                },
                preview: {
                    "insufficient-information": "Non puidemos inscribilo porque faltan algúns dos seus datos ou non se poden ler. Volva inscribirse cos datos completos.",
                    "no-matching-voter": "Non atopamos no rexistro un votante que coincida cos seus datos. Revise os seus datos e volva inscribirse, ou póñase en contacto coa súa oficina electoral.",
                    "voter-already-approved": "Xa está inscrito. Poderá iniciar sesión para votar cando se abra a votación.",
                },
                previewTitle: "O votante verá",
            },
            notifications: {
                approveError: "Non se puido aprobar a inscrición",
                approveSuccess: "Inscrición de {{name}} aprobada. Avisouse o votante.",
                rejectError: "Non se puido rexeitar a inscrición",
                rejectSuccess: "Inscrición de {{name}} rexeitada. Avisouse o votante.",
                VoterApprovedAlready: "Este votante xa está inscrito.",
            },
            export: {
                success: "A exportación de solicitudes completouse con éxito",
                error: "Erro ao exportar as solicitudes",
            },
            matrix: {
                button: "Matriz de aprobación",
                title: "Matriz de aprobación",
                back: "Aprobacións",
                subtitle: "As regras deciden que pasa con cada inscrición. Decide a primeira regra que se cumpre.",
                versionChip: "Versión {{version}}",
                savedBy: "Gardada o {{date}} por {{user}}",
                builtIn: "Regras integradas, en uso ata que se garde unha versión",
                unsaved: "Cambios sen gardar",
                viewOnly: "Só lectura",
                readOnlyTitle: "Pode ver as regras, pero non cambialas",
                readOnlyText: "Pídalle a un administrador que teña o permiso approval-matrix-write que faga os cambios.",
                loadError: "Non se puido cargar a matriz de aprobación.",
                compared: "Que comparamos",
                comparedHelp: "Cada inscrición compárase co votante atopado no rexistro. Nos nomes non se teñen en conta maiúsculas, acentos nin guións; para permisos de conducir e libretas de mariño, o nome e o segundo nome compáranse xuntos.",
                addCompared: "Comparar outro dato",
                rules: "Regras",
                rulesHelp: "As regras compróbanse desde arriba. Decide a primeira que se cumpre; se non se cumpre ningunha, aplícase a última regra.",
                when: "Cando",
                then: "Entón",
                otherwise: "Noutro caso",
                noneApply: "Non se aplica ningunha das regras anteriores",
                andWord: "e",
                and: " e ",
                appliesToExample: "Aplícase ao seu exemplo",
                cameFrom: "Decidiu a inscrición desde a que chegou",
                voterIsTold: "Ao votante díselle: “{{reason}}”.",
                sentence: "Cando {{when}}, {{outcome}}.",
                sentenceOtherwise: "Se non se aplica ningunha das regras anteriores, {{outcome}}.",
                sentenceEmpty: "Engada unha condición para indicar cando se aplica esta regra.",
                addRule: "Engadir regra",
                discard: "Descartar os cambios",
                actions: {
                    edit: "Editar a regra {{number}}",
                    editOtherwise: "Editar a última regra",
                    moveUp: "Subir a regra {{number}}",
                    moveDown: "Baixar a regra {{number}}",
                    delete: "Eliminar a regra {{number}}",
                },
                saveBar: {
                    title: "Ten cambios sen gardar",
                    fix_one: "Corrixa 1 regra antes de gardar",
                    fix_other: "Corrixa {{count}} regras antes de gardar",
                    more: "+{{count}} máis",
                },
                test: "Probar un exemplo",
                testHelp: "Describa unha inscrición para ver que regra a decide. Os cambios sen gardar tamén contan.",
                testDetails: "Datos comparados",
                applies: "Aplícase a regra {{number}}",
                otherwiseApplies: "Aplícase a última regra",
                testError: "Non se puido probar o exemplo.",
                testInvalid: "Corrixa estas regras para probar un exemplo:",
                ruleError: "Regra {{number}}: {{error}}",
                invariants: {
                    MANUAL_ENTRY_NOT_ACCEPTED: "Unha identidade escrita á man nunca se aproba automaticamente, así que isto envíase a unha persoa.",
                    ALREADY_ENROLLED_NOT_ACCEPTED: "Un votante que xa está inscrito nunca se aproba de novo.",
                    NO_VOTER_NOT_ACCEPTED: "Non se aproba a ninguén sen un votante no rexistro.",
                    OTHERWISE_NOT_ACCEPTED: "A última regra nunca aproba.",
                },
                dialog: {
                    editTitle: "Editar a regra {{number}}",
                    newTitle: "Nova regra",
                    otherwiseTitle: "Editar a última regra",
                    summary: "En resumo",
                    whenHelp: "Deben cumprirse todas. Omita unha condición cando non importe.",
                    otherwiseHelp: "Se non se aplica ningunha das regras anteriores",
                    addCondition: "Engadir condición",
                    remove: "Quitar “{{condition}}”",
                    identity: "Comprobación de identidade",
                    voterFound: "Votante no rexistro",
                    alreadyEnrolled: "Xa inscrito",
                    validId: "Tipo de documento",
                    differing: "Datos que difiren",
                    decision: "Decisión",
                    reason: "Que se lle di ao votante",
                    voterSees: "O votante ve",
                    apply: "Aplicar",
                    close: "Pechar",
                    yes: "Si",
                    no: "Non",
                    notReported: "Non indicado",
                },
                identity: {
                    VERIFIED: "Verificada con documento escaneado",
                    MANUAL_ENTRY: "Escrita á man",
                },
                differing: {
                    none: "Ningún",
                    exactly_1: "Exactamente 1",
                    at_most_1: "Como máximo 1",
                    exactly_2: "Exactamente 2",
                    at_most_2: "Como máximo 2",
                    at_least_3: "3 ou máis",
                },
                fieldMatch: {
                    MATCHES: "Igual",
                    DIFFERS: "Distinto",
                },
                decisions: {
                    ACCEPTED: "Aprobar automaticamente",
                    PENDING: "Enviar a unha persoa",
                    REJECTED: "Rexeitar",
                },
                outcomeShort: {
                    ACCEPTED: "aprobar automaticamente",
                    PENDING: "enviar a unha persoa",
                    REJECTED: "rexeitar",
                },
                outcomeHelp: {
                    ACCEPTED: "O votante queda inscrito sen que ninguén o revise.",
                    PENDING: "Decide un funcionario, e ao votante díselle que a súa inscrición está en revisión.",
                    REJECTED: "Ao votante díselle o motivo, e pode volver inscribirse.",
                },
                outcomeSentence: {
                    ACCEPTED: "apróbase a inscrición automaticamente",
                    PENDING: "envíase a inscrición a unha persoa",
                    REJECTED: "rexéitase a inscrición",
                },
                reasons: {
                    NO_VOTER: "Votante non coincidente",
                    ALREADY_APPROVED: "Xa aprobado",
                    INSUFFICIENT_INFORMATION: "Faltan datos",
                    IDENTITY_NOT_VERIFIED: "Identidade non verificada",
                    OTHER: "Outro",
                },
                voterText: {
                    NO_VOTER: "Non atopamos no rexistro un votante que coincida cos seus datos. Revise os seus datos e volva inscribirse, ou póñase en contacto coa súa oficina electoral.",
                    ALREADY_APPROVED: "Xa está inscrito. Poderá iniciar sesión para votar cando se abra a votación.",
                    INSUFFICIENT_INFORMATION: "Non puidemos inscribilo porque faltan algúns dos seus datos ou non se poden ler. Volva inscribirse cos datos completos.",
                    IDENTITY_NOT_VERIFIED: "Non puidemos verificar a súa identidade automaticamente, así que un funcionario electoral revisará a súa inscrición.",
                    OTHER: "Un funcionario electoral escribe esta mensaxe cando decide.",
                },
                conditions: {
                    any: "Aínda non hai condicións",
                    identity: {
                        VERIFIED: "Identidade verificada con documento escaneado",
                        MANUAL_ENTRY: "Identidade escrita á man",
                    },
                    voterFound: {
                        true: "Votante atopado no rexistro",
                        false: "Ningún votante atopado no rexistro",
                    },
                    alreadyEnrolled: {
                        true: "Xa inscrito",
                        false: "Aínda non inscrito",
                    },
                    validId: "Documento: {{id}}",
                    differing: {
                        none: "Todos os datos coinciden",
                        exactly_1: "Exactamente 1 dato difire",
                        at_most_1: "Como máximo 1 dato difire",
                        exactly_2: "Exactamente 2 datos difiren",
                        at_most_2: "Como máximo 2 datos difiren",
                        at_least_3: "3 ou máis datos difiren",
                    },
                    field: {
                        MATCHES: "{{field}} coincide",
                        DIFFERS: "{{field}} difire",
                    },
                },
                errors: {
                    ACCEPTS_MANUAL_ENTRY: "As inscricións coa identidade escrita á man non se poden aprobar automaticamente.",
                    ACCEPTS_ALREADY_ENROLLED: "Un votante que xa está inscrito non se pode aprobar de novo.",
                    ACCEPTS_WITHOUT_VOTER: "Non se pode aprobar unha inscrición sen un votante no rexistro.",
                    OTHERWISE_ACCEPTS: "A última regra pode enviar inscricións a unha persoa ou rexeitalas, pero non aprobalas.",
                    MISSING_REASON: "Escolla que se lle di ao votante.",
                    UNEXPECTED_REASON: "Unha aprobación non ten motivo.",
                    NO_COMPARED_FIELDS: "Escolla polo menos un dato para comparar co rexistro.",
                    DUPLICATE_COMPARED_FIELD: "Hai un dato comparado repetido.",
                    UNKNOWN_FIELD: "Unha regra usa un dato que non se compara.",
                    NO_CONDITIONS: "Engada polo menos unha condición. Só a última regra se aplica a todo o demais.",
                },
                change: {
                    added: "Regra {{number}} engadida",
                    decision: "Regra {{number}}: {{from}} → {{to}}",
                    edited: "Regra {{number}} modificada",
                    removed: "Eliminouse unha regra ({{text}})",
                    moved: "Reordenáronse as regras",
                    otherwise: "A última regra cambiou",
                    compared: "Os datos comparados cambiaron",
                },
                save: {
                    button: "Gardar como versión {{version}}",
                    title: "Gardar como versión {{version}}?",
                    body: "A partir de agora, as novas inscricións decídense con estas regras. As inscricións xa decididas conservan a súa decisión.",
                    changes: "Que cambiou",
                    log: "A nova versión queda anotada na bitácora electoral.",
                    confirm: "Gardar a versión {{version}}",
                    success: "Gardada como versión {{version}}",
                    error: "Non se puido gardar a matriz de aprobación",
                },
            },
        },
        monitoring: {
            configuredDashboards: "Paneis configurables",
            modeChangeError: "Non se puido cambiar o modo do panel. Ténteo de novo.",
            title: "Monitorización",
            loading: "Cargando a monitorización",
            unavailableAlert: "Non se puideron cargar os paneis de monitorización, así que se mostra o panel estándar.",
            noDashboards: "Este evento non ten paneis de monitorización.",
            dashboardFailed: "Non se puido cargar o panel de monitorización.",
            dashboardInvalid: "Este panel non se pode mostrar: {{problem}}",
            retry: "Tentar de novo",
            errors: {
                busy: "O servidor está ocupado. Tentarase de novo nuns segundos.",
                forbiddenScope: "Non pode ver esta rexión, Post ou país. Escolla outro.",
                snapshotPruned: "A actualización mostrada xa non se conserva. O panel mostra agora a última actualización: exporte de novo para usala.",
                checksUnavailable: "O servizo de gráficos non está dispoñible agora. Ténteo máis tarde.",
                lockedDown: "O evento electoral está bloqueado, así que isto non se pode cambiar.",
                notFound: "Este panel ou widget xa non está configurado. Recargue a páxina.",
                badRequest: "Non se aceptou a solicitude. Recargue a páxina e ténteo de novo.",
                conflict: "Outra persoa gardou un cambio antes. Recargue e ténteo de novo.",
                invalid: "Algúns valores da exportación non se aceptan.",
                unknown: "Algo fallou. Ténteo máis tarde.",
            },
            header: {
                dashboard: "Panel",
                updated: "Actualizado {{time}} ({{timeZone}})",
                notUpdated: "Aínda sen reconto",
                refresh: "cada {{seconds}} s",
                export: "Exportar",
                editDashboard: "Editar o panel",
                preset: "Axuste predefinido de paneis",
                reload: "Buscar cifras novas",
            },
            footer: {
                dataThrough: "Datos ata {{time}} ({{timeZone}})",
            },
            selectors: {
                region: "Rexión",
                post: "Posto",
                country: "País",
                allRegions: "Todas as rexións",
                allPosts: "Todos os postos",
                allAuthorizedPosts: "Todos os postos autorizados",
                allCountries: "Todos os países",
                authorizedOnly: "{{all}} (autorizados)",
            },
            widget: {
                menu: "Accións de {{widget}}",
                configure: "Configurar o widget",
                viewData: "Ver datos",
                export: "Exportar",
                duplicate: "Duplicar",
                loading: "Cargando {{widget}}",
                missing: "O panel nomea un widget que non existe: {{id}}",
                updating: "Actualizando {{widget}}",
                updatingNote: "Actualizando: o gráfico mostrado é o anterior.",
            },
            frame: {
                title: "Gráfico de {{widget}}",
            },
            sources: {
                voter_turnout: "Participación",
                test_voting: "Votación de proba",
                enrollment_decisions: "Decisións de inscrición",
                voting_credentials: "Credenciais de voto",
                poll_status: "Estado da votación",
                final_testing_lockdown: "Probas finais e bloqueo",
                counting_transmission: "Reconto e transmisión",
                voting_enrollment_activity: "Actividade de voto e inscrición",
                access_security: "Acceso e seguridade",
                attack_detections: "Detección de ataques",
                helpdesk: "Soporte",
            },
            reasons: {
                TEST_ELECTION_DESIGNATION: "aínda non se poden marcar as eleccións de proba",
                CREDENTIAL_ISSUED_EVENT: "aínda non se rexistra a emisión de credenciais",
                FINAL_TESTING_LOCKDOWN_STATE: "aínda non se rexistran as probas finais e o bloqueo",
                ATTACK_DETECTION_FEED: "non hai ningunha fonte de detección de ataques conectada",
                HELPDESK_INTEGRATION: "non hai ningún sistema de soporte conectado",
            },
            notices: {
                UNREGISTERED_ATTEMPTS_AT_EVENT_SCOPE_ONLY: "Os intentos con nomes de usuario non rexistrados non pertencen a ningún posto, polo que só se contan para todo o evento.",
                UNREGISTERED_ATTEMPTS_EXCLUDED: "Estas cifras non inclúen os intentos con nomes de usuario non rexistrados; cóntanse para todo o evento.",
                CREDENTIALS_ISSUED_WHEN_PASSWORD_SET: "As credenciais contan como emitidas cando se establece o contrasinal do votante, ata que a plataforma rexistre a súa emisión.",
                CONFIG_NEWER_THAN_SNAPSHOT: "Debuxado coa configuración máis recente; as cifras cóntanse con ela na próxima pasada.",
                CONFIG_AT_SNAPSHOT_UNAVAILABLE: "Debuxado coa configuración actual: a configuración coa que se contaron as cifras xa non se conserva.",
            },
            unavailable: {
                notConnected: "Non conectado · {{reason}}",
                notConnectedHelp: "Non se mostra nada ata que o estea.",
                unknownReason: "fonte de datos non dispoñible",
                noSnapshot: "Aínda sen reconto",
                noSnapshotHelp: "O primeiro reconto non rematou. Este widget actualízase só.",
                scopePending: "Contando esta selección",
                scopePendingHelp: "Esta selección cóntase na seguinte pasada, nun minuto aproximadamente.",
                settingsPending: "Contando coa nova configuración…",
                settingsPendingHelp: "As cifras vólvense contar coa configuración gardada, nun minuto aproximadamente.",
                renderFailed: "Non se puido debuxar o gráfico",
                renderFailedHelp: "No seu lugar móstranse as cifras.",
                invalid: "Este widget non se pode mostrar",
                invalidHelp: "A súa configuración ten un problema.",
                requestFailed: "Non se puido cargar este widget",
                requestFailedHelp: "Téntase de novo cando o panel se actualiza.",
            },
            dataTable: {
                title: "{{widget}} · datos",
                close: "Pechar",
                empty: "Sen filas",
                rowsPerPage: "Filas por páxina:",
                shownRows: "{{from}}–{{to}} de {{total}}",
                firstPage: "Primeira páxina",
                previousPage: "Páxina anterior",
                nextPage: "Páxina seguinte",
                lastPage: "Última páxina",
            },
            columns: {
                numerator: "Numerador",
                denominator: "Denominador",
                pct: "Porcentaxe",
                pct_label: "Porcentaxe mostrada",
                group: "Grupo",
                group_key: "Clave do grupo",
                post: "Posto",
                post_id: "ID do posto",
                region: "Rexión",
                country: "País",
                reason: "Motivo",
                category: "Categoría",
                state: "Estado",
                state_label: "Estado mostrado",
                bucket_start: "Inicio do período",
                bucket_label: "Período",
                bucket_utc: "Inicio do período (UTC)",
                measure: "Medida",
                label: "Etiqueta",
                value: "Valor",
            },
            measures: {
                registered: "Rexistrados",
                pre_enrolled: "Preinscritos",
                credentials_issued: "Credenciais emitidas",
                test_voted: "Votos de proba",
                voted: "Votaron",
                voted_pre_enrolled: "Preinscritos que votaron",
                applications: "Solicitudes",
                pending: "Pendentes",
                approved: "Aprobadas",
                disapproved: "Rexeitadas",
                posts: "Postos",
                initialized: "Inicializados",
                opened: "Abertos",
                paused: "En pausa",
                closed: "Pechados",
                tested: "Probados",
                locked_down: "Bloqueados",
                tallied: "Escrutados",
                transmitted: "Transmitidos",
                transmission_failed: "Transmisión fallida",
                logins: "Inicios de sesión",
                login_failures: "Inicios de sesión fallidos",
                login_failures_valid_user: "Fallidos, usuario válido",
                login_failures_unregistered: "Fallidos, usuario non rexistrado",
                password_resets: "Restablecementos de contrasinal",
                password_reset_requests: "Solicitudes de restablecemento de contrasinal",
                detections: "Deteccións",
                issues: "Incidencias",
                pending_issues: "Incidencias pendentes",
            },
            export: {
                title: "Exportar datos de monitorización",
                format: "Formato",
                csv: "CSV",
                sql: "SQL",
                from: "Desde",
                to: "Ata",
                timeZoneHelp: "As horas están en {{timeZone}}. Os totais, os estados e os grupos son os da actualización mostrada; só as filas das series de actividade se limitan ao intervalo, desde a hora de inicio ata a hora de fin, sen incluíla.",
                cancel: "Cancelar",
                export: "Exportar",
                invalidRange: "O fin debe ser posterior ao inicio.",
                problems: {
                    unknownSelector: "{{widget}} xa non ten a opción «{{selector}}». Recargue o panel e volva exportar.",
                    unknownOption: "O valor escollido para «{{selector}}» en {{widget}} xa non se ofrece. Escóllao de novo e exporte.",
                },
            },
            editor: {
                scopeSelector: {
                    region: "Rexión",
                    post: "Posto",
                    country: "País",
                },
                sources: {
                    voter_turnout: "Participación de votantes",
                    test_voting: "Votación de proba",
                    enrollment_decisions: "Decisións de inscrición",
                    voting_credentials: "Credenciais de votación",
                    poll_status: "Estado da mesa",
                    final_testing_lockdown: "Probas finais e bloqueo",
                    counting_transmission: "Reconto e transmisión",
                    voting_enrollment_activity: "Actividade de votación e inscrición",
                    access_security: "Acceso e seguridade",
                    attack_detections: "Deteccións de ataques",
                    helpdesk: "Asistencia técnica",
                },
                templates: {
                    summary: "Resumo",
                    by_group: "Por grupo",
                    by_post: "Por posto",
                    timeseries: "Ao longo do tempo",
                    by_measure: "Por medida",
                },
                yaml: {
                    label: "YAML",
                    readOnly: "O YAML ten un erro de sintaxe. Corríxao na pestana YAML para volver usar os formularios.",
                },
                diagnostics: {
                    title: "Comprobacións",
                    none: "Non se atopou ningún problema",
                    localUnavailable: "As comprobacións no navegador non están dispoñibles; os problemas aparecen tras a vista previa ou Validar.",
                    line: "Liña {{line}}",
                    engineCode: "dbt Charts {{code}}",
                    severity: {
                        ERROR: "Erro",
                        WARNING: "Aviso",
                    },
                    origin: {
                        SYNTAX: "Sintaxe YAML",
                        LOCAL: "Comprobación do navegador",
                        SERVER: "Comprobación do servidor",
                    },
                },
                footer: {
                    preview: "Vista previa",
                    valid: "Válido",
                    errors_one: "{{count}} erro",
                    errors_other: "{{count}} erros",
                    noWarnings: "sen avisos de gráficos",
                    warnings_one: "{{count}} aviso de gráfico",
                    warnings_other: "{{count}} avisos de gráficos",
                    rendering: "Xerando…",
                    previewFailed: "fallou a vista previa",
                    renderedIn: "xerado en {{ms}} ms",
                    revision: "Revisión {{revision}}",
                    savedBy: "gardado {{date}} por {{user}}",
                    unknownUser: "un administrador",
                    notSaved: "aínda sen gardar",
                    unsaved: "cambios sen gardar",
                    cancel: "Cancelar",
                    validate: "Validar",
                },
                preview: {
                    title: "Vista previa",
                    empty: "A vista previa aparece cando o YAML é válido.",
                    failed: "Non se puido xerar a vista previa: {{reason}}",
                    notConnectedTail: "Non se amosa nada ata que o estea.",
                    queryResult: "Resultado da consulta · primeiras filas",
                    noRows: "A consulta non devolveu filas.",
                    state: {
                        RENDERED: "Xerado",
                        NOT_CONNECTED: "Non conectado",
                        NO_SNAPSHOT: "Aínda sen datos",
                        SCOPE_PENDING: "Estase a contar este ámbito",
                        RENDER_FAILED: "Non se puido debuxar o gráfico",
                        INVALID: "A configuración non é válida",
                    },
                },
                configureWidget: {
                    title: "Configurar widget",
                    tabs: {
                        dataQuery: "Datos e consulta",
                        selectors: "Selectores",
                        yaml: "YAML",
                        preview: "Vista previa",
                    },
                    save: "Gardar widget",
                    loading: "Cargando o widget…",
                    loadFailed: "Non se puido cargar o widget: {{reason}}",
                    saved: "Widget gardado como revisión {{revision}}",
                    refused: "Non se gardou o widget: corrixa os problemas indicados.",
                    validated: "O widget é válido.",
                    invalid: "O widget ten problemas: consulte as comprobacións.",
                    requestFailed: "A solicitude fallou: {{reason}}",
                    discardTitle: "Descartar os cambios?",
                    discardBody: "Os cambios neste widget non se gardaron.",
                    discard: "Descartar",
                    keepEditing: "Seguir editando",
                },
                dataQuery: {
                    title: "Título",
                    source: "Fonte de datos",
                    template: "Consulta",
                    measures: "Medidas",
                    ratio: "Numerador / denominador",
                    numerator: "Numerador",
                    denominator: "Denominador",
                    groupBy: "Agrupar por",
                    sort: "Ordenar",
                    sortOrder: "Orde",
                    templateOrder: "A orde propia da consulta",
                    sortBy: {
                        label: "Etiqueta",
                        value: "Valor",
                        ratio: "Proporción",
                    },
                    order: {
                        asc: "Ascendente",
                        desc: "Descendente",
                    },
                    limit: "Filas",
                    noLimit: "Todas",
                    none: "Ningún",
                    fromSelector: "Desde o selector: {{name}}",
                    follow: "Seguir os selectores do panel",
                    followHelp: "Un selector sen marcar non limita este widget.",
                    manyQueries: "Este widget ten varias consultas; edíteas na pestana YAML.",
                    notConnected: "Non conectado · {{reason}}",
                    sourceHelp: {
                        DISTINCT_VOTERS: "Conta votantes distintos; as regras de reconto fíxaas a fonte de datos.",
                        DISTINCT_PRE_ENROLLED_VOTERS: "Conta votantes preinscritos distintos; as regras de reconto fíxaas a fonte de datos.",
                        LATEST_DECISION_PER_VOTER: "Conta a última decisión por votante; as regras de reconto fíxaas a fonte de datos.",
                        APPROVED_VOTERS: "Conta votantes aprobados; as regras de reconto fíxaas a fonte de datos.",
                        POSTS_IN_SCOPE: "Conta os postos do ámbito; as regras de reconto fíxaas a fonte de datos.",
                        FIRST_EVENT_PER_VOTER: "Conta o primeiro voto ou aprobación válido de cada votante; as regras de reconto fíxaas a fonte de datos.",
                        ATTEMPTS: "Conta intentos, non persoas; as regras de reconto fíxaas a fonte de datos.",
                        DETECTIONS: "Conta deteccións; as regras de reconto fíxaas a fonte de datos.",
                        REPORTED_ISSUES: "Conta incidencias notificadas; as regras de reconto fíxaas a fonte de datos.",
                        default: "As regras de reconto fíxaas a fonte de datos.",
                    },
                },
                selectors: {
                    help: "Os selectores aparecen na cabeceira do widget. Os seus valores alimentan a consulta; os selectores do panel (Rexión, Posto, País) aplícanse a todos os widgets.",
                    name: "Nome",
                    label: "Etiqueta",
                    control: "Control",
                    controls: {
                        dropdown: "Lista despregable",
                        toggle: "Interruptor",
                    },
                    default: "Predeterminado",
                    optionValue: "Valor",
                    optionLabel: "Etiqueta da opción",
                    addOption: "Engadir opción",
                    addSelector: "Engadir selector",
                    removeOption: "Quitar a opción {{option}}",
                    removeSelector: "Quitar o selector {{name}}",
                    moveUp: "Subir {{name}}",
                    moveDown: "Baixar {{name}}",
                    dynamic: "As opcións proceden dos datos ({{source}}).",
                    none: "Este widget non ten selectores.",
                    newLabel: "Novo selector",
                    newOption: "Nova opción",
                    shownWhen: "Amósase cando {{selector}} é {{values}}",
                },
                conflict: {
                    title: "Alguén gardou antes",
                    body: "{{user}} gardou a revisión {{revision}} ({{date}}) mentres vostede editaba.",
                    bodyShort: "Gardouse a revisión {{revision}} mentres vostede editaba.",
                    saved: "Revisión gardada",
                    mine: "Os meus cambios",
                    reload: "Recargar",
                    copy: "Copiar o meu YAML",
                    copied: "O seu YAML está no portapapeis.",
                    copyFailed: "O portapapeis non está dispoñible; seleccione o YAML e cópieo a man.",
                    keepEditing: "Seguir editando",
                    removed: "O documento eliminouse mentres vostede editaba. Siga editando para gardalo de novo.",
                },
                dashboard: {
                    editing: "Editando o panel",
                    title: "Título",
                    selectors: "Selectores do panel",
                    theme: "Tema",
                    editTheme: "Editar tema",
                    addWidget: "Engadir widget",
                    cancel: "Cancelar",
                    save: "Gardar panel",
                    width: "Largura",
                    widthValue: "{{n}} de 12",
                    moveUp: "Subir",
                    moveDown: "Baixar",
                    remove: "Quitar",
                    duplicate: "Duplicar",
                    configure: "Configurar widget",
                    empty: "Este panel aínda non ten widgets.",
                    saved: "Panel gardado como revisión {{revision}}",
                    refused: "Non se gardou o panel: corrixa os problemas indicados.",
                    requestFailed: "A solicitude fallou: {{reason}}",
                    dragHandle: "Arrastre para reordenar {{title}}",
                    widgets: "Widgets",
                    duplicated: "Duplicado como {{id}}",
                    resetToPreset: "Restablecer ao axuste predefinido",
                    actions: "Accións de {{title}}",
                    discardBody: "Os teus cambios neste panel non se gardaron.",
                    duplicateInvalid: "A copia non se gardou: {{problem}}",
                    layoutMalformed: "Algúns elementos do deseño non son un widget cun ancho. Corríxeos na lapela YAML para reordenar os widgets.",
                },
                catalog: {
                    title: "Engadir widget",
                    search: "Buscar widgets, fontes de datos ou requisitos",
                    add: "Engadir",
                    empty: "Ningún widget coincide.",
                    onDashboard: "Neste panel",
                    close: "Pechar",
                },
                theme: {
                    title: "Tema do panel",
                    subtitle: "estilo de dbt Charts aplicado a todos os widgets deste panel",
                    appliesTo_one: "aplícase a {{count}} widget",
                    appliesTo_other: "aplícase a {{count}} widgets",
                    apply: "Aplicar tema",
                    saved: "Tema gardado como revisión {{revision}}",
                    discardBody: "Os cambios neste tema non se gardaron.",
                },
                reset: {
                    title: "Restablecer ao axuste predefinido",
                    body: "Todos os paneis, widgets e temas deste evento substitúense polos do axuste predefinido. A configuración actual permanece no historial.",
                    preset: "Axuste predefinido",
                    confirm: "Restablecer",
                    cancel: "Cancelar",
                    done: "O evento usa agora {{title}}.",
                    failed: "O restablecemento fallou: {{reason}}",
                    noPresets: "Non hai axustes predefinidos dispoñibles.",
                    loading: "Cargando os axustes predefinidos…",
                },
                lockedDown: "O evento está bloqueado; a súa configuración de monitorización non pode cambiar.",
                document: {
                    loadFailed: "Non se puido cargar o documento: {{reason}}",
                    refused: "Non se gardou: corrixe os problemas indicados.",
                    validated: "O documento é válido.",
                    invalid: "O documento ten problemas: consulta as comprobacións.",
                    requestFailed: "A solicitude fallou: {{reason}}",
                    savedWithWarnings_one: "{{count}} aviso: consulta as comprobacións.",
                    savedWithWarnings_other: "{{count}} avisos: consulta as comprobacións.",
                },
                errors: {
                    checksUnavailable: "O motor de gráficos non puido comprobar o cambio, así que non se gardou. Téntao de novo nun momento.",
                    busy: "Estanse a gardar outros cambios deste evento. Téntao de novo nun momento.",
                    lockedDown: "O evento está bloqueado; a súa configuración de monitorización non pode cambiar.",
                    forbiddenScope: "Non podes ver cifras da rexión, o posto ou o país escollidos.",
                    badRequest: "O editor enviou unha solicitude que o servidor non puido ler. Recargue a páxina e ténteo de novo.",
                },
                duplicate: {
                    copyTitle: "{{title}} (copia)",
                    done: "Engadiuse {{id}}, unha copia do widget, ao panel.",
                    failed: "Non se puido duplicar o widget: {{reason}}",
                    notPlaced: "A copia {{id}} gardouse, pero o panel non a incluíu ({{reason}}). Engádaa con Editar panel.",
                },
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Votantes",
                enrolledOverseasVoters: "Votantes Inscritos en el Extranjero",
                approvalStatus: "Estado de Aprobación: Votantes Aprobados/Desaprobados",
                manuallyApproval: "Votantes Aprobados/Desaprobados Manualmente",
                automaticallyApproval: "Votantes Aprobados/Desaprobados Automáticamente",
                authenticatedVoters: "Votantes Autenticados",
                invalidUserErrors: "Errores de Usuario Inválido:",
                invalidPasswordErrors: "Errores de Contraseña Inválida:",
            },
            polls: {
                title: "Encuestas",
                initializedSystems: "Publicaciones con Sistemas Inicializados",
                votingOpened: "Publicaciones con Votación Abierta",
                votingClosed: "Publicaciones con Votación Cerrada",
                votingStarted: "Publicaciones con Votación Iniciada",
                voterTurnout: "Participación de los Votantes",
            },
            tally: {
                title: "Conteo",
                activeVotesCounting: "Publicaciones con Conteo de Votos Activo",
                generatedERs: "Publicaciones con ERs Generados",
                transmittedResults: "Publicaciones con Resultados Transmitidos",
            },
            testing: {
                title: "Pruebas",
                testElectionVoterCount: "Conteo de Votantes en Elección de Prueba",
            },
        },
        certificateAuthorities: {
            title: "Certificados",
            subtitle: "Autoridades de certificación (CA) de confianza para este evento electoral. As CA importadas úsanse para validar os certificados dos votantes.",
            importButton: "Importar certificados",
            type: {
                root: "Raíz",
                intermediate: "Intermedio",
            },
            expiry: {
                expired: "Caducado",
                expiringSoon: "Próximo a caducar",
                valid: "Válido",
            },
            columns: {
                commonName: "Nome común",
                type: "Tipo",
                issuerCn: "CN do emisor",
                notBefore: "Válido desde",
                notAfter: "Caduca",
                fingerprint: "Pegada SHA256",
            },
            importDialog: {
                title: "Importar autoridades de certificación",
                subtitle: "Importar un ou máis certificados CA desde un ficheiro PEM",
                description: "Seleccione un ficheiro PEM que conteña un ou máis certificados. Admítense paquetes — cada certificado impórtase individualmente.",
                selectFile: "Seleccionar ficheiro PEM",
                fileLoaded: "Ficheiro cargado ({{bytes}} bytes)",
                importButton: "Importar",
            },
            notify: {
                importSuccess: "Importáronse {{inserted}} certificado(s).",
                importSkipped: "{{count}} omitido(s) (xa presentes).",
                importErrors: "Problemas na importación: {{errors}}",
                importError: "Erro ao importar: {{error}}",
                deleteSuccess: "Certificado eliminado.",
                deleteError: "Erro ao eliminar o certificado.",
                exportSuccess: "Certificado(s) exportado(s) correctamente.",
                exportError: "Erro ao exportar os certificados.",
            },
            exportDialog: {
                title: "Exportar autoridades de certificación",
                description: "Está a punto de exportar {{amount}} certificado(s).",
                all: "todos",
            },
            deleteDialog: {
                description: "¿Está seguro de que desexa eliminar {{count}} certificado(s)?",
            },
            emptyHeader: "Non se importaron autoridades de certificación para este evento electoral.",
            fileReadError: "Erro ao ler o ficheiro.",
            viewDialog: {
                title: "Detalles da autoridade de certificación",
                subject: "Asunto",
                issuer: "Emisor",
                serialNumber: "Número de serie",
                pemContent: "Contido PEM",
            },
            confirmDelete: "Eliminar autoridade de certificación",
            confirmDeleteDescription: '¿Está seguro de que quere eliminar o certificado "{{name}}" (pegada: {{fingerprint}})?',
        },
        signing: {
            terms: {
                post: "Posto",
                posts: "Postos",
            },
            tab: {
                title: "Sinaturas",
                intro: "As accións protexidas só se executan cando abondas persoas autorizadas as asinan cos seus certificados dixitais. Cada sinatura compróbase cos emisores de confianza e queda anotada no rexistro.",
                protectedActions: "Accións protexidas",
                certificates: "Certificados",
                requests: "Solicitudes",
            },
            loadError: "Non se puido cargar a configuración de sinaturas. Recargue a páxina para tentalo de novo.",
            errors: {
                automatedCeremonies: "Este evento utiliza cerimonias de claves automáticas. Os custodios non realizan estes pasos, polo que non se poden esixir as súas sinaturas. Para esixir as sinaturas dos custodios, utiliza cerimonias de claves manuais.",
                forbidden: "Non ten permiso para este cambio.",
                invalid: "O servidor rexeitou estes valores. Revíseos e ténteo de novo.",
                conflict: "Outra persoa cambiouno mentres tanto. Recargue a páxina e ténteo de novo.",
                lockedDown: "O evento electoral está bloqueado: as regras de sinatura só cambian mediante unha nova versión de configuración.",
                notFound: "Xa non existe. Recargue a páxina.",
            },
            readOnly: {
                chip: "Só lectura",
                rules: "Só lectura. Para cambiar as regras de sinatura cómpre o permiso «Sinaturas: editar accións protexidas».",
                whoCanSign: "Roles co permiso «Asinar: {{action}}» en Usuarios e Roles. Para cambialos cómpre permiso para editar roles.",
            },
            groups: {
                "voting": "Votación",
                "results-and-reports": "Resultados e informes",
                "enrollment": "Inscrición",
                "configuration-and-keys": "Configuración e chaves",
            },
            actions: {
                "initialize-voting": {
                    label: "Inicializar a votación",
                    short: "Inicialización",
                    permissionName: "inicializar a votación",
                    object: "inicialización da votación",
                    appliesTo: "Cada $t(signing.terms.post)",
                    description: "Iníciase en Publicar. Inicializa o $t(signing.terms.post) e xera o seu Informe de Inicialización.",
                },
                "open-voting": {
                    label: "Abrir a votación",
                    short: "Apertura",
                    permissionName: "abrir a votación",
                    object: "apertura da votación",
                    appliesTo: "Cada $t(signing.terms.post)",
                    description: "Iníciase en Publicar con Iniciar Votación. Abre a votación no $t(signing.terms.post).",
                },
                "close-voting": {
                    label: "Pechar a votación",
                    short: "Peche",
                    permissionName: "pechar a votación",
                    object: "peche da votación",
                    appliesTo: "Cada $t(signing.terms.post)",
                    description: "Iníciase en Publicar con Detener Votación. Pecha a votación no $t(signing.terms.post); as sinaturas de peche consérvanse na súa acta.",
                    descriptionSealed: "Iníciase en Publicar con Detener Votación. Pecha a votación no $t(signing.terms.post). Cando todas as canles están pechadas, as súas urnas sélanse, tras o período de graza se o hai: non se pode engadir, cambiar nin borrar ningunha papeleta, e a votación non pode volver comezar. As sinaturas de peche consérvanse na súa acta.",
                },
                "generate-election-returns": {
                    label: "Xerar actas electorais",
                    short: "Actas electorais",
                    permissionName: "xerar actas electorais",
                    object: "actas electorais",
                    appliesTo: "Cada $t(signing.terms.post) e país",
                    description: "Iníciao o escrutinio, unha solicitude por $t(signing.terms.post) e país. Libera as actas electorais asinadas para a súa impresión e transmisión.",
                },
                "generate-reports": {
                    label: "Xerar outros informes electorais",
                    short: "Informe",
                    permissionName: "xerar outros informes electorais",
                    object: "informe",
                    appliesTo: "Cada $t(signing.terms.post)",
                    description: "Iníciao o escrutinio para o Informe de Inicialización e Informes para o informe de participación. Libera o informe asinado.",
                },
                "transmit-results": {
                    label: "Transmitir resultados",
                    short: "Transmisión",
                    permissionName: "transmitir resultados",
                    object: "paquete de resultados",
                    appliesTo: "Cada $t(signing.terms.post) e país",
                    description: "Iníciase en Escrutinio, Transmisión. Xera o paquete de resultados asinado para os seus destinos; as sinaturas completan a súa lista de sinaturas.",
                },
                "approve-voter": {
                    label: "Aprobar manualmente un votante",
                    short: "Aprobación de votante",
                    permissionName: "aprobar manualmente un votante",
                    object: "aprobación de votante",
                    appliesTo: "O $t(signing.terms.post) do votante",
                    description: "Iníciase en Aprobacións. Aproba o votante e emite as súas credenciais.",
                },
                "approve-configuration": {
                    label: "Aprobar unha versión de configuración",
                    short: "Versión de configuración",
                    permissionName: "aprobar unha versión de configuración",
                    object: "versión de configuración",
                    appliesTo: "O evento electoral",
                    description: "Iníciase en Publicar. Publica a versión de configuración.",
                },
                "key-ceremony": {
                    label: "Confirmar un fragmento de chave (cerimonia de chaves)",
                    short: "Fragmento de chave",
                    permissionName: "confirmar un fragmento de chave",
                    object: "fragmento de chave",
                    appliesTo: "Cada fiduciario",
                    description: "Iníciao cada fiduciario en Chaves. Anota a sinatura do fiduciario na cerimonia e no taboleiro de anuncios.",
                },
                "tally-key": {
                    label: "Achegar un fragmento de chave (escrutinio)",
                    short: "Achega de fragmento de chave",
                    permissionName: "achegar un fragmento de chave",
                    object: "achega de fragmento de chave",
                    appliesTo: "Cada fiduciario",
                    description: "Iníciao cada fiduciario en Escrutinio. Anota a achega do fiduciario.",
                },
            },
            protectedActions: {
                intro: "Cada sinatura faise co certificado dixital do token de seguranza do asinante.",
                columns: {
                    action: "Acción",
                    appliesTo: "Aplícase a",
                    whoCanSign: "Quen pode asinar",
                    signaturesNeeded: "Sinaturas necesarias",
                    requestExpires: "Caducidade da solicitude",
                    waiting: "En espera",
                },
                off: "Desactivada",
                eachTrustee: "Cada fiduciario",
                footerVersion: "As regras de sinatura forman parte da versión de configuración {{version}} deste evento.",
                footerFirstVersion: "As regras de sinatura pasarán a formar parte da primeira versión de configuración deste evento cando se publique.",
                footerChanged: "Último cambio: {{date}}.",
                footerChangedBy: "Último cambio: {{date}}, por {{name}}.",
                lockedDown: "O evento electoral está bloqueado: as súas regras de sinatura pertencen á súa versión de configuración, polo que só cambian mediante unha nova versión de configuración.",
                edit: "Editar {{action}}",
                view: "Ver {{action}}",
                waitingCount_one: "{{count}} solicitude en espera",
                waitingCount_other: "{{count}} solicitudes en espera",
                capacityError: "Non se puido cargar quen pode asinar, así que o número de sinaturas non se pode comprobar cos $t(signing.terms.posts).",
            },
            expiry: {
                "30": "30 minutos",
                "60": "1 hora",
                "120": "2 horas",
                "1440": "24 horas",
                "none": "Sen límite",
                "other": "{{count}} minutos",
            },
            rule: {
                needsSignatures: "Require sinaturas",
                whoCanSign: "Quen pode asinar",
                whoCanSignHelp: "Estes roles reciben o permiso «Asinar: {{action}}» en Usuarios e Roles, para todos os eventos electorais. Os asinantes tamén deben ter acceso ao $t(signing.terms.post).",
                signaturesNeeded: "Sinaturas necesarias",
                signaturesNeededHelp: "Cada asinante usa o seu certificado dixital. Cada $t(signing.terms.post) ten polo menos {{n}} persoas que poden asinar.",
                signaturesNeededShortHelp: "Cada asinante usa o seu certificado dixital.",
                requesterSigning: "A persoa que a inicia tamén pode asinar",
                expiresAfter: "Unha solicitude caduca despois de",
                trusteesSign: "Os fiduciarios asinan este paso",
                trusteesHelp: "Cada fiduciario asina o seu propio paso co seu certificado dixital. A cerimonia de chaves determina cantos fiduciarios participan.",
                footer: "Os cambios quedan anotados no rexistro do evento electoral e pasan a formar parte da seguinte versión de configuración.",
                cancel: "Cancelar",
                save: "Gardar",
                saved: "Gardouse a regra de sinatura.",
                savedShort_one: "Gardouse a regra de sinatura. {{posts}} aínda non pode alcanzar o número: engada alí un asinante.",
                savedShort_other: "Gardouse a regra de sinatura. {{posts}} aínda non poden alcanzar o número: engada alí asinantes.",
                checkedOnSave: "O número compróbase cos novos roles ao gardar.",
                savedRequesterShort: "Gardouse a regra de sinatura. Algúns $t(signing.terms.posts) non poden alcanzar o número sen a persoa que inicia unha solicitude.",
                saveError: "Non se puido gardar a regra de sinatura. Pode que outra persoa a cambiase mentres tanto; recargue e ténteo de novo.",
            },
            validation: {
                atLeastOne: "Polo menos 1.",
                tooMany: "Ningún $t(signing.terms.post) ten {{n}} persoas que poidan asinar. O máximo é {{max}}.",
                tooManyEvent: "Só {{max}} persoas poden asinar isto. Escolla como máximo {{max}}.",
                atMost: "Como máximo {{max}}.",
                shortPosts_one: "{{posts}} só ten {{n}} persoas que poden asinar, así que non pode alcanzar {{required}} sinaturas. Engada alí un asinante ou reduza o número.",
                requesterShort_one: "Sen a persoa que a inicia, {{posts}} só ten {{n}} persoas que poden asinar, así que non pode alcanzar {{required}} sinaturas.",
                requesterShort_other: "Sen a persoa que a inicia, {{posts}} só teñen {{n}} persoas que poden asinar, así que non poden alcanzar {{required}} sinaturas.",
                shortPosts_other: "{{posts}} só teñen {{n}} persoas que poden asinar, así que non poden alcanzar {{required}} sinaturas. Engada alí un asinante ou reduza o número.",
            },
            pendingRequests_one: "{{count}} solicitude está agardando sinaturas coa regra actual. Ao gardar cancélase; a persoa que a iniciou terá que comezar de novo.",
            pendingRequests_other: "{{count}} solicitudes están agardando sinaturas coa regra actual. Ao gardar cancélanse; as persoas que as iniciaron terán que comezar de novo.",
            certificates: {
                issuersIntro: "Os certificados do persoal deben encadear cun destes. Son distintos dos certificados cos que inician sesión os votantes.",
                checkRevocation: "Comprobar as listas de revogación",
                crlUnavailable: {
                    "label": "Cando non se pode descargar unha lista",
                    "refuse": "Non aceptar sinaturas",
                    "accept-unchecked": "Aceptar e marcar a sinatura como non comprobada",
                },
                registration: {
                    "label": "Rexistro dun certificado a nome dunha persoa",
                    "on-first-use": "Cando o seu titular asina con el por primeira vez",
                    "security-officer-only": "Só cando o rexistra alguén que pode rexistrar certificados",
                },
                onePost: "Un certificado asina só para un $t(signing.terms.post)",
                issuers: "Emisores de confianza",
                import: "Importar certificados de emisores",
                importHelp: "Escolla un ficheiro PEM ou CER co certificado do emisor. Un ficheiro PEM pode conter varios certificados.",
                chooseFile: "Escoller un ficheiro de certificado",
                fileError: "Non se puido ler o ficheiro.",
                imported: "{{imported}} certificados de emisores importados; {{skipped}} xa eran de confianza.",
                importedWithErrors: "{{imported}} certificados de emisores importados, {{skipped}} xa eran de confianza. Rexeitados: {{errors}}",
                importError: "Non se puideron importar os certificados de emisores.",
                deleteIssuer: "Eliminar {{name}}",
                deleteIssuerConfirm: "Eliminar {{name}} dos emisores de confianza? Os certificados que emitiu xa non poderán asinar.",
                deleteError: "Non se puido eliminar o emisor.",
                noIssuers: "Aínda non hai emisores de confianza. O persoal non pode asinar ata que se importe un.",
                root: "Raíz",
                intermediate: "Intermedio",
                columns: {
                    issuer: "Emisor",
                    type: "Tipo",
                    issuedBy: "Emitido por",
                    validUntil: "Válido ata",
                    sha256: "SHA-256",
                    person: "Persoa",
                    post: "$t(signing.terms.post)",
                    certificate: "Certificado",
                    registered: "Rexistrado",
                    status: "Estado",
                },
                checks: "Comprobacións",
                checksSaved: "Gardáronse as comprobacións de certificados.",
                checksError: "Non se puideron gardar as comprobacións de certificados.",
                crlSchedule: "Descárganse de cada emisor cada hora.",
                crlUpdated: "{{url}}: actualizada {{time}}",
                crlFailed: "{{url}}: non se puido descargar (último intento {{time}})",
                registeredTitle: "Certificados rexistrados",
                search: "Buscar persoas, certificados ou $t(signing.terms.posts)",
                status: "Estado",
                statusAll: "Todos",
                statuses: {
                    "active": "Activo",
                    "expires-soon": "Caduca pronto",
                    "expired": "Caducado",
                    "revoked": "Revogado",
                },
                revokedOn: "Revogado o {{date}}",
                allPosts: "Todos",
                noCertificates: "Non hai certificados rexistrados.",
                registeredHow: {
                    "first-use": "Na primeira sinatura",
                    "security-officer": "Rexistrado por un administrador",
                },
                register: "Rexistrar un certificado",
                registerSubmit: "Rexistrar",
                registerDone: "Rexistrouse o certificado.",
                registerError: "Non se puido rexistrar o certificado.",
                person: "Persoa",
                personSearchHelp: "Escriba parte dun nome de usuario para atopar a persoa.",
                registeredBy: "Por {{name}}",
                registerRefused: "Este certificado non se pode rexistrar: comprobe que o emitiu un emisor de confianza, que é válido hoxe e que está destinado a asinar.",
                registeredToOther: "Este certificado está rexistrado a nome de {{name}}. Se esta conta tamén é de {{name}}, vincúlea como a súa segunda conta.",
                linkAccount: "Vincular como segunda conta da mesma persoa",
                alreadyRegistered: "Este certificado xa está rexistrado a nome desta persoa.",
                pem: "Certificado (PEM)",
                revoke: "Revogar",
                revokeOf: "Revogar o certificado de {{name}}",
                revokeTitle: "Revogar o certificado de {{name}}",
                revokeHelp: "Un certificado revogado xa non pode asinar. As sinaturas que xa fixo seguen sendo válidas.",
                revokeReason: "Motivo",
                revokeDone: "Revogouse o certificado.",
                revokeError: "Non se puido revogar o certificado.",
            },
            requests: {
                exportCsv: "Exportar CSV",
                exportError: "Non se puideron exportar as solicitudes.",
                exportFileName: "signing-requests.csv",
                status: "Estado",
                statusAll: "Todas",
                statusCount: "{{status}} · {{count}} de {{total}}",
                expires: "Caduca {{time}}",
                lastSignatureBy: "{{name}}, {{time}}",
                empty: "Aínda non hai solicitudes de sinatura.",
                columns: {
                    request: "Solicitude",
                    status: "Estado",
                    started: "Iniciada",
                    by: "Por",
                    lastSignature: "Última sinatura",
                    code: "Código",
                },
            },
            reports: {
                postRequired: "Selecciona un posto para xerar este informe cando se requiren sinaturas.",
                generateNotice: "{{post}}: o documento xérase agora. Poderase imprimir e transmitir cando o asinen {{n}} persoas.",
            },
            status: {
                waiting: "En espera",
                completed: "Asinada",
                executed: "Feita",
                cancelled: "Cancelada",
                expired: "Caducada",
                failed: "Fallida",
            },
            cancelReasons: {
                "by-requester": "A persoa que a iniciou cancelouna",
                "by-operator": "Un operador cancelouna",
                "rule-changed": "Cambiou a regra de sinatura da acción",
                "payload-changed": "Cambiou o que se asina",
                "superseded": "Unha solicitude máis recente substituíuna",
                "certificate-revoked": "Revogouse un certificado que a asinou",
            },
            panel: {
                rulePost: "Require {{n}} sinaturas dos asinantes de {{post}}, cada unha co seu certificado dixital.",
                ruleEvent: "Require {{n}} sinaturas, cada unha co certificado dixital do asinante.",
                signingCode: "Código de sinatura",
                signers: "Asinantes",
                sign: "Asinar",
                handover: "O seguinte membro inicia sesión",
                cancel: "Cancelar a solicitude",
                signedAt: "Asinado {{time}}",
                notSigned: "Sen asinar",
                certificate: "Certificado {{name}}",
                you: "(vostede)",
                expiresAt: "Caduca ás {{time}}",
                progress: "{{count}} de {{total}}",
                openDocument: "Abrir o documento",
                configurationVersion: "Versión de configuración {{version}}",
                configurationChanges: "Cambios nesta versión",
            },
            dialog: {
                title: "Asinar {{object}}",
                steps: {
                    check: "Revisar",
                    certificate: "Certificado",
                    signed: "Asinado",
                },
                localNote: "A sinatura faise neste navegador. O seu ficheiro de certificado, a súa chave privada e o seu contrasinal nunca se envían. Só a súa sinatura e o seu certificado público chegan ao servidor.",
                check: {
                    signingAs: "Está a asinar como {{name}}",
                    titlePost: "{{title}}, {{post}}",
                    sameCode: "Todas as persoas que asinan ven o mesmo código.",
                    confirmDocument: "Revisei o que asino: {{object}}",
                },
                certificate: {
                    intro: "Insira o seu token de seguranza e escolla o seu ficheiro de certificado.",
                    password: "Contrasinal do certificado",
                    open: "Abrir o certificado",
                    chooseAnother: "Escoller outro ficheiro",
                },
                checks: {
                    "passed": {
                        "trusted-issuer": "Emitido por un emisor de confianza ({{root}})",
                        "valid-now": "Válido hoxe",
                        "signing-key-usage": "Destinado a asinar",
                        "not-revoked": "Non revogado (listas actualizadas {{time}})",
                        "registered": "Rexistrado ao seu nome o {{date}}",
                        "registered-to-other": "Non rexistrado a nome doutra persoa",
                        "already-signed": "Aínda non usado para esta solicitude",
                        "post-binding": "Rexistrado para este $t(signing.terms.post)",
                        "signature": "A sinatura cobre esta solicitude",
                    },
                    "failed": {
                        "trusted-issuer": "Non emitido por un emisor de confianza",
                        "valid-now": "Non válido hoxe",
                        "signing-key-usage": "Non destinado a asinar",
                        "not-revoked": "Revogado, ou non hai unha lista de revogación vixente para comprobalo",
                        "registered": "Non rexistrado ao seu nome",
                        "registered-to-other": "Rexistrado a nome de {{name}}",
                        "already-signed": "Xa usado para esta solicitude",
                        "post-binding": "Rexistrado para outro $t(signing.terms.post)",
                        "signature": "A sinatura non cobre esta solicitude",
                    },
                    "first-use": "Primeiro uso: rexistrarase ao seu nome",
                },
                problems: {
                    wrongPassword: "Contrasinal incorrecto. Revíseo e ténteo de novo.",
                    notForYou: "Este certificado non pode asinar por vostede. Use o certificado do seu propio token de seguranza.",
                    issuerNotAccepted: "Use o certificado que {{organization}} rexistrou para vostede. Non se aceptan certificados doutros emisores.",
                    cancelled: "Esta solicitude cancelouse: {{reason}}. As sinaturas dadas para ela xa non contan. Iníciea de novo para asinar a versión actual.",
                },
                signed: {
                    title: "Asinado",
                    withCertificate: "co certificado de {{name}}",
                    count: "{{n}} de {{total}} sinaturas.",
                    allIn: "Xa están as {{total}} sinaturas.",
                    next: "A continuación asinan: {{names}}.",
                },
                handover: "Pecharase a súa sesión. O seguinte membro inicia sesión neste equipo e volve a esta solicitude para asinar. A solicitude segue aberta ata as {{time}}.",
                sign: "Asinar",
                back: "Atrás",
                cancel: "Cancelar",
            },
            widget: {
                continue: "Continuar",
                done: "Feito",
                close: "Pechar",
                retry: "Tentar de novo",
                loading: "Cargando a solicitude…",
                loadError: "Non se puido cargar a solicitude.",
                chooseFile: "Escoller ficheiro de certificado",
                fileInput: "Ficheiro de certificado",
                fileSize: "{{size}} KB",
                showPassword: "Mostrar o contrasinal",
                hidePassword: "Ocultar o contrasinal",
                opening: "Abrindo o certificado…",
                checking: "Comprobando o certificado…",
                signing: "Asinando…",
                certificateCard: "Emitido por {{issuer}} · válido ata {{date}} · {{algorithm}}",
                fingerprint: "SHA-256 {{fingerprint}}",
                algorithms: {
                    "rsa-pkcs1-sha256": "RSA",
                    "ecdsa-p256-sha256": "EC P-256",
                },
                document: "{{type}} · SHA-256 {{hash}}",
                documentPages: "{{type}} · {{pages}} páxinas · SHA-256 {{hash}}",
                checksTitle: "Comprobacións do certificado",
                untrustedIssuer: "{{issuer}} non é un emisor de confianza para este evento electoral",
                registeredToSomeoneElse: "Rexistrado a nome doutra persoa",
                checkPassedNoDetail: {
                    "trusted-issuer": "Emitido por un emisor de confianza",
                    "not-revoked": "Non revogado",
                },
                organization: "a súa organización",
                cantSign: "Este certificado non pode asinar esta solicitude.",
                checkError: "Non se puido comprobar o certificado. Ténteo de novo.",
                fileErrors: {
                    UNREADABLE_FILE: "Este ficheiro non é un ficheiro de certificado (.p12 ou .pfx), ou está danado.",
                    UNSUPPORTED_ENCRYPTION: "Este navegador non pode abrir o cifrado que usa este ficheiro.",
                    NO_PRIVATE_KEY: "Este ficheiro non ten chave privada. Escolla o ficheiro de certificado do seu token de seguranza.",
                    NO_CERTIFICATE: "Este ficheiro non ten ningún certificado.",
                    UNSUPPORTED_KEY: "O tipo de chave deste certificado non é compatible. Use un certificado RSA ou EC P-256.",
                    KEY_CERTIFICATE_MISMATCH: "O certificado deste ficheiro non coincide coa súa chave.",
                },
                openError: "Non se puido abrir o certificado. Ténteo de novo.",
                signError: "Non se puido enviar a sinatura. Ténteo de novo.",
                refused: "O servidor rexeitou a sinatura.",
                stale: "O documento cambiou mentres asinaba. Asine de novo.",
                mismatch: "O que se asinaría non coincide con esta solicitude. Peche o diálogo e volva abrir a solicitude.",
                documentMismatch: "O documento non coincide co que asina esta solicitude.",
                documentError: "Non se puido descargar o documento. Ténteo de novo.",
                alreadySigned: "Xa asinou esta solicitude.",
                closed: {
                    changed: "Esta solicitude cambiou despois de abrila. Peche esta xanela e revísea de novo antes de asinar.",
                    allSigned: "Esta solicitude xa ten todas as súas sinaturas.",
                },
                chooseCertificate: "Certificado co que asinar",
                renderError: "Non se puido mostrar a solicitude de sinatura. Péchea e vólvaa abrir.",
                signedAt: "{{time}}",
                panel: {
                    completedAt: "Asinada ás {{time}}",
                    expired: "Esta solicitude caducou. As sinaturas dadas para ela xa non contan. Iníciea de novo para asinar.",
                    failed: "Están todas as sinaturas, pero a acción fallou. O rexistro ten os detalles.",
                    details: "Detalles",
                    close: "Pechar o panel da solicitude",
                },
                cancelDialog: {
                    title: "Cancelar esta solicitude?",
                    body: "As sinaturas dadas para ela xa non contan. A persoa que a iniciou terá que comezar de novo.",
                    reason: "Motivo (opcional)",
                    confirm: "Cancelar a solicitude",
                    back: "Mantela",
                    error: "Non se puido cancelar a solicitude. Ténteo de novo.",
                },
                handoverDialog: {
                    title: "O seguinte membro inicia sesión",
                    noExpiry: "Pecharase a súa sesión. O seguinte membro inicia sesión neste equipo e volve a esta solicitude para asinar.",
                    confirm: "Pechar sesión",
                    back: "Manter a sesión",
                    error: "Non se puido rexistrar o relevo. Ténteo de novo.",
                },
            },
            details: {
                keys_ceremony_id: "Cerimonia",
                tally_session_id: "Sesión de escrutinio",
                trustee_id: "Fiduciario",
                custody_proof_sha256: "SHA-256 do proba de custodia",
                channel: "Canle",
                channels: "Canles",
                publication_id: "Publicación de papeletas",
                ballot_publication_id: "Publicación de papeletas",
                digest: "SHA-256 da configuración",
                signing_rules: "Regras de sinatura",
                scheduled_events: "Novos eventos programados",
                ballots_and_contests: "Papeletas e concursos",
                application_id: "Solicitude de inscrición",
                applicant_registry_id: "Conta do rexistro",
                decision: "Decisión",
                submitted_at: "Enviada",
                reason: "Por que require unha persoa",
                registry_record: "Rexistro do censo",
                status: "Estado da solicitude de inscrición",
                from: "Estado anterior",
            },
            closed: {
                pending: "Están todas as sinaturas. A votación péchase nun momento.",
                title: "A votación pechouse ás {{time}}.",
                titleSealed: "A votación pechouse ás {{time}}. Papeletas seladas.",
                record: "Acta de selado",
                ballots: "Papeletas no selo",
                sealHash: "{{algorithm}} do selo",
                signedBy: "Asinado por",
                signatures: "Sinaturas de peche na acta de selado",
                signaturesValue_one: "{{count}}, código de sinatura {{code}}",
                signaturesValue_other: "{{count}}, código de sinatura {{code}}",
                signers: "Asinado polos membros",
            },
            values: {
                ballots_and_contests: {
                    "first-version": "Primeira versión",
                    "no-changes": "Sen cambios",
                    "changed": "Con cambios",
                },
                signing_rules: {
                    "initialize-voting": "$t(signing.actions.initialize-voting.label)",
                    "open-voting": "$t(signing.actions.open-voting.label)",
                    "close-voting": "$t(signing.actions.close-voting.label)",
                    "generate-election-returns": "$t(signing.actions.generate-election-returns.label)",
                    "generate-reports": "$t(signing.actions.generate-reports.label)",
                    "transmit-results": "$t(signing.actions.transmit-results.label)",
                    "approve-voter": "$t(signing.actions.approve-voter.label)",
                    "approve-configuration": "$t(signing.actions.approve-configuration.label)",
                    "key-ceremony": "$t(signing.actions.key-ceremony.label)",
                    "tally-key": "$t(signing.actions.tally-key.label)",
                },
                channels: {
                    ONLINE: "En liña",
                    KIOSK: "Quiosco",
                    EARLY_VOTING: "Votación anticipada",
                    TELEPHONE: "Teléfono",
                },
                statuses: {
                    NOT_STARTED: "Non iniciada",
                    OPEN: "Aberta",
                    PAUSED: "En pausa",
                    CLOSED: "Pechada",
                },
                channelStatus: "{{channel}}: {{status}}",
                ruleChange: "{{action}}: {{rule}}",
                ruleChangeFrom: "{{action}}: {{rule}} (antes {{was}})",
                ruleNeeds: "precisa {{n}}",
                ruleOff: "desactivada",
                decision: {
                    approve: "Aprobar",
                },
            },
            results: {
                signatures: "Sinaturas",
                needs: "Require {{n}}",
                off: "Desactivada",
                openRequest: "Abrir a solicitude de sinatura",
                downloadSigned: "Descargar o PDF asinado",
                print: "Imprimir",
                transmit: "Transmitir resultados",
                sendTo: "Enviar a {{count}} destinos",
                awaiting: "{{item}}: agardando sinaturas",
                transmission: {
                    title: "Sinaturas",
                    description: "Cada asinante asina os resultados do paquete co seu certificado dixital, neste navegador. O paquete pódese enviar cando o asinen {{n}} persoas.",
                    waiting: "O paquete pódese enviar cando a súa solicitude de sinatura teña todas as sinaturas.",
                    signed: "O paquete leva todas as súas sinaturas e pódese enviar.",
                    ended: "A solicitude de sinatura deste paquete rematou. Volva crear o paquete para asinalo.",
                },
            },
            waiting: {
                title: "Pendente da miña sinatura",
                buttonCount_one: "Pendente da miña sinatura: {{count}} solicitude por asinar",
                buttonCount_other: "Pendente da miña sinatura: {{count}} solicitudes por asinar",
                intro: "Solicitudes que agardan as sinaturas das accións que pode asinar, nos seus $t(signing.terms.posts).",
                close: "Pechar a lista",
                empty: "Non hai nada pendente da súa sinatura.",
                loadError: "Non se puideron cargar as solicitudes que agardan sinaturas.",
                signedByYou: "Asinada por vostede",
            },
            notes: {
                afterApproval: "Despois da aprobación",
                afterApprovalValue: "Emítense as credenciais do votante e envíanselle",
                custodyProof: "O seu proba de custodia",
                custodyProofChecked: "Comprobado: é o seu proba de custodia para esta cerimonia",
                recordedIn: "Anótase en",
                recordedInCeremony: "A cerimonia de chaves e o taboleiro de anuncios",
                recordedInTally: "A sesión de escrutinio",
            },
            custodyProof: {
                signing: "Asine o seu proba de custodia no panel de sinatura. Anótase unha vez que o asine.",
                record: "Anotar o meu proba de custodia",
                failed: "Non se puido anotar o seu proba de custodia asinado: {{error}}",
                dropAgain: "Volva soltar o seu ficheiro de proba de custodia para anotar o seu proba de custodia asinado. (signed-custody-proof.json)",
                redo: "O seu proba de custodia achegouse sen a súa sinatura, que esta elección agora require. Achégueo de novo e asíneo.",
                notTaken: "A cerimonia xa non acepta este proba de custodia. Volva soltar o seu ficheiro de proba de custodia. (signed-custody-proof.json)",
            },
        },
        lifecycle: {
            signedClose: {
                title: "Prazo de peche asinado",
                deadline: "{{election}}: {{time}} · autorizado pola configuración {{code}}.",
                explanation: "Este prazo asinado segue sendo vinculante aínda que se cambie ou elimine o calendario editable. O planificador pecha as canles autorizadas que aínda estean abertas.",
                reached: "Este prazo asinado xa venceu. Comprobe o estado actual da votación e o rexistro de auditoría; aínda non se rexistrou o seu procesamento.",
                processed: "Prazo de peche asinado procesado ás {{time}}.",
                signedAt: "Prazo asinado: {{time}}.",
                channels: "Canles que seguen cubertas por este prazo: {{channels}}.",
                result: "Consulte o estado da votación e o rexistro de auditoría para coñecer os cambios reais e o resultado completo.",
                unavailable: "Non se puideron cargar os prazos de peche asinados. Comprobe o calendario publicado e o rexistro de auditoría.",
            },
            picker: {
                noMatch: "Ningún fuso horario coincide. Escribe unha cidade, un país, unha zona, unha abreviatura ou un desprazamento.",
            },
            input: {
                timezone: "Fuso horario",
                scheduledAt: "Programado para",
                meetingStart: "Inicio da reunión",
                cronZone: "A programación execútase no fuso horario principal do evento, {{zone}}.",
                unconfiguredZone: "{{zone}} non é un dos fusos horarios configurados do evento. Escolle un deles.",
            },
            schedule: {
                allElections: "Todas as eleccións",
                outcome: "Resultado",
                noOffset: "Sen desprazamento horario: nunca se executa",
                unpublished: "Aínda sen publicar",
                notPublished: "Aínda non hai nada publicado: os votantes ven a programación tras a primeira publicación.",
                unpublishedChanges_one: "{{count}} evento programado cambiou desde a última publicación. Os votantes verano cando publiques.",
                unpublishedChanges_other: "{{count}} eventos programados cambiaron desde a última publicación. Os votantes veranos cando publiques.",
                offsetless_one: "{{count}} hora programada non ten desprazamento horario, así que nunca se executa. Edítaa para fixar o seu fuso horario.",
                offsetless_other: "{{count}} horas programadas non teñen desprazamento horario, así que nunca se executan. Edítaas para fixar o seu fuso horario.",
                outcomeChange: "Ao gardar cambia o que fai esta transición programada: {{before}} → {{after}}.",
                outcomeNew: "Unha vez gardada, esta transición programada: {{after}}.",
                outcomeElections: "{{count}} de {{total}} eleccións",
                exportError: "Non se puido exportar a programación.",
                exportFileName: "schedule.csv",
                totals: {
                    refused_one: "{{count}} fila programada será rexeitada ({{transitions}} transicións de eleccións).",
                    refused_other: "{{count}} filas programadas serán rexeitadas ({{transitions}} transicións de eleccións).",
                    runsUnsigned_one: "{{count}} peche programado executarase sen sinaturas ({{transitions}} transicións de eleccións).",
                    runsUnsigned_other: "{{count}} peches programados executaranse sen sinaturas ({{transitions}} transicións de eleccións).",
                    review: "Revisar",
                    showAll: "Amosar todo",
                    showing: {
                        refused: "Móstranse as {{count}} filas programadas que serán rexeitadas ({{transitions}} transicións de eleccións).",
                        runsUnsigned: "Móstranse os {{count}} peches programados que se executarán sen sinaturas ({{transitions}} transicións de eleccións).",
                    },
                },
                recompute: {
                    title_one: "Unha actualización da base de datos de fusos horarios move {{count}} hora programada futura. Non cambia nada ata que a apliques.",
                    title_other: "Unha actualización da base de datos de fusos horarios move {{count}} horas programadas futuras. Non cambia nada ata que as apliques.",
                    change: "{{type}}: {{before}} → {{after}}",
                    apply: "Aplicar",
                    applied_one: "{{count}} hora programada actualizada.",
                    applied_other: "{{count}} horas programadas actualizadas.",
                    error: "Non se puideron actualizar as horas programadas.",
                },
                outcomeChangeElections_one: "Gardar cambia o resultado en {{count}} elección:",
                outcomeChangeElections_other: "Gardar cambia o resultado en {{count}} eleccións:",
            },
            authorizes: {
                reportPolicyOf: "{{election}}: {{value}}",
                initializationRetained: "Un informe obrigatorio nesta configuración asinada segue sendo obrigatorio se a configuración actual do Posto cambia a non obrigatorio.",
                title: "Que autoriza esta aprobación",
                schedule: "Aperturas e peches programados",
                noSchedule: "Non hai aperturas nin peches programados: os asinantes abren e pechan a votación.",
                opens: "Ábrese {{time}}",
                closes: "Péchase {{time}}",
                settings: "Axustes",
                unsignedClose: "Peche programado sen sinaturas: {{value}}",
                initialization: "Inicialización: {{value}}",
                firstConfiguration: "É a primeira configuración aprobada: non hai nada con que comparar.",
                sameAsPrevious: "Os axustes son os mesmos que na configuración aprobada anterior.",
                rule: {
                    openNeeds_one: "Abrir require {{count}} sinatura",
                    openNeeds_other: "Abrir require {{count}} sinaturas",
                    openNoSignatures: "Abrir non require sinaturas",
                    closeNeeds_one: "Pechar require {{count}} sinatura",
                    closeNeeds_other: "Pechar require {{count}} sinaturas",
                    closeNoSignatures: "Pechar non require sinaturas",
                    openSetting: "Apertura da votación",
                    closeSetting: "Peche da votación",
                    signatures_one: "{{count}} sinatura",
                    signatures_other: "{{count}} sinaturas",
                    none: "sen sinaturas",
                },
                diff: {
                    tightens: "Endurece: {{setting}} {{before}} → {{after}}",
                    loosens: "Relaxa: {{setting}} {{before}} → {{after}}",
                    mixed: "Cambia: {{setting}} {{before}} → {{after}} (máis estrito nun aspecto e menos noutro)",
                },
                comparedWith: "Comparado coa configuración aprobada anterior, aprobación {{code}}:",
                channels: "Canles de votación por elección",
                channelsOf: "{{election}}: {{channels}}",
                noChannels: "ningunha",
            },
            publish: {
                openedAuthorized: "A votación abriuse segundo a programación ({{time}}), autorizada pola aprobación de configuración {{code}} (asinada por {{names}}).",
                closedAuthorized: "A votación pechouse segundo a programación ({{time}}), autorizada pola aprobación de configuración {{code}} (asinada por {{names}}).",
                closedUnsigned: "A votación pechouse segundo a programación ({{time}}). Sen sinaturas de peche: a programación pechou a votación na súa hora límite.",
                authorizedBy: "Autorizado por",
                cancelledRequest: "A solicitude {{code}} tiña {{n}} de {{k}} sinaturas e cancelouse.",
                openedRefused: "A apertura programada de {{time}} foi rexeitada.",
                closedRefused: "O peche programado de {{time}} foi rexeitado.",
                openedNoSignaturesNeeded: "A votación abriuse segundo a programación ({{time}}); non facían falta sinaturas.",
                closedNoSignaturesNeeded: "A votación pechouse segundo a programación ({{time}}); non facían falta sinaturas.",
                openedNothingToChange: "Ás {{time}} a apertura programada non tiña nada que abrir: as súas canles xa estaban abertas.",
                closedNothingToChange: "Ás {{time}} o peche programado non tiña nada que pechar: as súas canles xa estaban pechadas.",
            },
            import: {
                title: "Importar programación",
                subtitle: "Unha fila por evento e elección, en hora local. Deixa o fuso horario baleiro para usar o fuso horario da elección.",
                chooseFile: "Escolle un ficheiro CSV",
                template: "Descargar modelo",
                templateFileName: "schedule-template.csv",
                ready: "{{ok}} eventos listos para {{posts}} eleccións.",
                needsAttention_one: "{{ok}} eventos listos para {{posts}} eleccións. {{count}} fila require atención; corrixe o ficheiro e vólveo subir.",
                needsAttention_other: "{{ok}} eventos listos para {{posts}} eleccións. {{count}} filas requiren atención; corrixe o ficheiro e vólveo subir.",
                preview: "Filas que se importarán",
                row: "Fila",
                asWritten: "{{local}} · {{place}}",
                moreRows: "…e {{count}} filas máis",
                imported: "Programación importada: {{created}} creados, {{updated}} actualizados.",
                uploadError: "Non se puido comprobar o ficheiro. Vólveo subir.",
                importError: "Non se puido importar a programación.",
                error: {
                    unknownElection: "Ningunha elección ten o alias {{election}}.",
                    unknownEventType: "{{type}} non é un tipo de evento programado.",
                    invalidTimeZone: "{{zone}} non é un fuso horario.",
                    invalidDateTime: "A data e a hora deben ter o formato YYYY-MM-DDTHH:MM.",
                    invalidVotingChannels: "As canles de votación son descoñecidas ou abren á vez a votación en liña e a anticipada.",
                    dstGap: "{{dateTime}} non existe en {{city}} porque se adiantan os reloxos. Escribe unha hora que exista.",
                    duplicate: "Outra fila programa o mesmo evento para esta elección.",
                    other: "Esta fila non se pode importar ({{code}}).",
                    ambiguousElection: "Máis dunha elección ten o alias {{election}}.",
                },
            },
            settings: {
                accordion: "Idioma, data e hora",
                dateAndTime: "Data e hora",
                configured: "Fusos horarios configurados",
                configuredHelp: "{{count}} fusos horarios. As eleccións escollen o seu desta lista; escribe unha cidade ou un país para engadir un.",
                moreZones: "+{{count}}",
                primary: "Fuso horario principal",
                primaryHelp: "Úsase para as programacións de todo o evento, os informes e as eleccións sen fuso horario propio.",
                primaryInUse: "{{zone}} é o fuso horario principal. Escolle antes outro fuso horario principal.",
                inUse: "{{zone}} úsano {{names}}. Cambia antes esas eleccións.",
                logs: "Horas nos rexistros e nas súas exportacións",
                logsPrimary: "Fuso horario principal ({{abbr}})",
                logsElection: "O fuso horario da elección de cada fila",
                logsHelp: "As filas sen elección usan o fuso horario principal.",
                electionZone: "Fuso horario",
                electionPrimary: "Principal do evento: {{zone}}",
                electionZoneHelp: "As programacións, as pantallas dos votantes e os informes desta elección usan este fuso horario, tamén en todas as súas áreas. Baleiro usa o fuso horario principal do evento.",
                electionUnconfigured: "O evento xa non configura este fuso horario, así que a elección usa o fuso horario principal, {{zone}}. Escolle un dos fusos horarios configurados.",
                electionUnconfiguredSave: "Escolle un dos fusos horarios configurados do evento.",
            },
            policies: {
                accordion: "Ciclo da votación",
                intro: "Estes axustes forman parte da configuración do evento electoral: a aprobación da configuración asínaos, e as aperturas e peches programados seguen os máis estritos entre os axustes actuais e os publicados.",
                nothingPublished: "Aínda non hai nada publicado: ata a primeira publicación, as aperturas e peches programados usan os valores predeterminados (por elección, rexeitar).",
                publishedValue: "Configuración publicada: {{value}}",
                changedSincePublished: "Cambiou desde a configuración publicada: as aperturas e peches programados seguen a máis estrita das dúas ata a próxima publicación aprobada.",
                scope: {
                    title: "Inicialización antes de abrir a votación",
                    post: {
                        label: "Por elección",
                        help: "Unha elección ábrese cando está inicializada.",
                    },
                    event: {
                        label: "Todo o evento",
                        help: "Ningunha elección se abre ata que todas estean inicializadas.",
                        warning: "Unha elección sen inicializar mantén pechadas todas as eleccións, tamén nas súas aperturas programadas.",
                    },
                    postAndCountry: {
                        label: "Por elección e país",
                        help: "Unha elección ábrese cando todos os seus países (áreas) están inicializados.",
                        warning: "Unha elección segue pechada, tamén na súa apertura programada, ata que todos os seus países están inicializados; cada país inicialízase co seu propio informe.",
                    },
                },
                close: {
                    title: "Peche programado sen sinaturas",
                    help: "Cando pechar a votación require sinaturas e un peche programado non está na configuración asinada.",
                    refuse: {
                        label: "Rexeitar",
                        help: "O peche non se executa; os asinantes da elección pechan a votación coas súas sinaturas.",
                    },
                    runAsSystem: {
                        label: "Executar como sistema",
                        help: "A votación péchase na hora límite e queda rexistrada como pechada pola programación sen sinaturas.",
                        warning: "Os peches programados fóra da configuración asinada pechan a votación sen a sinatura de ninguén. O rexistro e os documentos indícano.",
                    },
                },
                onSave: {
                    outcomes_zero: "Ningunha transición programada cambia de resultado.",
                    outcomes_one: "{{count}} transición programada cambia de resultado. Revísaa en Eventos Programados.",
                    outcomes_other: "{{count}} transicións programadas cambian de resultado. Revísaas en Eventos Programados.",
                },
                saveError: "Non se puideron gardar os axustes do ciclo da votación.",
                publishedPerTarget: "Configuración publicada, por destino: {{values}}",
                publishedCount_one: "{{value}} ({{count}} destino)",
                publishedCount_other: "{{value}} ({{count}} destinos)",
                savedWithoutPolicies: "O evento electoral gardouse, pero os axustes do ciclo da votación non: {{reason}}. Gárdaos de novo.",
            },
        },
        scheduledOutcome: {
            chip: {
                waitingForInitialization: "Agardando pola inicialización",
                runs: "Executarase",
                runsUnsigned: "Executarase sen sinaturas",
                refused: "Rexeitarase",
            },
            note: {
                waitingForInitialization: "Agardando pola inicialización",
                authorized: "Autorizado pola configuración {{code}}",
                noSignaturesNeeded: "Non necesita sinaturas",
                closesUnsigned: "Péchase sen sinaturas",
                refused: {
                    initialization: "A inicialización requirida está incompleta",
                    votingClose: "A votación non pode abrirse despois do prazo de peche",
                    needsSignatures: "Necesita as sinaturas dos asinantes",
                    covered: "Non está na configuración asinada",
                    unsignedClose: "Un peche sen sinaturas rexéitase",
                    stricterCopy: "Cambiou desde a configuración publicada, que segue a decidir",
                    defaults: "Aínda non hai nada publicado: aplícanse os valores predeterminados",
                },
                refusedWithStep: "{{reason}}. {{next}}",
            },
            why: {
                button: "Por que?",
                title: {
                    waitingForInitialization: "Por que agarda pola inicialización",
                    runs: "Por que se executará",
                    runsUnsigned: "Por que se executará sen sinaturas",
                    refused: "Por que se rexeitará",
                },
                checks: "Comprobacións",
                check: "Comprobación",
                current: "Axustes actuais",
                published: "Configuración publicada",
                verdict: "Resultado",
                allows: "Permite",
                blocks: "Bloquea",
                deciding: "Comprobación decisiva",
                nextStep: "Seguinte paso:",
                signedBy: "Asinado por {{names}}",
            },
            question: {
                initialization: "Completouse a inicialización requirida?",
                votingClose: "Esta apertura respecta o prazo de peche da votación?",
                needsSignatures: "Esta acción necesita sinaturas?",
                covered: "Está esta programación exacta na configuración asinada?",
                unsignedClose: "Que pasa cun peche sen sinaturas?",
                stricterCopy: "Difiren os axustes actuais e os publicados? Cales deciden?",
                defaults: "Hai xa algo publicado?",
            },
            check: {
                initialization: {
                    waiting: "Deben completarse as inicializacións esixidas pola configuración actual e a publicada.",
                },
                votingClose: {
                    passed: "A votación pecha ás {{closes_at}}; esta apertura non pode executarse nese momento nin despois.",
                },
                needsSignatures: {
                    yes: "Si, {{signatures}} sinaturas",
                    yes_one: "Si, {{count}} sinatura",
                    yes_other: "Si, {{count}} sinaturas",
                    no: "Non",
                },
                covered: {
                    overriddenBySignedPostRow: "A configuración asinada {{code}} utiliza a apertura propia deste posto, {{scheduled_event_id}}. A apertura para todo o evento non se aplica.",
                    yes: "Si: aprobación {{code}}, sen cambios",
                    changed: "Non: cambiou desde a aprobación {{code}}",
                    changedBy: "Non: editado o {{edited_at}} por {{edited_by}}, despois da aprobación {{code}}",
                    notInApproval: "Non: a aprobación {{code}} non o inclúe",
                    noApproval: "Aínda non hai ningunha configuración aprobada",
                    channelsChanged: "Non: as canles de votación da elección cambiaron desde a aprobación {{code}}",
                    alreadyFired: "Non: esta transición da aprobación {{code}} xa se executou o {{fired_at}}; executala de novo precisa sinaturas",
                    late: "Non: pasaron máis de 15 minutos desde {{scheduled_date}} (aprobación {{code}}); executala agora precisa sinaturas",
                },
                unsignedClose: {
                    refuse: "Rexeitar",
                    runAsSystem: "Executar como sistema",
                },
                stricterCopy: {
                    same: "Ambos son iguais",
                    currentStricter: "Os axustes actuais son máis estritos: aplícanse xa",
                    currentLooser: "Os axustes actuais son menos estritos: aplícanse tras a próxima publicación aprobada",
                    combined: "Cada un é máis estrito nun valor: aplícanse ambos",
                },
                defaults: {
                    published: "Publicado o {{published_at}}",
                    nothingPublished: "Nada publicado: aplícanse os valores predeterminados",
                    noSnapshot: "Publicado o {{published_at}}, antes de que as publicacións gardasen estes axustes: aplícanse os valores predeterminados",
                },
            },
            nextStep: {
                initialize: "Complete a inicialización requirida. O planificador volverá intentalo antes do peche da votación.",
                closed: "Esta apertura non se executará despois do peche da votación.",
                none: "Non fai falta facer nada.",
                publishAndApprove: "Publica e aproba a configuración.",
                requireConfigurationApproval: "Fai que Aprobar configuración requira sinaturas e, despois, publica e aproba a configuración.",
                askSignersToOpen: "Pídelles aos asinantes da elección que abran a votación.",
                askSignersToClose: "Pídelles aos asinantes da elección que pechen a votación.",
            },
            applies: {
                tightens: "Aplícase xa ás accións manuais e programadas.",
                loosens: "Aplícase xa ás accións manuais; ás aperturas e peches programados, tras a próxima publicación aprobada.",
                tightensAndLoosens: "A súa parte máis estrita aplícase xa ás accións manuais e programadas; a súa parte menos estrita aplícase xa ás accións manuais e, ás aperturas e peches programados, tras a próxima publicación aprobada.",
            },
        },
        messagingEvent: {
            tab: "Mensaxería",
            intro: "As canles que os votantes deste evento poden escoller para códigos e avisos, e a conta desde a que envía cada unha. As contas xestiónanse en Axustes > Mensaxería.",
            readOnly: "Pode ver estes axustes. Para cambialos precisa o permiso messaging-config-write.",
            savingNote: "Ao gardar tamén se actualizan as canles que as páxinas de inscrición ofrecen en cada Post.",
            save: "Gardar",
            saved: "Axustes de mensaxería gardados.",
            saveRejected: "Os axustes de mensaxería non se gardaron. Corrixa os problemas indicados.",
            saveError: "Non se puideron gardar os axustes de mensaxería.",
            accountLabel: "Conta de {{channel}}",
            notUsed: "Sen usar",
            missingAccount: "Conta non atopada",
            noAccount: "Engada antes unha conta en Axustes > Mensaxería",
            missing: "Falta: {{blockers}}",
            purposeSwitch: "{{channel}}: {{purpose}}",
            sections: {
                channels: "Canles",
                templates: "Modelos aprobados",
                posts: "Canles por Post",
                postsCount: "Canles por Post ({{count}} Posts)",
                delivery: "Estado da entrega",
            },
            column: {
                channel: "Canle",
                account: "Envía desde",
                purpose: "Finalidade",
                language: "Idioma",
                template: "Modelo do provedor",
                status: "Estado",
                post: "Post",
                key: "Tipo de mensaxe ou modelo",
                providerLanguage: "Idioma do provedor",
                voters: "Votantes que a usan",
                sent24h: "Enviados, últimas 24 h",
                sent24hHelp: "Cada mensaxe cuxo último intento foi nas últimas 24 horas, en calquera estado, incluídas as fallidas. As columnas de estado contan todas as mensaxes do evento.",
            },
            outOfWindow: {
                utility: "Fóra da xanela de 24 horas, {{channel}} envía os avisos co modelo de utilidade aprobado vinculado aos avisos en Modelos aprobados.",
            },
            messageTypes: {
                otp: "Código de verificación",
                otl: "Ligazón de acceso",
                enrollmentAccepted: "Inscrición aceptada",
                enrollmentAcceptedKiosk: "Inscrición aceptada (quiosco)",
                enrollmentPending: "Inscrición pendente de aprobación",
                enrollmentRejected: "Inscrición rexeitada",
                passwordReset: "Restablecemento do contrasinal",
                temporaryPassword: "Contrasinal temporal",
                contactChanged: "Método de contacto cambiado",
            },
            templates: {
                empty: "Escolla unha conta que envíe modelos aprobados, como WhatsApp, Viber ou Messenger, para vincular aquí os seus modelos.",
                help: "Seleccione un tipo de mensaxe do sistema ou un alias de Modelos. Déixeo baleiro para usar o modelo aprobado por defecto para este propósito. Idioma é o idioma do votante. Modelo do provedor é o nome ou ID do modelo no provedor. Idioma do provedor é o código do provedor para ese modelo cando difire do idioma do votante: WhatsApp precisa o código exacto do modelo aprobado, como en_US.",
                order: "Para cada mensaxe gaña a fila máis específica: a fila da mensaxe no idioma do votante, despois a fila da mensaxe en calquera idioma, despois o predeterminado do propósito no idioma do votante e, por último, calquera predeterminado do propósito.",
                noneRequired: "{{channel}} só envía modelos aprobados. Engada polo menos un modelo predeterminado para cada propósito en uso.",
                noneOptional: "Non hai modelos vinculados para {{channel}}. Só fan falta para enviar avisos fóra da xanela de conversa.",
                row: "Modelo {{position}} de {{channel}}",
                keyDefault: "Predeterminado para este propósito",
                add: "Engadir modelo de {{channel}}",
                remove: "Quitar o modelo {{position}} de {{channel}}",
                incomplete: "Indique o idioma e o modelo do provedor, ou quite esta fila.",
                approval: {
                    APPROVED: "Aprobado",
                    NOT_APPROVED: "Non aprobado",
                    NOT_CHECKED: "Aprobación non comprobada",
                },
            },
            posts: {
                noChannels: "Active códigos ou avisos nunha canle para escoller as canles de cada Post.",
                help: "A inscrición mostra aos votantes de cada Post as canles marcadas aquí.",
                restricted: "{{count}} Posts ofrecen menos das {{total}} canles.",
                allChannels: "Todos os Posts ofrecen as {{total}} canles; desmarque unha canle no Post onde non funcione.",
                search: "Buscar Posts",
                cell: "{{post}}: {{channel}}",
                showing: "Móstranse {{shown}} de {{total}} Posts. Busque para atopar outros.",
            },
            delivery: {
                notConfigured: "Este evento non o ofrece",
                empty: "Non se usa ningunha canle.",
                help: "As contas son por mensaxe, segundo o estado do seu último intento. Aceptado significa que o provedor aceptou a mensaxe, non que o votante a recibise. Descoñecido significa que a entrega aínda non está confirmada; pasadas 24 horas móstrase como Sen resolver, nunca como fallida. Unha conta sen informes de entrega mostra a entrega como non dispoñible.",
                loadError: "Non se puideron cargar as contas de mensaxes.",
                noReceipts: "Esta conta non recibe informes de entrega, así que non se pode mostrar a entrega.",
                showFailed: "Ver as mensaxes fallidas de {{channel}} en Rexistros",
                noChannelHelp: "Votantes sen ningunha canle de contacto rexistrada. Os seus avisos fallan e nunca se contan en ningunha canle.",
                showFailedNoChannel: "Ver en Rexistros as mensaxes fallidas dos votantes sen canle de contacto",
            },
            error: {
                UNSUPPORTED_VERSION: "Esta configuración usa a versión {{version}}, que non se admite.",
                DUPLICATE_CHANNEL: "{{channel}} está configurada máis dunha vez.",
                UNKNOWN_ACCOUNT: "A conta de {{channel}} xa non existe. Escolla outra conta.",
                ACCOUNT_OF_ANOTHER_TENANT: "A conta seleccionada pertence a outro inquilino.",
                ACCOUNT_CHANNEL_MISMATCH: "A conta seleccionada non envía mensaxes de {{channel}}.",
                PURPOSE_NOT_READY: "{{channel}} aínda non pode enviar {{purpose}}. Falta: {{blockers}}.",
                TEMPLATE_NOT_APPROVED: "O modelo de {{channel}} para {{purpose}} en {{language}} non está aprobado polo provedor.",
                OUT_OF_WINDOW_NOT_SUPPORTED: "{{channel}} non pode enviar fóra dunha xanela de conversa con esta conta: non ten xanela de conversa ou os seus avisos xa precisan un modelo.",
                ELECTION_CHANNEL_NOT_ENABLED: "{{election}} ofrece {{channel}}, que este evento non usa.",
                UNKNOWN_ELECTION: "{{election}} non é unha elección deste evento.",
                UTILITY_TEMPLATE_MISSING: "Os avisos de {{channel}} fóra da xanela de 24 horas precisan o modelo de utilidade aprobado. Vincúleo aos avisos en Modelos aprobados.",
            },
            noReadPermission: "Para ver estes axustes precísase o permiso messaging-config-read.",
            chooseAccount: "Escolla antes unha conta.",
            needsSavingAgain: "Hai que volver gardar a configuración.",
            needsSavingAgainHelp: "Copiouse do almacenamento anterior e non superou as comprobacións que fai un gardado. Corrixa os problemas que se mostran e volva gardala.",
        },
        messaging: {
            channel: {
                EMAIL: "Correo electrónico",
                SMS: "SMS",
                WHATSAPP: "WhatsApp",
                VIBER: "Viber",
                MESSENGER: "Facebook Messenger",
            },
            provider: {
                AWS_SES: "Amazon SES",
                SMTP: "Servidor SMTP",
                AWS_SNS: "Amazon SNS",
                WHATSAPP_CLOUD_API: "WhatsApp Cloud API (Meta)",
                MESSENGER_SEND_API: "Messenger Platform (Meta)",
                VIBER_INFOBIP: "Viber Business Messages (Infobip)",
                CONSOLE: "Consola (xa non é compatible)",
                HTTP_API: "API HTTP personalizada (xa non é compatible)",
            },
            purpose: {
                OTP: "Códigos",
                NOTICE: "Avisos",
            },
            state: {
                QUEUED: "En cola",
                ACCEPTED: "Aceptado",
                DELIVERED: "Entregado",
                FAILED: "Fallido",
                UNKNOWN: "Descoñecido",
                UNRESOLVED: "Sen resolver",
            },
            stateHelp: {
                QUEUED: "Pendente de entregar ao provedor.",
                ACCEPTED: "O provedor aceptou a mensaxe. Isto non significa que o votante a recibise.",
                DELIVERED: "O provedor informou de que a mensaxe se entregou.",
                FAILED: "O provedor confirmou que a mensaxe non se entregou.",
                UNKNOWN: "A entrega aínda non está confirmada.",
                UNRESOLVED: "Non se puido confirmar a entrega en 24 horas. Isto non significa que fallase.",
            },
            blocker: {
                UNCHECKED: "Sen comprobar para o seu número, páxina ou remitente actuais",
                NOT_CONNECTED: "Sen conexión",
                UNSUPPORTED_PURPOSE: "Este provedor non o admite",
                NEEDS_PROVIDER_APPROVAL: "Precisa a aprobación do provedor",
                NEEDS_PRODUCTION_ACCESS: "Precisa acceso de produción",
                NEEDS_APPROVED_TEMPLATE: "Precisa un modelo aprobado",
                UNSUPPORTED_PROVIDER: "Provedor non compatible: substitúa esta conta",
                CALLBACK_NOT_CONFIGURED: "Enderezo de retorno non configurado",
                REPORT_CREDENTIALS_MISSING: "Credenciais de informes non xeradas",
            },
            readiness: {
                connected: "Conectada",
                notConnected: "Sen conexión",
                readyOtp: "Lista para códigos",
                readyNotice: "Lista para avisos",
                notReady: "Non está lista",
                lastCheck: "Comprobada {{date}}",
                neverChecked: "Aínda non comprobada",
            },
            approval: {
                PENDING: "Pendente de aprobación do provedor",
                CONFIRMED: "Aprobación do provedor confirmada",
            },
            credential: {
                ACCESS_TOKEN: "Token de acceso",
                APP_SECRET: "Segredo da aplicación",
                VERIFY_TOKEN: "Token de verificación",
                API_KEY: "Clave de API",
                SMTP_PASSWORD: "Contrasinal",
                AWS_ACCESS_KEY_ID: "ID de clave de acceso de AWS",
                AWS_SECRET_ACCESS_KEY: "Clave de acceso secreta de AWS",
                REPORT_USERNAME: "Usuario de informes",
                REPORT_PASSWORD: "Contrasinal de informes",
            },
            deliveryUnavailable: "Entrega non dispoñible",
            templates: {
                noMethod: "Escolle polo menos un método para o modelo.",
                parameters: "Parámetros do modelo",
                parametersHelp: "O que enche cada marcador do modelo aprobado, en orde, como user.first_name ou vote_url. Para un modelo con parámetros con nome escriba @nome=valor, como @first_name=user.first_name; calquera outra entrada é posicional.",
                parameter: "Parámetro {{position}}",
                removeParameter: "Quitar o parámetro {{position}}",
                addParameter: "Engadir parámetro",
                noAccount: "Aínda non hai ningunha conta de {{channel}}. Engade unha en Axustes > Mensaxería para ver que idiomas están aprobados.",
                account: "Conta",
                approvalTitle: "Modelos aprobados",
                language: "Idioma",
                approvalFor: "Aprobado para {{purpose}}",
                approved: "Aprobado",
                notApproved: "Non aprobado",
                approvalHelp: "As aprobacións veñen do provedor e actualízanse coa comprobación de conexión da conta.",
                messengerIntro: "Nas 24 horas seguintes á última mensaxe do votante, Messenger envía o texto seguinte.",
                messengerMessage: "Mensaxe dentro das 24 horas",
                messengerWindow: "Un destinatario de Messenger gardado non é permiso para enviar. Fóra da xanela de 24 horas este aviso envíase co modelo de utilidade aprobado indicado abaixo ou vinculado no evento electoral; sen el non se envía, e o fallo móstrase co seu motivo. As mensaxes de utilidade precisan o permiso page_utility_messaging e un modelo UTILITY aprobado na páxina.",
                intro: {
                    WHATSAPP: "WhatsApp só envía modelos que Meta aprobou para a conta de WhatsApp Business. A mensaxe debe coincidir co modelo aprobado; escolle o que enche os seus parámetros.",
                    VIBER: "Viber só envía códigos e mensaxes transaccionais con modelos aprobados polo socio de Viber. A mensaxe debe coincidir co modelo aprobado; escolle o que enche os seus parámetros.",
                },
                approvedWording: "Texto aprobado",
                approvedWordingHelp: "Unha copia do modelo aprobado, usada como vista previa. Cambiala aquí non cambia o que envía o provedor.",
                providerTemplateTitle: "Modelo do provedor",
                providerTemplateHelp: "Opcional. O nome ou ID do modelo aprobado no provedor. Se está baleiro, úsase o modelo do evento electoral vinculado ao alias deste modelo, ou o predeterminado do evento para o propósito.",
                providerTemplate: "Nome ou ID do modelo do provedor",
                providerLanguage: "Código de idioma do provedor",
                providerLanguageHelp: {
                    WHATSAPP: "Usa o código de idioma exacto do modelo de WhatsApp aprobado, como en ou en_US. Só se necesita un código rexional se o modelo se aprobou con el.",
                    VIBER: "O código de idioma co que o provedor de Viber coñece o modelo, cando o precisa.",
                    MESSENGER: "O código de idioma do modelo de utilidade aprobado, como en_US.",
                },
                noReadPermission: "Para ver as contas precísase o permiso messaging-config-read.",
            },
            send: {
                eachVoter: "A canle de cada votante",
                eachVoterHelp: "Cada votante recibe unha mensaxe pola súa propia canle. Se a entrega falla, volve intentarse nesa canle e o fallo móstrase na lapela Mensaxería do evento. A entrega sen confirmar móstrase como Descoñecido.",
                channelColumn: "Canle",
                sendsFrom: "Envíase desde",
                noAccount: "Sen conta",
                missingContent: "Esta notificación non ten contido para {{channels}}.",
                approvedTemplateHelp: "Os modelos de {{channel}} están aprobados polo provedor, polo que o texto, o modelo do provedor e o idioma non se poden cambiar aquí. Escolle outro modelo gardado para usar outro contido aprobado.",
                voters: "Votantes",
                environment: "O remitente predeterminado da instalación",
                noNoticeChannels: "A configuración de mensaxería deste evento non activa os avisos en ningunha canle, así que ningún votante recibiría esta notificación. Active os avisos dunha canle na lapela Mensaxería do evento.",
                noReadPermission: "Para mostrar a canle de cada votante precísase o permiso messaging-config-read. Cada votante recibe igualmente a notificación pola súa propia canle.",
            },
            audience: {
                notOfferedRow: "Ningún Post destes votantes ofrece esta canle para avisos, así que ningún deles o recibe: {{reason}}.",
                willSend: "Recibirán a notificación: {{willSend}}",
                selectedTimedOut: "Contar os votantes seleccionados levou demasiado tempo, así que non se amosan recontos. Cada votante recibe igualmente a notificación pola súa propia canle.",
                notSent: "Non se envía",
                deletedAccount: "Conta eliminada",
                notOffered: "{{notOffered}} deles non o reciben: {{reason}}.",
                noAccountHelp: "Ningunha conta envía por esta canle, así que os avisos destes votantes fallan: {{reason}}.",
                noChannelHelp: "Estes votantes non teñen canle de contacto rexistrada. Non reciben nada, e cada un aparece como fallido: {{reason}}.",
                total: "Votantes desta audiencia: {{total}}",
                loadError: "Non se puido cargar o número de votantes. Cada votante recibe igualmente a notificación pola súa propia canle.",
            },
            voterCount: {
                countedAt: "Contado: {{time}}.",
                never: "Aínda non se contou.",
                pending: "Hai un reconto en curso.",
                timedOut: "O último reconto levou demasiado tempo e detívose.",
                failed: "O último reconto fallou.",
                previous: "Os recontos que se amosan son do anterior.",
                recount: "Volver contar",
                recountAsked: "Pediuse un reconto. Os recontos actualízanse cando remate.",
                recountAlreadyAsked: "Xa hai un reconto en curso.",
                recountError: "Non se puido pedir o reconto.",
                loadError: "Non se puideron cargar os recontos de votantes.",
            },
            volumes: {
                title: "Volumes mensuais",
                intro: "Intentos entregados a un provedor cada mes, por canle, conta de envío, país de destino e categoría de facturación, para conciliar as facturas dos provedores. Cada intento conta no mes en que se fixo, así que un reintento volve contar. A categoría de facturación é a prevista ao enviar, ou a que informou o provedor; se un intento é facturable é o que informou o provedor. Non se amosan prezos.",
                month: "Mes",
                monthHelp: "Os meses cóntanse en UTC.",
                loading: "Cargando os volumes mensuais",
                loadError: "Non se puideron cargar os volumes.",
                empty: "Non se entregou ningún intento a un provedor en {{month}}.",
                noPermission: "Para ver os volumes cómpre o permiso messaging-account-read ou messaging-config-read.",
                notReported: "Sen informar",
                deploymentOrDeleted: "Remitente da instalación ou unha conta eliminada",
                category: {
                    AUTHENTICATION: "Autenticación",
                    UTILITY: "Utilidade",
                    SERVICE: "Servizo",
                    TRANSACTIONAL: "Transaccional",
                    EMAIL: "Correo electrónico",
                },
                billableYes: "Facturable",
                billableNo: "Non facturable",
                total: "Todos os intentos",
                column: {
                    account: "Enviada desde",
                    country: "País de destino",
                    category: "Categoría de facturación",
                    billable: "Facturable",
                    messages: "Intentos",
                },
            },
            voter: {
                listChannel: "Canle de mensaxería",
                title: "Mensaxería",
                notSet: "Sen definir",
                channel: "Canle",
                destination: "Envíase a",
                messengerPage: "Páxina de Messenger",
                consent: "Consentimento",
                lastFailure: "Último fallo",
                noFailure: "Ningún",
                failureNeedsPermission: "Móstrase co permiso messaging-config-read.",
                noChannel: "Sen contacto rexistrado",
                notConfirmed: "Entrega non confirmada",
                notConfirmedHelp: "A última mensaxe cuxa entrega aínda non está confirmada. Pasadas 24 horas móstrase como Sen resolver, o que non significa que fallase.",
            },
            logs: {
                channel: "Canle",
                status: "Estado",
                statusAsLogged: "O estado cando se escribiu a entrada; o estado actual precisa o permiso messaging-config-read.",
            },
            stats: {
                sent: {
                    WHATSAPP: "Mensaxes de WhatsApp enviadas",
                    VIBER: "Mensaxes de Viber enviadas",
                    MESSENGER: "Mensaxes de Messenger enviadas",
                },
            },
            reason: {
                CANDIDATE_REFUSED: "As novas credenciais non conectaron: mantéñense as anteriores",
                ACCOUNT_IN_USE: "Úsana os axustes de mensaxería dun evento electoral: quítea de alí primeiro",
                NUMBER_CHANGED: "Un votante cambiou o seu número de WhatsApp: pídalle que verifique de novo o seu contacto",
                IDENTITY_CHANGED: "A identidade de envío da conta cambiou: compróbase de novo",
                TEMPLATES_NOT_READ: "Non se puideron ler os modelos do provedor",
                PARTNER_LOGIN_REFUSED: "Infobip rexeitou a clave de API da conta",
                NO_PAGES_MESSAGING: "O token da páxina non ten o permiso pages_messaging",
                NOT_SUBSCRIBED: "A aplicación non está subscrita á páxina",
                NUMBER_STATUS_NOT_READ: "Non se puido ler o estado do número",
                CALLBACK_NOT_CONFIGURED: "Enderezo de retorno non configurado",
                UNSUPPORTED_PROVIDER: "Provedor non compatible: substitúa esta conta",
                CREDENTIALS_FOLLOW_ENDPOINT: "Volva introducir as credenciais para o novo enderezo",
                NO_CONTACT_CHANNEL: "Sen canle de contacto",
                NOT_RETRYABLE_NO_TEMPLATE: "Non se pode reintentar: non hai modelo gardado",
                CHANNEL_NOT_OFFERED_FOR_NOTICES: "Canle non ofrecida para avisos",
                CHANNEL_NOT_OFFERED_FOR_CODES: "Canle non ofrecida para códigos",
                NO_CONTENT_FOR_CHANNEL: "Sen contido para a canle",
                NO_ACCOUNT_FOR_CHANNEL: "Sen conta de envío para a canle",
                INVALID_DESTINATION: "Destino non válido para a canle",
                NOT_RETRYABLE_PROTECTED_FIELDS: "Non se pode reintentar: contén campos protexidos",
                REPORTED_TOO_LATE: "Notificado demasiado tarde para reintentar",
                CHANNEL_CHANGED: "A canle do votante cambiou: non se reintenta",
                WORKER_STOPPED_BEFORE_SENDING: "O proceso detívose antes de enviar",
                WORKER_STOPPED_AFTER_SENDING: "O proceso detívose antes de rexistrar o resultado",
                CODE_EXPIRED_BEFORE_SENDING: "O código caducou antes de poder enviarse",
                CAPACITY_BUSY: "Non enviado: a conta estivo no seu límite de envío durante demasiado tempo",
                PROVIDER_ANSWER_LATE: "O provedor non respondeu a tempo: é posible que a mensaxe se enviase",
                UNRESOLVED: "Non se puido confirmar a entrega",
                SELECTED_WITHOUT_VOTERS: "Seleccione polo menos un votante",
                WRONG_RECIPIENT_KIND: "O destino non é do tipo ao que envía esta canle",
                UNSUPPORTED_PURPOSE: "O provedor non envía este tipo de mensaxe",
                MISSING_APPROVED_TEMPLATE: "Non hai modelo aprobado para esta mensaxe",
                OUTSIDE_CONVERSATION_WINDOW: "Fóra da xanela de conversa",
                DESTINATION_NOT_ALLOWED: "Esta conta non envía ao país do destino",
                CODE_EXPIRED: "O código caducou",
                MISSING_CODE: "Non hai código que enviar",
                ENDPOINT_NOT_HTTPS: "O enderezo do provedor debe comezar por https://",
                PROVIDER_CODE: "Código de erro do provedor {{code}}",
                CHECK_DROPPED: "A conta cambiou mentres se comprobaba: compróbea de novo",
                ACCOUNT_NOT_READY: "Non enviado: a conta non está lista ({{blocker}})",
                PROVIDER_UNREACHABLE: "Non se puido contactar co provedor",
                PROVIDER_STATUS: "O provedor respondeu co estado {{status}}",
                MISSING_CREDENTIAL: "Falta a credencial: {{credential}}",
                PROVIDER_CHECK_FAILED: "A comprobación do provedor fallou: {{detail}}",
                NUMBER_STATUS: "O estado do número é {{status}}",
                NUMBER_NAME_STATUS: "O nome visible do número é {{status}}",
                NUMBER_IN_SANDBOX: "O número está en modo sandbox",
                NUMBER_NOT_VERIFIED: "O código do número non está verificado",
                SMS_SANDBOX: "A conta está no sandbox de SMS",
                SES_SANDBOX: "A conta está no sandbox de SES",
                SES_SENDING_DISABLED: "O envío está desactivado para esta conta",
                SMTP_REFUSED: "O servidor SMTP non é accesible ou rexeitou as credenciais",
                TOKEN_INVALID: "O token de acceso non é válido ou caducou",
                TOKEN_CANNOT_SEND: "O token de acceso non ten o permiso para enviar",
                TOKEN_NOT_CHECKED: "Non se puido comprobar o token de acceso",
                APP_SECRET_REFUSED: "Meta rexeitou o segredo da aplicación",
                APP_SECRET_NOT_CHECKED: "Non se puido comprobar o segredo da aplicación",
                RETRY_NOT_PREPARED: "Non se pode reintentar: non se puido volver preparar a mensaxe",
                NOT_THE_VOTERS_CHANNEL: "Non é a canle do votante",
                REPORT_CREDENTIALS_MISSING: "Xere as credenciais de informes e cree a subscrición de Infobip",
                CALLBACK_NOT_HTTPS: "O enderezo de retorno debe ser https",
                UNKNOWN_ACCOUNT: "Esta conta xa non existe: pode que se eliminase noutra lapela. Volva cargar a lista.",
                INTERNAL_ERROR: "O servidor non puido completar a solicitude. Ténteo de novo máis tarde.",
                VERIFY_TOKEN_GENERATED: "O token de verificación xérao o sistema; non se introduce",
                CREDENTIAL_GENERATED: "{{credential}}: xérao o sistema; non se introduce",
                CREDENTIAL_NOT_USED: "As contas de {{provider}} non usan {{credential}}",
                CREDENTIAL_EMPTY: "{{credential}} non pode estar baleiro",
                NO_REPORT_CREDENTIALS: "As contas de {{provider}} non teñen credenciais de informes",
                UNKNOWN_AUDIENCE: "Selección de destinatarios descoñecida",
                INVALID_MONTH: "O mes debe escribirse como AAAA-MM",
                INVALID_SUPPORT_REFERENCE: "Non é unha referencia de soporte",
                MESSENGER_PAGE_CHANGED: "Non enviado: o votante está conectado a outra páxina de Messenger",
            },
        },
        messagingAccounts: {
            status: {
                title: "Estado no provedor",
                daily: "As contas compróbanse unha vez ao día e cada vez que comprobe a conexión.",
                unchecked: "O número, a páxina ou o remitente cambiaron desde a última comprobación. Ata que a conta se comprobe de novo, os códigos e avisos que pasen por ela fallan por non estar lista; a mensaxe de proba si se envía.",
                notReported: "Non informado",
                yes: "Si",
                no: "Non",
                token: "Token de acceso",
                tokenExpires: "Válido · caduca o {{date}}",
                tokenNoExpiry: "Válido · non caduca",
                tokenInvalid: "Non válido",
                missingScopes: "Faltan permisos: {{scopes}}",
                numberStatus: "Estado do número",
                nameStatus: "Nome visible: {{status}}",
                qualityRating: "Cualificación de calidade",
                quality: {
                    GREEN: "Alta",
                    YELLOW: "Media",
                    RED: "Baixa",
                    UNKNOWN: "Descoñecida",
                },
                messagingLimit: "Límite de mensaxes",
                pagesMessaging: "Permiso para enviar (pages_messaging)",
                subscribed: "Aplicación subscrita á páxina",
                getStarted: "Botón Comezar",
                getStartedMissing: "Sen o botón, os votantes que nunca escribiron á páxina non poden iniciar a conversa que lles trae o seu código.",
                partnerLogin: "Acceso do socio",
                appSecret: "Segredo da aplicación",
                notChecked: "Non se puido comprobar",
                numberQualityWarning: "Un aviso de calidade de Meta: o número segue enviando, pero unha calidade baixa pode reducir o seu límite de mensaxes.",
                accepted: "Aceptado",
                refused: "Rexeitado",
                callback: "Enderezo de retorno",
                callbackReady: "Configurado",
                approvalFromCheck: "Informada pola comprobación do provedor",
                approvalEntered: "Introducida por un administrador: a comprobación do provedor non a informou",
                approvalEnteredHelp: "Só se usa ata que a comprobación do provedor informe da aprobación.",
                templates: {
                    title: "Modelos no provedor",
                    none: "Sen modelos",
                    name: "Modelo",
                    language: "Idioma",
                    category: "Categoría",
                    status: "Estado",
                    entered: "Os modelos de Viber introdúceos un administrador en Modelos aprobados: o socio non ten API para a aprobación de modelos.",
                },
                templateCategory: {
                    AUTHENTICATION: "Autenticación",
                    UTILITY: "Utilidade",
                    MARKETING: "Mercadotecnia",
                },
                templateStatus: {
                    APPROVED: "Aprobado",
                    PENDING: "En revisión",
                    REJECTED: "Rexeitado",
                    PAUSED: "En pausa",
                    DISABLED: "Desactivado",
                },
                numberChanges: {
                    title: "Votantes que cambiaron o seu número de WhatsApp",
                    description: "WhatsApp informou destes cambios de número. Pida a estes votantes que verifiquen de novo o seu contacto; non se cambiou nada automaticamente.",
                    item: "{{old}} cambiou a {{new}} o {{date}}.",
                    voters: "Votantes: {{voters}}",
                    noVoters: "Ningún votante recibiu mensaxes desta conta no número anterior.",
                },
            },
            tab: "MENSAXERÍA",
            description: "Contas que envían aos votantes os seus códigos e avisos. Cada evento electoral escolle a conta de cada canle; os eventos novos comezan coa conta predeterminada.",
            list: {
                title: "Contas de envío",
                add: "Engadir conta",
                loading: "Cargando contas",
                loadError: "Non se puideron cargar as contas de envío.",
                empty: "Aínda non hai contas de envío.",
            },
            column: {
                channel: "Canle",
                name: "Conta",
                sender: "Envía como",
                provider: "Provedor",
                default: "Predeterminada",
                isDefault: "Conta predeterminada",
                lastCheck: "Última comprobación",
                actions: "Accións",
            },
            action: {
                edit: "Editar",
                editNamed: "Editar {{name}}",
                view: "Ver",
                viewNamed: "Ver {{name}}",
                check: "Comprobar conexión",
                checkNamed: "Comprobar a conexión de {{name}}",
                test: "Enviar mensaxe de proba",
                testNamed: "Enviar unha mensaxe de proba desde {{name}}",
                delete: "Eliminar",
                deleteNamed: "Eliminar {{name}}",
            },
            check: {
                done: "Comprobouse {{name}}. O seu estado está actualizado.",
                error: "Non se puido comprobar {{name}}.",
            },
            delete: {
                refused: "A conta non se eliminou: {{reason}}",
                title: "Eliminar conta",
                body: "Eliminar {{name}}? Os eventos electorais que a usan deixarán de enviar pola súa canle.",
                success: "Conta eliminada",
                error: "Non se puido eliminar a conta.",
            },
            editor: {
                addTitle: "Engadir conta",
                editTitle: "Editar conta de {{channel}}",
                subtitle: "Os votantes reciben códigos e avisos desta conta nas canles que a usan.",
                channel: "Canle",
                provider: "Provedor",
                save: "Gardar",
                cancel: "Cancelar",
                close: "Pechar",
                channelHelp: "Non se pode cambiar despois de crear a conta.",
            },
            field: {
                name: "Nome da conta",
                from_address: "Enderezo do remitente",
                from_name: "Nome do remitente",
                region: "Rexión de AWS",
                notification_topic_arn: "Tema de notificacións de entrega (ARN de SNS)",
                server_url: "Servidor e porto",
                sender_id: "ID do remitente",
                origination_number: "Número de orixe",
                business_account_id: "ID da conta de WhatsApp Business",
                phone_number_id: "ID do número de teléfono",
                display_phone_number: "Número",
                display_name: "Nome visible",
                api_version: "Versión de Graph API",
                page_id: "ID da páxina de Facebook",
                page_name: "Nome da páxina",
                page_username: "Nome de usuario da páxina",
                base_url: "URL base da API",
                sender: "Nome do remitente",
                provider_approval: "Aprobación do provedor",
                is_default: "Conta de {{channel}} predeterminada para novos eventos electorais",
                api_base_url: "URL base da Graph API",
            },
            fieldHelp: {
                from_address: "O enderezo que ven os votantes. O seu dominio debe estar verificado co provedor.",
                notification_topic_arn: "O tema de SNS no que SES publica os eventos de entrega e rebote. Rexéitanse as notificacións de calquera outro tema.",
                sender_id: "Ata 11 letras e díxitos. Algúns países esixen rexistralo.",
                origination_number: "Úsase en lugar do ID do remitente onde un país esixe un número.",
                phone_number_id: "O número desde o que se envían as mensaxes.",
                display_name: "O nome visible que Meta aprobou para o número.",
                page_username: "Úsase na ligazón m.me que os votantes abren para obter o seu código.",
                api_version: "Por exemplo, v23.0.",
                base_url: "A URL base da API de Infobip da conta.",
                sender: "O remitente aprobado que ven os votantes.",
                provider_approval: "Meta só permite mensaxes de WhatsApp de gobernos mediante un acordo aprobado. Escolla Aprobación do provedor confirmada cando Meta o aprobase para esta conta; ata entón non se poden activar códigos nin avisos nela.",
                api_base_url: "Só cando a Graph API non é a de Meta, como o punto de acceso dun provedor de solucións. Baleiro usa a de Meta.",
            },
            error: {
                REQUIRED: "Obrigatorio",
                NOT_A_COUNT: "Introduce un número enteiro",
                AT_LEAST_ONE: "Introduza 1 ou máis",
                OTP_ABOVE_TOTAL: "Non pode superar as mensaxes por segundo",
                INVALID_CALLING_CODE: "Introduce prefixos telefónicos de país de 1 a 3 díxitos, como 63",
                DUPLICATE_LANGUAGE: "Este idioma xa ten un modelo para este propósito",
                NOT_A_URL: "Introduza un enderezo que comece por https://",
                UNSUPPORTED_PROVIDER: "Provedor non compatible: substitúa esta conta",
                CREDENTIALS_FOLLOW_ENDPOINT: "Volva introducir as credenciais para o novo enderezo",
            },
            warning: {
                pageChangeCount: "Votantes conectados a {{page}} que terán que volver conectarse: {{count}}.",
                pageChangeCounting: "Contando os votantes conectados á páxina…",
                pageChangeCountError: "Non se puido ler o número de votantes conectados á páxina.",
                recheck: "Ao gardar, a conta compróbase de novo en segundo plano. Ata que esa comprobación saia ben, os códigos e avisos que pasen por ela fallan por non estar lista; a mensaxe de proba si se envía.",
                pageChange: "As conversas de Messenger pertencen a unha páxina. Tras cambiar a páxina, non se envían códigos nin avisos aos votantes conectados a {{page}} ata que volvan conectarse. O votante volve conectarse no seu seguinte inicio de sesión, despois de introducir o seu contrasinal: o inicio de sesión mostra o paso de conexión da páxina nova, o votante preme Comezar en Messenger e recibe alí o código. Un votante que non pode iniciar sesión cun contrasinal, por exemplo porque o esqueceu, necesita que o persoal lle cambie a canle.",
                numberChange: "As mensaxes chegarán desde outro número. Os seus modelos deben estar aprobados nesa conta de empresa antes de poder enviar códigos, e os votantes verán un chat novo.",
            },
            viber: {
                title: "Modelos aprobados",
                description: "Introduce os modelos que Viber aprobou a través do socio, por propósito e idioma. A API de modelos do socio non está dispoñible, así que esta lista mantense a man e a comprobación de conexión lea.",
                purpose: "Propósito",
                language: "Idioma",
                templateId: "ID do modelo do socio",
                add: "Engadir modelo",
                remove: "Quitar modelo",
            },
            limits: {
                title: "Límites de envío",
                messagesPerSecond: "Mensaxes por segundo",
                messagesPerSecondHelp: "Baleiro: as mensaxes non se limitan.",
                otpReservedPerSecond: "Reservadas para códigos por segundo",
                otpReservedHelp: "Un mínimo dentro do único orzamento de envío compartido da conta: os avisos detéñense nel e os códigos van primeiro. Se non se envían códigos, un envío masivo pode usar todo o ritmo.",
                otpConcurrency: "Códigos enviados á vez",
                otpConcurrencyHelp: "Baleiro: 8. Os códigos e os avisos de Keycloak (ligazóns de restablecemento, contrasinais temporais) ocupan cada un unha praza mentres se envían. Cóntase por proceso do servidor; os demais envíos agardan a súa quenda.",
                allowedCallingCodes: "Destinos permitidos (prefixos telefónicos de país)",
                allowedCallingCodesHelp: "Separados por comas, por exemplo 63, 971. Baleiro permite calquera destino.",
            },
            credentials: {
                title: "Credenciais",
                description: "As credenciais son só de escritura: despois de gardar, só se mostra a data en que se substituíu cada unha.",
                set: "Configurada · substituída {{date}}. Gárdase cifrada e nunca se mostra.",
                replace: "Substituír",
                replaceNamed: "Substituír {{name}}",
                reenter: "O enderezo cambiou: volva introducir esta credencial.",
            },
            credentialHelp: {
                AWS_SES: {
                    AWS_ACCESS_KEY_ID: "Opcional. Sen claves, úsase o rol propio do servizo.",
                    AWS_SECRET_ACCESS_KEY: "Opcional. Configúraa xunto co ID de clave de acceso.",
                },
                AWS_SNS: {
                    AWS_ACCESS_KEY_ID: "Opcional. Sen claves, úsase o rol propio do servizo.",
                    AWS_SECRET_ACCESS_KEY: "Opcional. Configúraa xunto co ID de clave de acceso.",
                },
                SMTP: {
                    SMTP_PASSWORD: "O contrasinal do servidor SMTP.",
                },
                WHATSAPP_CLOUD_API: {
                    ACCESS_TOKEN: "Un token dun usuario do sistema da carteira empresarial do propietario, con whatsapp_business_messaging.",
                    APP_SECRET: "Comproba que as chamadas ao webhook proceden de Meta.",
                },
                MESSENGER_SEND_API: {
                    ACCESS_TOKEN: "Un token de acceso de páxina con pages_messaging.",
                    APP_SECRET: "Comproba que as chamadas ao webhook proceden de Meta.",
                },
                VIBER_INFOBIP: {
                    API_KEY: "A clave de API de Infobip.",
                },
            },
            webhook: {
                title: "Informes de entrega",
                description: {
                    WHATSAPP_CLOUD_API: "Introduza este URL de retorno na configuración de webhooks de Meta. Os informes de entrega chegan aquí e compróbanse co segredo da aplicación.",
                    MESSENGER_SEND_API: "Introduza este URL de retorno na configuración de webhooks de Meta. Os informes de entrega e o toque do votante en Comezar chegan aquí e compróbanse co segredo da aplicación.",
                    VIBER_INFOBIP: "Infobip envía os informes de entrega de Viber a este URL de retorno mediante unha subscrición con autenticación Basic.",
                    AWS_SES: "Subscriba este URL de retorno (HTTPS) ao tema de notificacións de entrega. Os eventos de entrega e rebote chegan aquí e compróbanse coa sinatura de Amazon.",
                },
                afterSaving: "Móstrase despois de gardar",
                tokenSet: "Configurado · substituído {{date}}",
                tokenMissing: "Aínda non xerado",
                tokenAfterSaving: "Xérase despois de gardar",
                generate: "Xerar token de verificación",
                tokenTitle: "Token de verificación",
                tokenOnce: "Introduce agora este token na configuración de webhooks de Meta. Só se mostra unha vez.",
                copyToken: "Copiar token de verificación",
                tokenDone: "Feito",
                tokenError: "Non se puido xerar o token de verificación.",
                url: "URL de retorno",
                copyUrl: "Copiar o URL de retorno",
                needsWrite: "Móstrase aos administradores que poden xestionar contas de mensaxería.",
                loading: "Cargando…",
                unavailable: "Non dispoñible",
                loadError: "Non se puido cargar o URL de retorno.",
            },
            copy: {
                success: "Copiado",
                error: "Non se puido copiar",
            },
            save: {
                success: "Conta gardada",
                error: "Non se puido gardar a conta.",
                refused: "Non se gardou a conta: {{reason}}",
            },
            test: {
                title: "Enviar unha mensaxe de proba desde {{name}}",
                description: "Envía unha mensaxe real para o propósito escollido a este destino. O resultado mostra o que informou o provedor.",
                purpose: "Propósito",
                destination: {
                    EMAIL_ADDRESS: "Correo electrónico",
                    PHONE_NUMBER: "Número de teléfono (E.164)",
                    PAGE_SCOPED_ID: "ID de ámbito de páxina",
                },
                language: "Idioma",
                send: "Enviar mensaxe de proba",
                reason: "Motivo: {{reason}}",
                error: "Non se puido enviar a mensaxe de proba.",
                template: "Modelo aprobado",
                templateHelp: "O nome ou ID do modelo que o provedor aprobou para este propósito e idioma.",
                viberTemplate: "Viber usa o modelo que esta conta indica como aprobado para o propósito e o idioma escollidos.",
                languageHelp: "Para un provedor que envía modelos aprobados, introduza o código de idioma do provedor para o modelo, como en_US.",
            },
            unsupported: "Provedor non compatible: substitúa esta conta. O seu provedor xa non é compatible, así que non pode enviar. Engada unha conta para esta canle cun provedor compatible, escóllaa nos eventos electorais que usan esta e despois elimine esta conta.",
            reports: {
                label: "Credenciais de informes",
                missing: "Aínda non xeradas",
                generate: "Xerar credenciais de informes",
                title: "Credenciais de informes",
                once: "Introdúzaas agora na subscrición de Infobip. Só se mostran unha vez; xerar outras novas substitúeas.",
                copyUsername: "Copiar o usuario de informes",
                copyPassword: "Copiar o contrasinal de informes",
                error: "Non se puideron xerar as credenciais de informes.",
                step: {
                    subscription: "En Infobip, cree unha subscrición para os informes de entrega de Viber.",
                    url: "Poña como URL o URL de retorno desta conta.",
                    auth: "Escolla a autenticación Basic e introduza o usuario e o contrasinal de informes.",
                },
                confirmTitle: "Substituír as credenciais de informes?",
                confirmBody: "O usuario e o contrasinal de informes actuais deixan de funcionar de inmediato. Ata que a subscrición de Infobip teña os novos, os informes de entrega de Viber rexéitanse e as mensaxes quedan en Aceptado.",
                confirm: "Substituír",
            },
        },
        sentMessages: {
            showMore: "Mostrar máis",
            showLess: "Mostrar menos",
            tab: "Mensaxes enviadas",
            accountsTab: "Contas",
            tabsLabel: "Seccións de mensaxería",
            description: "Mensaxes que recibiu o provedor de demostración deste contorno de desenvolvemento, tal como as amosarían as aplicacións dos votantes. Ningunha chegou a un votante real. Esta lapela só aparece onde as rutas do provedor de demostración están activadas.",
            modeLabel: "Amosar mensaxes de",
            all: "Todas",
            refresh: "Actualizar",
            refreshing: "Actualizando…",
            refreshError: "Non se puideron actualizar as mensaxes. A lista amosada é a última que se leu.",
            empty: "Aínda non hai mensaxes.",
            emptyChannel: "Aínda non hai mensaxes de {{channel}}.",
            column: {
                time: "Hora",
                channel: "Canle",
                from: "De",
                to: "Para",
                message: "Mensaxe",
                report: "Informe de entrega",
            },
            report: {
                accepted: "Informe aceptado polo compoñente de webhooks (HTTP 200)",
                refused: "Informe rexeitado: HTTP {{status}}",
                pending: "Informe aínda non enviado",
                notSent: "Informe non enviado: {{reason}}",
                noAnswer: "O informe non obtivo resposta: {{reason}}",
                noReason: "sen motivo indicado",
                unavailable: "Esta canle non ten informes de entrega",
            },
            content: {
                demoCode: "{{code}} é o seu código de verificación. Pola súa seguridade, non o comparta con ninguén.",
                demoNotice: "Recordatorio de votación\n\nOla {{name}}, a votación de {{event}} xa está aberta.\n\nAcceda ao portal de votación para revisar a súa papeleta e emitir o seu voto:\n{{url}}\n\nNon comparta o seu código de acceso con ninguén. Se xa votou, non precisa facer nada máis.",
                demoLegacyNotice: "Recordatorio de votación\n\nOla {{name}}, a votación xa está aberta. Acceda ao portal de votación para emitir o seu voto:\n{{url}}\n\nNon comparta o seu código de acceso con ninguén.",
                template: "Modelo {{name}} ({{language}})",
                noText: "(sen texto)",
                code: "Código",
                copyCode: "Copiar o código",
                copied: "Código copiado",
                copyFailed: "Non se puido copiar o código",
                truncated: "Recortado: o provedor de demostración só conserva os primeiros 64 KiB de cada campo.",
            },
            chat: {
                phone: "{{channel}} nun teléfono",
                chats: "Chats de {{channel}}",
                open: "Abrir o chat con {{recipient}} desde {{sender}}",
                back: "Volver aos chats",
                from: "De {{sender}}",
                messages: "Mensaxes para {{recipient}}",
            },
            getStarted: {
                title: "Comezar",
                help: "Pegue a ligazón de Messenger que amosa a páxina de inscrición e prema Comezar, como faría o votante en Messenger. Despois, o código chega ao chat.",
                link: "Ligazón de Messenger",
                submit: "Comezar",
                accepted: "O compoñente de webhooks respondeu 200. O código chega ao chat.",
                answered: "O compoñente de webhooks respondeu {{status}}.",
                failed: "Non se puido comezar: {{reason}}",
            },
            email: {
                inbox: "Caixa de entrada",
                reading: "Correo seleccionado",
                noSubject: "(sen asunto)",
                from: "De",
                to: "Para",
                view: "Amosar o correo como",
                html: "HTML",
                text: "Texto simple",
                htmlFrame: "Contido do correo",
                noContent: "Este correo non ten contido.",
                loading: "Cargando o correo…",
                loadError: "Non se puido ler o HTML do correo: pode que o provedor de demostración xa non o conserve.",
            },
            reason: {
                SEVERAL_ACCOUNTS: "Varias contas usan este remitente",
                ACCOUNTS_UNREADABLE: "Non se puideron ler as contas",
                UNREACHABLE: "O compoñente de webhooks non respondeu",
                LINK_UNREADABLE: "Pegue a ligazón m.me da páxina de inscrición",
                LINK_WITHOUT_REF: "A ligazón non ten ref: copie a ligazón completa",
                NO_PAGE_ACCOUNT: "Ningunha conta de Messenger desta organización usa esta páxina",
                SEVERAL_PAGE_ACCOUNTS: "Varias contas de Messenger desta organización usan esta páxina",
            },
        },
        electoralLogConsole: {
            title: "Rexistro Electoral",
            subtitle: "Explore o rexistro electoral e a urna dun evento electoral, ou consulte a súa base de datos do rexistro electoral. Nada nesta páxina modifica datos.",
            notAllowed: "Precisa o permiso electoral-log-console-read para abrir o rexistro electoral.",
            tabs: {
                tables: "Táboas",
                query: "Consulta",
            },
            electionEvent: "Evento Electoral",
            tenant: "Inquilino",
            table: "Táboa",
            tables: {
                records: "Entradas",
                ballots: "Papeletas",
                voters: "Votantes",
                queue: "Cola do Secuenciador",
            },
            order: {
                "label": "Orde",
                "newest-first": "Máis recentes primeiro",
                "oldest-first": "Máis antigos primeiro",
            },
            filters: {
                statement_kind: "Tipo",
                election_id: "Elección",
                area_id: "ID de Área",
                user_id: "ID de Usuario ou Votante",
                ballot_id: "ID de Papeleta",
                status: "Estado",
                created_after: "Desde",
                created_before: "Ata",
                any: "Calquera",
                apply: "Aplicar Filtros",
                clear: "Limpar",
                invalid: "Revise os filtros marcados: as datas deben ser válidas e os ID de área da urna deben ser UUID.",
            },
            statuses: {
                valid: "Válida",
                pending: "Pendente",
                rejected: "Rexeitada",
            },
            estimatedRows: "Unhas {{rows}} filas nesta táboa antes de filtrar.",
            personalDataHidden: "Os nomes de usuario, os enderezos IP e os países aparecen ocultos: velos require o permiso electoral-log-personal-data-read.",
            loadError: "Non se puido ler o rexistro electoral.",
            record: {
                title: "Entrada {{position}}",
                view: "Ver entrada",
                message: "Mensaxe (descodificada)",
                copy: "Copiar JSON",
                close: "Pechar",
                loadError: "Non se puido ler a entrada.",
            },
            query: {
                help: "As consultas execútanse sobre a base de datos do rexistro electoral do evento electoral nunha transacción de só lectura. As súas táboas son electoral_log_messages, ballot_box_ballot, ballot_box_voter, ballot_box_pending e ballot_box_sequencer; trellis_logs describe os seus rexistros Merkle.",
                scope: "Cada evento electoral ten a súa propia base de datos, así que unha consulta le un só evento.",
                chooseEvent: "Escolla o evento electoral que consultar.",
                placeholder: "SELECT …",
                limits: "Só lectura · ata 1.000 filas · límite de 30 s · cada consulta queda anotada nos rexistros do servidor co seu usuario",
                run: "Executar Consulta",
                summary: "Filas: {{rows}} · {{ms}} ms",
                truncated: "Só se amosan as primeiras {{rows}} filas.",
                error: "Non se puido executar a consulta.",
            },
        },
        taskQueues: {
            title: "Colas de Tarefas",
            subtitle: "As colas de tarefas do contorno: que está agardando, que se procesou e canto tardou. As listas das colas nunca mostran os argumentos das tarefas.",
            notAllowed: "Precisa o permiso task-queues-read do tenant de superadministración para abrir as colas de tarefas.",
            live: "En directo",
            updated: "Actualizado ás {{time}}",
            error: "Non se puideron cargar as colas de tarefas.",
            columns: {
                queue: "Cola",
                ready: "Listas",
                runningOrScheduled: "En curso ou programadas",
                oldest: "Máis antiga",
                processed: "Procesadas (última hora)",
                lastHour: "Resultados (última hora)",
                sent: "Enviadas (total)",
            },
            outcomes: {
                succeeded: "Correctas",
                failed: "Fallidas",
                expired: "Caducadas",
                rejected: "Rexeitadas",
                discarded: "Descartadas",
                unknown: "Descoñecido",
            },
            graphs: {
                title: "Rendemento",
                period: "Período",
                periods: {
                    hour: "Última hora",
                    sixHours: "Últimas 6 horas",
                    day: "Últimas 24 horas",
                    week: "Últimos 7 días",
                },
                outcomes: "Mensaxes procesadas por resultado",
                durations: "Tempo medio de espera e de proceso",
                wait: "Espera",
                processing: "Proceso",
                seconds: "Segundos",
                empty: "Non se procesou ningunha mensaxe desta cola neste período.",
            },
            messages: {
                title: "Mensaxes",
                states: {
                    queued: "En cola",
                    archived: "Arquivadas",
                },
                argumentsHidden: "Os argumentos das tarefas nunca se mostran, porque poden conter datos de votantes.",
                refresh: "Actualizar",
                newest: "Máis recentes",
                newer: "Máis novas",
                older: "Máis antigas",
                empty: "Non hai mensaxes",
                unreadable: "Mensaxe ilexible",
                columns: {
                    id: "ID",
                    task: "Tarefa",
                    outcome: "Resultado",
                    event: "Evento",
                    error: "Erro",
                    enqueued: "Engadida á cola",
                    reads: "Lecturas",
                    retries: "Reintentos",
                    archived: "Arquivada",
                    visible: "Visible desde",
                    size: "Tamaño",
                    taskId: "ID da tarefa",
                },
            },
            deadLetters: {
                help: "Estes eventos do rexistro electoral non se puideron procesar. Seleccione eventos para reenvialos á cola de eventos ou para descartalos; os eventos descartados quedan no arquivo.",
                noWrite: "Precisa o permiso task-queues-write para reenviar ou descartar estes eventos.",
                replay: "Reenviar",
                discard: "Descartar",
                cancel: "Cancelar",
                confirmTitle: {
                    replay: "Reenviar os eventos?",
                    discard: "Descartar os eventos?",
                },
                confirmBody: {
                    replay_one: "Reenviarase {{count}} evento á cola de eventos do rexistro electoral. Se volve fallar, regresará aquí.",
                    replay_many: "Reenviaranse {{count}} eventos á cola de eventos do rexistro electoral. Os eventos que volvan fallar regresarán aquí.",
                    replay_other: "Reenviaranse {{count}} eventos á cola de eventos do rexistro electoral. Os eventos que volvan fallar regresarán aquí.",
                    discard_one: "Moverase {{count}} evento ao arquivo e non se engadirá ao rexistro electoral.",
                    discard_many: "Moveranse {{count}} eventos ao arquivo e non se engadirán ao rexistro electoral.",
                    discard_other: "Moveranse {{count}} eventos ao arquivo e non se engadirán ao rexistro electoral.",
                },
                queued: {
                    replay_one: "Reenvío de {{count}} evento engadido á cola como tarefa {{taskId}}.",
                    replay_many: "Reenvío de {{count}} eventos engadido á cola como tarefa {{taskId}}.",
                    replay_other: "Reenvío de {{count}} eventos engadido á cola como tarefa {{taskId}}.",
                    discard_one: "Descarte de {{count}} evento engadido á cola como tarefa {{taskId}}.",
                    discard_many: "Descarte de {{count}} eventos engadido á cola como tarefa {{taskId}}.",
                    discard_other: "Descarte de {{count}} eventos engadido á cola como tarefa {{taskId}}.",
                },
                failed: "Non se puido engadir a operación á cola.",
            },
            tabs: {
                queues: "Colas",
                query: "Consulta",
            },
            query: {
                help: "As consultas execútanse sobre a base de datos de colas de tarefas do contorno nunha transacción de só lectura, co seu rol de lectura. Cada cola ten unha táboa de mensaxes en espera, pgmq.q_<cola>, e outra de mensaxes procesadas, pgmq.a_<cola>.",
                arguments: "As consultas len as mensaxes tal como están gardadas, cos argumentos das súas tarefas, que poden incluír datos de votantes.",
                placeholder: "SELECT …",
                limits: "Só lectura · ata 1.000 filas · límite de 30 s · cada consulta queda anotada nos rexistros do servidor co seu usuario",
                run: "Executar Consulta",
                summary: "Filas: {{rows}} · {{ms}} ms",
                truncated: "Só se amosan as primeiras {{rows}} filas.",
                error: "Non se puido executar a consulta.",
            },
        },
    },
};
export default galegoTranslation;
